import { selectionCopyShow, selectIsOverlap } from "./select";
import { luckyColor, iconfontObjects } from "./constant";
import luckysheetConfigsetting from "./luckysheetConfigsetting";
import luckysheetMoreFormat from "./moreFormat";
import alternateformat from "./alternateformat";
import conditionformat from "./conditionformat";
import server from "./server";
import { luckysheet_searcharray } from "./sheetSearch";
import luckysheetFreezen from "./freezen";
import luckysheetsizeauto from "./resize";
import { createFilter } from "./filter";
import luckysheetSearchReplace from "./searchReplace";
import luckysheetLocationCell from "./locationCell";
import ifFormulaGenerator from "./ifFormulaGenerator";
import { luckysheetupdateCell } from "./updateCell";
import insertFormula from "./insertFormula";
import sheetmanage from "./sheetmanage";
import luckysheetPostil from "./postil";
import { isRealNum, isRealNull, isEditMode, hasPartMC, checkIsAllowEdit } from "../global/validate";
import tooltip from "../global/tooltip";
import editor from "../global/editor";
import { genarate, update, is_date } from "../global/format";
import { jfrefreshgrid, luckysheetrefreshgrid } from "../global/refresh";
import { sortSelection } from "../global/sort";
import luckysheetformula from "../global/formula";
import { rowLocationByIndex, colLocationByIndex } from "../global/location";
import { isdatatypemulti } from "../global/datecontroll";
import { rowlenByRange, getCellTextSplitArr } from "../global/getRowlen";
import { setcellvalue } from "../global/setdata";
import { getFontStyleByCell, checkstatusByCell } from "../global/getdata";
import { countfunc } from "../global/count";
import { hideMenuByCancel } from "../global/cursorPos";
import { getSheetIndex, getRangetxt, getluckysheetfile } from "../methods/get";
import { setluckysheetfile } from "../methods/set";
import {
    isInlineStringCell,
    isInlineStringCT,
    updateInlineStringFormat,
    convertCssToStyleList,
    inlineStyleAffectAttribute,
    updateInlineStringFormatOutside,
} from "./inlineString";
import {
    replaceHtml,
    getObjType,
    rgbTohex,
    mouseclickposition,
    luckysheetfontformat,
    luckysheetContainerFocus,
} from "../utils/util";
import { openProtectionModal, checkProtectionFormatCells, checkProtectionNotEnable } from "./protection";
import { checkTheStatusOfTheSelectedCells, frozenFirstRow, frozenFirstColumn } from "../global/api";
import { createLuckyChart, redrawAllIC50EC50Chart } from "../expendPlugins/chart/plugin";
import sequenceImportDialog from "./sequenceImportDialog"; // 序列操作相关处理 --modify by wangxiaofei 2023.8.18
import calculateORFDialog from "./calculateORFDialog";
import dnaAnalysisUtils from "./dnaAnalysisUtils";
import sequenceLookup from "./sequenceLookup"; // 序列查找操作相关处理 --modify by wangxiaofei 2023.8.28
import crisprDesign from "./crisprDesign"; // CRISPR设计操作相关处理 --modify by wangxiaofei 2023.8.30
import primerDesign from "./primerDesign"; // 引物设计操作相关处理 --modify by wangxiaofei 2023.8.30
import proteinAnalysis from "./proteinAnalysis"; // 蛋白质分析操作相关处理 --modify by wangxiaofei 2023.9.5
import {colorPalette} from './common/commonJson'; // 公共常用变量

const menuButton = {
    menu:
        '<div class="luckysheet-cols-menu '+'luckysheet-rightgclick-menu luckysheet-menuButton ${subclass} luckysheet-mousedown-cancel" id="luckysheet-icon-${id}-menuButton">${item}</div>',
    // "item": '<div itemvalue="${value}" itemname="${name}" class="luckysheet-cols-menuitem ${sub} luckysheet-mousedown-cancel"><div class="luckysheet-cols-menuitem-content luckysheet-mousedown-cancel" style="padding: 3px 0px 3px 1px;"><span style="margin-right:3px;width:13px;display:inline-block;" class="icon luckysheet-mousedown-cancel"></span> ${name} <span class="luckysheet-submenu-arrow luckysheet-mousedown-cancel" style="user-select: none;">${example}</span></div></div>',
    item:
        '<div itemvalue="${value}" itemname="${name}" class="luckysheet-cols-menuitem ${sub} luckysheet-mousedown-cancel"><div class="luckysheet-cols-menuitem-content luckysheet-mousedown-cancel" style="padding: 3px 0px 3px 1px;"><span style="margin-right:3px;width:13px;display:inline-block;" class="icon luckysheet-mousedown-cancel"></span> ${name} <span class="luckysheet-submenu-arrow luckysheet-mousedown-cancel ${iconClass}" style="user-select: none;">${example}</span></div></div>',
    split: '<div class="luckysheet-menuseparator luckysheet-mousedown-cancel" role="separator"></div>',
    color:
        '<div class="luckysheet-cols-menu '+'luckysheet-rightgclick-menu luckysheet-rightgclick-menu-sub luckysheet-mousedown-cancel luckysheet-menuButton ${sub}" id="${id}"><div class="luckysheet-cols-menuitem luckysheet-mousedown-cancel luckysheet-color-reset"><div class="luckysheet-cols-menuitem-content luckysheet-mousedown-cancel">${resetColor}</div></div> <div class="luckysheet-mousedown-cancel"> <div class="luckysheet-mousedown-cancel"> <input type="text" class="luckysheet-color-selected" /> </div> </div> <div class="luckysheet-menuseparator luckysheet-mousedown-cancel" role="separator"></div> ${coloritem}</div>',
    coloritem:
        '<div class="luckysheet-cols-menuitem luckysheet-mousedown-cancel ${class}"><div class="luckysheet-cols-menuitem-content luckysheet-mousedown-cancel">${name}</div></div>',
    subcolor:
        '<div id="luckysheet-icon-${id}-menuButton" class="luckysheet-cols-menu '+'luckysheet-rightgclick-menu luckysheet-rightgclick-menu-sub luckysheet-menuButton-sub luckysheet-mousedown-cancel"> <div class="luckysheet-mousedown-cancel"> <div class="luckysheet-mousedown-cancel"> <input type="text" class="luckysheet-color-selected" /> </div> </div></div>',
    rightclickmenu: null,
    submenuhide: {},
    focus: function ($obj, value) {
        const instance = this.instance;
        if ($obj.attr("id") == `luckysheet-icon-font-family-menuButton`) {
            if (isdatatypemulti(value)["num"]) {
                let _locale = instance.locale();
                const locale_fontarray = _locale.fontarray;
                value = locale_fontarray[parseInt(value)];
                if (value == null) {
                    value = this.defualtFont[itemvalue];
                }
            }
        }
        $obj.find(".luckysheet-cols-menuitem")
            .find("span.icon")
            .html("");
        if (value == null) {
            $obj.find(".luckysheet-cols-menuitem")
                .eq(0)
                .find("span.icon")
                .html('<i class="fa fa-check luckysheet-mousedown-cancel"></i>');
        } else {
            $obj.find(".luckysheet-cols-menuitem[itemvalue='" + value + "']")
                .find("span.icon")
                .html('<i class="fa fa-check luckysheet-mousedown-cancel"></i>');
        }
    },
    createButtonMenu: function (itemdata) {
        let itemset = "";
        let _this = this;

        for (let i = 0; i < itemdata.length; i++) {
            let item = itemdata[i];

            if (item.value == "split") {
                itemset += _this.split;
            } else {
                if (item.example == "more") {
                    // itemset += replaceHtml(_this.item, {"value": item.value, "name": item.text, "example": "►", "sub": "luckysheet-cols-submenu"});
                    itemset += replaceHtml(_this.item, {
                        value: item.value,
                        name: item.text,
                        example: "",
                        sub: "luckysheet-cols-submenu",
                        iconClass: "iconfont luckysheet-iconfont-youjiantou",
                    });
                } else {
                    itemset += replaceHtml(_this.item, {
                        value: item.value,
                        name: item.text,
                        example: item.example,
                        sub: "",
                        iconClass: "",
                    });
                }
            }
        }

        return itemset;
    },
    cancelPaintModel: function (container) {
        let _this = this;
        const instance = this.instance;
        const containerId = instance.getInstanceId();
        let Store = instance.getStore();
        let currentInstance = $(`#${containerId}`);

        currentInstance.find("#luckysheet-sheettable_0").removeClass("luckysheetPaintCursor");

        if (Store.luckysheet_copy_save["dataSheetIndex"] == Store.currentSheetIndex) {
            Store.luckysheet_selection_range = [];
            instance.select.selectionCopyShow();
        } else {
            Store.luckysheetfile[
                instance.get.getSheetIndex(Store.luckysheet_copy_save["dataSheetIndex"])
            ].luckysheet_selection_range = [];
        }

        Store.luckysheet_copy_save = {};

        _this.luckysheetPaintModelOn = false;
        currentInstance.find("#luckysheetpopover").fadeOut(200, function () {
            currentInstance.find("#luckysheetpopover").remove();
        });
    },
    luckysheetPaintModelOn: false,
    luckysheetPaintSingle: false,
    initialMenuButton: function (container) {
        let _this = this;
        const instance = this.instance;
        const containerId = instance.getInstanceId();
        let Store = instance.getStore();
        let currentInstance = $(`#${containerId}`);
        const luckysheetConfigsetting = instance.luckysheetConfigsetting;
        _this.initFormulaButton(); // 初始化生物计算相关方法

        //格式刷
        currentInstance.find("#luckysheet-icon-paintformat").click(function(e) {
        // $(document).off(`click.paintformat-${containerId}`).on(`click.paintformat-${containerId}`, `#${containerId} #luckysheet-icon-paintformat`, function(e) {
            // *如果禁止前台编辑，则中止下一步操作
            if (!instance.validate.checkIsAllowEdit()) {
                // instance.tooltip.info("", instance.locale().pivotTable.errorNotAllowEdit);
                return;
            }
            e.stopPropagation();
            let _locale = instance.locale();
            let locale_paint = _locale.paint;

            if (Store.luckysheet_select_save == null || Store.luckysheet_select_save.length == 0) {
                if (instance.validate.isEditMode()) {
                    alert(locale_paint.tipSelectRange);
                } else {
                    instance.tooltip.info("", locale_paint.tipSelectRange);
                }
                return;
            } else if (Store.luckysheet_select_save.length > 1) {
                if (instance.validate.isEditMode()) {
                    alert(locale_paint.tipNotMulti);
                } else {
                    instance.tooltip.info("", locale_paint.tipNotMulti);
                }
                return;
            }

            // *增加了对选区范围是否为部分合并单元格的校验，如果为部分合并单元格，就阻止格式刷的下一步
            // TODO 这里也可以改为：判断到是合并单元格的一部分后，格式刷执行黏贴格式后删除范围单元格的 mc 值

            let has_PartMC = false;

            let r1 = Store.luckysheet_select_save[0].row[0],
                r2 = Store.luckysheet_select_save[0].row[1];

            let c1 = Store.luckysheet_select_save[0].column[0],
                c2 = Store.luckysheet_select_save[0].column[1];

            has_PartMC = instance.validate.hasPartMC(Store.config, r1, r2, c1, c2);

            if (has_PartMC) {
                // *提示后中止下一步
                instance.tooltip.info(_locale.merge.partiallyError, "");
                return;
            }

            instance.tooltip.popover(
                "<i class='fa fa-paint-brush'></i> " + locale_paint.start + "",
                "topCenter",
                true,
                null,
                locale_paint.end,
                function () {
                    _this.cancelPaintModel();
                },
            );

            currentInstance.find("#luckysheet-sheettable_0").addClass("luckysheetPaintCursor");

            Store.luckysheet_selection_range = [
                { row: Store.luckysheet_select_save[0].row, column: Store.luckysheet_select_save[0].column },
            ];

            instance.select.selectionCopyShow();

            let RowlChange = false,
                HasMC = false;

            for (let r = Store.luckysheet_select_save[0].row[0]; r <= Store.luckysheet_select_save[0].row[1]; r++) {
                if (Store.config["rowhidden"] != null && Store.config["rowhidden"][r] != null) {
                    continue;
                }

                if (Store.config["rowlen"] != null && r in Store.config["rowlen"]) {
                    RowlChange = true;
                }

                for (
                    let c = Store.luckysheet_select_save[0].column[0];
                    c <= Store.luckysheet_select_save[0].column[1];
                    c++
                ) {
                    let cell = Store.flowdata[r][c];

                    if (getObjType(cell) == "object" && "mc" in cell && cell.mc.rs != null) {
                        HasMC = true;
                    }
                }
            }
            Store.luckysheet_copy_save = {
                dataSheetIndex: Store.currentSheetIndex,
                copyRange: [
                    { row: Store.luckysheet_select_save[0].row, column: Store.luckysheet_select_save[0].column },
                ],
                RowlChange: RowlChange,
                HasMC: HasMC,
            };

            _this.luckysheetPaintModelOn = true;
            _this.luckysheetPaintSingle = true;
        });
        currentInstance.find("#luckysheet-icon-paintformat").dblclick(function() {
        // $(document).off(`dblclick.dblpaintformat-${containerId}`).on(`dblclick.dblpaintformat-${containerId}`, `#${containerId} #luckysheet-icon-paintformat`, function() {
            // *如果禁止前台编辑，则中止下一步操作
            if (!instance.validate.checkIsAllowEdit()) {
                instance.tooltip.info("", instance.locale().pivotTable.errorNotAllowEdit);
                return;
            }
            let _locale = instance.locale();
            let locale_paint = _locale.paint;
            if (Store.luckysheet_select_save == null || Store.luckysheet_select_save.length == 0) {
                if (instance.validate.isEditMode()) {
                    alert(locale_paint.tipSelectRange);
                } else {
                    instance.tooltip.info("", locale_paint.tipSelectRange);
                }
                return;
            } else if (Store.luckysheet_select_save.length > 1) {
                if (instance.validate.isEditMode()) {
                    alert(locale_paint.tipNotMulti);
                } else {
                    instance.tooltip.info("", locale_paint.tipNotMulti);
                }
                return;
            }

            instance.tooltip.popover(
                "<i class='fa fa-paint-brush'></i> " + locale_paint.start,
                "topCenter",
                true,
                null,
                locale_paint.end,
                function () {
                    _this.cancelPaintModel();
                },
            );
            currentInstance.find("#luckysheet-sheettable_0").addClass("luckysheetPaintCursor");

            Store.luckysheet_selection_range = [
                { row: Store.luckysheet_select_save[0].row, column: Store.luckysheet_select_save[0].column },
            ];
            instance.select.selectionCopyShow();

            let RowlChange = false,
                HasMC = false;
            for (let r = Store.luckysheet_select_save[0].row[0]; r <= Store.luckysheet_select_save[0].row[1]; r++) {
                if (Store.config["rowhidden"] != null && Store.config["rowhidden"][r] != null) {
                    continue;
                }

                if (Store.config["rowlen"] != null && r in Store.config["rowlen"]) {
                    RowlChange = true;
                }

                for (
                    let c = Store.luckysheet_select_save[0].column[0];
                    c <= Store.luckysheet_select_save[0].column[1];
                    c++
                ) {
                    let cell = Store.flowdata[r][c];

                    if (getObjType(cell) == "object" && "mc" in cell && cell.mc.rs != null) {
                        HasMC = true;
                    }
                }
            }
            Store.luckysheet_copy_save = {
                dataSheetIndex: Store.currentSheetIndex,
                copyRange: [
                    { row: Store.luckysheet_select_save[0].row, column: Store.luckysheet_select_save[0].column },
                ],
                RowlChange: RowlChange,
                HasMC: HasMC,
            };

            _this.luckysheetPaintModelOn = true;
            _this.luckysheetPaintSingle = false;
        });

        //货币格式
        currentInstance.find("#luckysheet-icon-currency").click(function() {
        // $(document).off(`click.currency-${containerId}`).on(`click.currency-${containerId}`, `#${containerId} #luckysheet-icon-currency`, function() {
            let d = instance.editor.deepCopyFlowData(Store.flowdata); //取数据

            _this.updateFormat(containerId, d, "ct", "¥ #.00");
        });

        //百分比
        currentInstance.find("#luckysheet-icon-percent").click(function() {
        // $(document).off(`click.percent-${containerId}`).on(`click.percent-${containerId}`, `#${containerId} #luckysheet-icon-percent`, function() {
            let d = instance.editor.deepCopyFlowData(Store.flowdata); //取数据

            _this.updateFormat(containerId, d, "ct", "0.00%");
        });

        //减少小数位数
        currentInstance.find("#luckysheet-icon-fmt-decimal-decrease").click(function() {
        // $(document).off(`click.decimal-decrease-${containerId}`).on(`click.decimal-decrease-${containerId}`, `#${containerId} #luckysheet-icon-fmt-decimal-decrease`, function() {
            let d = instance.editor.deepCopyFlowData(Store.flowdata); //取数据
            let row_index = Store.luckysheet_select_save[0]["row_focus"],
                col_index = Store.luckysheet_select_save[0]["column_focus"];
            let foucsStatus = _this.checkstatus(d, row_index, col_index, "ct");
            let cell = d[row_index][col_index];

            if (foucsStatus == null || foucsStatus.t != "n") {
                return;
            }

            if (foucsStatus.fa == "General") {
                let mask = genarate(cell.v);
                foucsStatus = mask[1];
            }

            //万亿格式
            let reg = /^(w|W)((0?)|(0\.0+))$/;
            if (reg.test(foucsStatus.fa)) {
                if (foucsStatus.fa.indexOf(".") > -1) {
                    if (foucsStatus.fa.substr(-2) == ".0") {
                        _this.updateFormat(containerId, d, "ct", foucsStatus.fa.split(".")[0]);
                    } else {
                        _this.updateFormat(containerId, d, "ct", foucsStatus.fa.substr(0, foucsStatus.fa.length - 1));
                    }
                } else {
                    _this.updateFormat(containerId, d, "ct", foucsStatus.fa);
                }

                return;
            }
            //Uncaught ReferenceError: Cannot access 'fa' before initialization
            let prefix = "",
                main = "",
                fa = [];
            if (foucsStatus.fa.indexOf(".") > -1) {
                fa = foucsStatus.fa.split(".");
                prefix = fa[0];
                main = fa[1];
            } else {
                return;
            }

            fa = main.split("");
            let tail = "";
            for (let i = fa.length - 1; i >= 0; i--) {
                let c = fa[i];
                if (c != "#" && c != "0" && c != "," && isNaN(parseInt(c))) {
                    tail = c + tail;
                } else {
                    break;
                }
            }

            let fmt = "";
            if (foucsStatus.fa.indexOf(".") > -1) {
                let suffix = main;
                if (tail.length > 0) {
                    suffix = main.replace(tail, "");
                }

                let pos = suffix.replace(/#/g, "0");
                pos = pos.substr(0, pos.length - 1);
                if (pos == "") {
                    fmt = prefix + tail;
                } else {
                    fmt = prefix + "." + pos + tail;
                }
            }

            _this.updateFormat(containerId, d, "ct", fmt);
        });

        //增加小数位数
        currentInstance.find("#luckysheet-icon-fmt-decimal-increase").click(function() {
        // $(document).off(`click.decimal-increase-${containerId}`).on(`click.decimal-increase-${containerId}`, `#${containerId} #luckysheet-icon-fmt-decimal-increase`, function() {
            let d = instance.editor.deepCopyFlowData(Store.flowdata); //取数据
            let row_index = Store.luckysheet_select_save[0]["row_focus"],
                col_index = Store.luckysheet_select_save[0]["column_focus"];
            let foucsStatus = _this.checkstatus(d, row_index, col_index, "ct");
            let cell = d[row_index][col_index];

            if (foucsStatus == null || foucsStatus.t != "n") {
                return;
            }

            if (foucsStatus.fa == "General") {
                let mask = genarate(cell.v);
                foucsStatus = mask[1];
            }

            if (foucsStatus.fa == "General") {
                _this.updateFormat(containerId, d, "ct", "#.0");
                return;
            }

            //万亿格式
            let reg = /^(w|W)((0?)|(0\.0+))$/;
            if (reg.test(foucsStatus.fa)) {
                if (foucsStatus.fa.indexOf(".") > -1) {
                    _this.updateFormat(containerId, d, "ct", foucsStatus.fa + "0");
                } else {
                    if (foucsStatus.fa.substr(-1) == "0") {
                        _this.updateFormat(containerId, d, "ct", foucsStatus.fa + ".0");
                    } else {
                        _this.updateFormat(containerId, d, "ct", foucsStatus.fa + "0.0");
                    }
                }

                return;
            }

            //Uncaught ReferenceError: Cannot access 'fa' before initialization
            let prefix = "",
                main = "",
                fa = [];

            if (foucsStatus.fa.indexOf(".") > -1) {
                fa = foucsStatus.fa.split(".");
                prefix = fa[0];
                main = fa[1];
            } else {
                main = foucsStatus.fa;
            }

            fa = main.split("");
            let tail = "";
            for (let i = fa.length - 1; i >= 0; i--) {
                let c = fa[i];
                if (c != "#" && c != "0" && c != "," && isNaN(parseInt(c))) {
                    tail = c + tail;
                } else {
                    break;
                }
            }

            let fmt = "";
            if (foucsStatus.fa.indexOf(".") > -1) {
                let suffix = main;
                if (tail.length > 0) {
                    suffix = main.replace(tail, "");
                }

                let pos = suffix.replace(/#/g, "0");
                pos += "0";
                fmt = prefix + "." + pos + tail;
            } else {
                if (tail.length > 0) {
                    fmt = main.replace(tail, "") + ".0" + tail;
                } else {
                    fmt = main + ".0" + tail;
                }
            }

            _this.updateFormat(containerId, d, "ct", fmt);
        });

        //更多格式
        currentInstance.find("#luckysheet-icon-fmt-other").click(function() {
        // $(document).off(`click.fmt-other-${containerId}`).on(`click.fmt-other-${containerId}`, `#${containerId} #luckysheet-icon-fmt-other`, function() {
            const _locale = instance.locale();
            const locale_format = _locale.format;
            const locale_defaultFmt = _locale.defaultFmt;

            let menuButtonId = $(this).attr("id") + "-menuButton";
            let $menuButton = $(`#${containerId} #${menuButtonId}`);

            if ($menuButton.length == 0) {
                let itemdata = locale_defaultFmt;

                let itemset = _this.createButtonMenu(itemdata);

                // luckysheet-menuButton-sub
                let menu = replaceHtml(_this.menu, { id: "fmt-other", item: itemset, subclass: "", sub: "", });

                let subitemdata = [
                    { text: locale_format.moreCurrency + "...", value: "morecurrency", example: "" },
                    { text: locale_format.moreDateTime + "...", value: "moredatetime", example: "" },
                    { text: locale_format.moreNumber + "...", value: "moredigit", example: "" },
                ];
                let subitemset = _this.createButtonMenu(subitemdata);
                let submenu = replaceHtml(_this.menu, {
                    id: "fmtOtherSelf",
                    item: subitemset,
                    subclass: "luckysheet-menuButton-sub luckysheet-icon-fmtOtherSelf-menuButton",
                   
                });

                //luckysheet-icon-fmt-other-menuButton_sub
                $(`#${containerId}`).append(menu + submenu);
                $menuButton = currentInstance.find("#" + menuButtonId).width(250);
                _this.focus($menuButton);

                $menuButton.find(".luckysheet-cols-menuitem").click(function () {
                    $menuButton.hide();
                    instance.util.luckysheetContainerFocus();

                    let $t = $(this),
                        itemvalue = $t.attr("itemvalue"),
                        itemname = $t.attr("itemname");
                    currentInstance.find("#luckysheet-icon-fmt-other")
                        .find(".luckysheet-toolbar-menu-button-caption")
                        .html(" " + itemname + " ");

                    if (itemvalue == "fmtOtherSelf") {
                        return;
                    }

                    let d = instance.editor.deepCopyFlowData(Store.flowdata); //取数据
                    _this.focus($menuButton, itemvalue);

                    _this.updateFormat(containerId, d, "ct", itemvalue);
                });

                //更多格式
                currentInstance.find(`.luckysheet-icon-fmtOtherSelf-menuButton`)
                    .find(".luckysheet-cols-menuitem")
                    .click(function () {
                        $(`#${containerId} #${menuButtonId}`).hide();
                        $(`#${containerId} #luckysheet-icon-fmtOtherSelf-menuButton`).hide();
                        instance.util.luckysheetContainerFocus();

                        let itemvalue = $(this).attr("itemvalue");

                        instance.moreFormat.createDialog(itemvalue, containerId);
                        // luckysheetMoreFormat.init();
                    });
            } else {
                const text = $(this)
                    .find(".luckysheet-toolbar-menu-button-caption")
                    .text()
                    .trim();
                const format = locale_defaultFmt.find((f) => f.text === text);
                if (format) {
                    _this.focus($menuButton, format.value);
                }
            }

            let userlen = $(this).outerWidth() * Store.scale;
            let tlen = $menuButton.outerWidth() * Store.scale;

            let menuleft = $(this).offset().left;
            if (tlen > userlen && tlen + menuleft > $("#" + Store.container).width() * Store.scale) {
                menuleft = menuleft - tlen + userlen;
            }
            instance.util.mouseclickposition($menuButton, menuleft, $(this).offset().top + 25 * Store.scale, "lefttop");
        });

        //字体设置
        currentInstance.find("#luckysheet-icon-font-family").mousedown(function(e) {
        // $(document).off(`mousedown.font-family-${containerId}`).on(`mousedown.font-family-${containerId}`, `#${containerId} #luckysheet-icon-font-family`, function(e) {
                instance.cursorPos.hideMenuByCancel(e);
                e.stopPropagation();
            })
            .click(function() {
        // .off(`click.font-family-${containerId}`).on(`click.font-family-${containerId}`, `#${containerId} #luckysheet-icon-font-family`, function() {
                let menuButtonId = $(this).attr("id") + "-menuButton";
                let $menuButton = currentInstance.find("#" + menuButtonId);
                if ($menuButton.length == 0) {
                    // const locale_fontarray = instance.locale().fontarray;
                    // let itemdata = [];

                    // for(let a=0;a<locale_fontarray.length;a++){
                    //     let fItem = locale_fontarray[a];
                    //     let ret = {};
                    //     ret.value = a;
                    //     ret.text = "<span class='luckysheet-mousedown-cancel' style='font-size:11px;font-family:"+fItem+"'>"+fItem+"</span>";
                    //     ret.example = "";
                    //     itemdata.push(ret);
                    // }

                    let itemset = _this.createButtonMenu(_this.fontSelectList);

                    let menu = replaceHtml(_this.menu, { id: "font-family", item: itemset, subclass: "", sub: "", });

                    $(`#${containerId}`).append(menu);
                    $menuButton = currentInstance.find("#" + menuButtonId).width(200);
                    _this.focus($menuButton);

                    $menuButton.on("click", ".luckysheet-cols-menuitem", function () {
                        $menuButton.hide();
                        instance.util.luckysheetContainerFocus();

                        let $t = $(this),
                            itemvalue = $t.attr("itemvalue"),
                            itemname = $t.attr("itemname");
                        _this.focus($menuButton, itemvalue);
                        currentInstance.find("#luckysheet-icon-font-family")
                            .find(".luckysheet-toolbar-menu-button-caption")
                            .html(" " + itemname + " ");

                        let d = instance.editor.deepCopyFlowData(Store.flowdata);

                        _this.updateFormat(containerId, d, "ff", itemvalue);
                    });
                }

                let userlen = $(this).outerWidth() * Store.scale;
                let tlen = $menuButton.outerWidth() * Store.scale;

                let menuleft = $(this).offset().left;
                if (tlen > userlen && tlen + menuleft > $("#" + Store.container).width() * Store.scale) {
                    menuleft = menuleft - tlen + userlen;
                }
                instance.util.mouseclickposition($menuButton, menuleft, $(this).offset().top + 25 * Store.scale, "lefttop");
            });

        //字体颜色
        currentInstance.find("#luckysheet-icon-text-color").mousedown(function(e) {
        // $(document).off(`mousedown.text-color-${containerId}`).on(`mousedown.text-color-${containerId}`, `#${containerId} #luckysheet-icon-text-color`, function(e) {
                instance.cursorPos.hideMenuByCancel(e);
                e.stopPropagation();
            })
            .click(function() {
        // .off(`click.text-color-${containerId}`).on(`click.text-color-${containerId}`, `#${containerId} #luckysheet-icon-text-color`, function() {
                let d = instance.editor.deepCopyFlowData(Store.flowdata);
                let color = $(this).attr("color");
                if (color == null) {
                    color = "#000000";
                }
                _this.updateFormat(containerId, d, "fc", color);
            });

        currentInstance.find("#luckysheet-icon-text-color-menu").mousedown(function(e) {
        // $(document).off(`mousedown.text-color-menu-${containerId}`).on(`mousedown.text-colo-menur-${containerId}`, `#${containerId} #luckysheet-icon-text-color-menu`, function(e) {
                instance.cursorPos.hideMenuByCancel(e);
                e.stopPropagation();
            })
            .click(function() {
        // .off(`click.text-color-menu-${containerId}`).on(`click.text-color-menu-${containerId}`, `#${containerId} #luckysheet-icon-text-color-menu`, function() {
                let menuButtonId = $(this).attr("id") + "-menuButton";
                let $menuButton = currentInstance.find("#" + menuButtonId);

                if ($menuButton.length == 0) {
                    const _locale = instance.locale();
                    const locale_toolbar = _locale.toolbar;
                    const locale_button = _locale.button;
                    const locale_alternatingColors = _locale.alternatingColors;
                    let itemdata = [
                        {
                            name: locale_toolbar.alternatingColors + "...",
                            id: "luckysheet-color-alternate",
                            example: "",
                        },
                    ];

                    let itemset = _this.createButtonMenu(itemdata);
                    let subid = "text-color-self";
                    let coloritem = replaceHtml(_this.coloritem, {
                        class: "luckysheet-icon-alternateformat",
                        name: locale_toolbar.alternatingColors + "...",
                       
                    });
                    let menu = replaceHtml(_this.color, {
                        id: menuButtonId,
                        coloritem: coloritem,
                        colorself: subid,
                        sub: "",
                        resetColor: locale_toolbar.resetColor,
                       
                    });

                    $(`#${containerId}`).append(menu);
                    $menuButton = currentInstance.find("#" + menuButtonId);

                    currentInstance.find("#" + menuButtonId)
                        .find(".luckysheet-color-selected")
                        .spectrum({
                            showPalette: true,
                            showPaletteOnly: true,
                            preferredFormat: "hex",
                            clickoutFiresChange: false,
                            showInitial: true,
                            showInput: true,
                            flat: true,
                            hideAfterPaletteSelect: true,
                            showSelectionPalette: true,
                            maxPaletteSize: 8,
                            maxSelectionSize: 8,
                            cancelText: locale_button.cancel,
                            chooseText: locale_button.confirm,
                            togglePaletteMoreText: locale_toolbar.customColor,
                            togglePaletteLessText: locale_toolbar.collapse,
                            togglePaletteOnly: true,
                            clearText: locale_toolbar.clearText,
                            color: luckysheetConfigsetting.defaultTextColor,
                            noColorSelectedText: locale_toolbar.noColorSelectedText,
                            localStorageKey: "spectrum.textcolor" + instance.server.gridKey,
                            palette: colorPalette,
                            change: function (color) {
                                let $input = $(this);
                                if (color != null) {
                                    color = color.toHexString();
                                } else {
                                    color = "#000";
                                }

                                let oldcolor = null;
                                // $("#luckysheet-icon-text-color"+" .luckysheet-color-menu-button-indicator").css("border-bottom-color", color);
                                // 下边框换成了一个DIV
                                currentInstance.find("#luckysheet-icon-text-color"+" .text-color-bar").css("background-color", color);
                                currentInstance.find("#luckysheet-icon-text-color").attr("color", color);

                                let d = instance.editor.deepCopyFlowData(Store.flowdata);
                                _this.updateFormat(containerId, d, "fc", color);

                                $menuButton.hide();
                                instance.util.luckysheetContainerFocus();
                            },
                        });

                    $menuButton.find(".luckysheet-color-reset").click(function () {
                        $menuButton.hide();
                        instance.util.luckysheetContainerFocus();

                        let $input = currentInstance.find("#" + menuButtonId).find(".luckysheet-color-selected");
                        $input.val("#000000");
                        currentInstance.find("#luckysheet-icon-text-color").attr("color", null);
                        $input.spectrum("set", "#000000");
                        currentInstance.find("#luckysheet-icon-text-color .luckysheet-color-menu-button-indicator").css(
                            "border-bottom-color",
                            "#000000",
                        );

                        let d = instance.editor.deepCopyFlowData(Store.flowdata);
                        _this.updateFormat(containerId, d, "fc", null);
                    });

                    //交替颜色
                    $menuButton.find(".luckysheet-icon-alternateformat").click(function () {
                        $menuButton.hide();
                        instance.util.luckysheetContainerFocus();

                        if (Store.luckysheet_select_save.length > 1) {
                            if (instance.validate.isEditMode()) {
                                alert(locale_alternatingColors.errorInfo);
                            } else {
                                instance.tooltip.info(locale_alternatingColors.errorInfo, "");
                            }
                            return;
                        }

                        let range = $.extend(true, {}, Store.luckysheet_select_save[0]);

                        let isExists = instance.alternateformat.rangeIsExists(range)[0];
                        if (!isExists) {
                            instance.alternateformat.modelfocusIndex = 0;
                            instance.alternateformat.new(range);
                        }

                        instance.alternateformat.init(containerId);
                        instance.alternateformat.perfect(containerId);
                    });
                }

                let userlen = $(this).outerWidth() * Store.scale;
                let tlen = $menuButton.outerWidth() * Store.scale;

                let menuleft = $(this).offset().left;
                if (tlen > userlen && tlen + menuleft > $("#" + Store.container).width() * Store.scale) {
                    menuleft = menuleft - tlen + userlen;
                }

                let offsetTop = $(this).offset().top + 26 * Store.scale;
                setTimeout(function () {
                    let $input = currentInstance.find("#" + menuButtonId).find(".luckysheet-color-selected");
                    $input.spectrum("set", $input.val());
                    instance.util.mouseclickposition($menuButton, menuleft - 28 * Store.scale, offsetTop, "lefttop");
                }, 1);
            });

        //背景颜色
        currentInstance.find("#luckysheet-icon-cell-color").click(function() {
        // $(document).off(`click.cell-color-${containerId}`).on(`click.cell-color-${containerId}`, `#${containerId} #luckysheet-icon-cell-color`, function() {
            let d = instance.editor.deepCopyFlowData(Store.flowdata);
            let color = $(this).attr("color");
            if (color == null) {
                color = "#ffffff";
            }
            _this.updateFormat(containerId, d, "bg", color);
        });

        currentInstance.find("#luckysheet-icon-cell-color-menu").click(function() {
        // $(document).off(`click.cell-color-menu-${containerId}`).on(`click.cell-color-menu-${containerId}`, `#${containerId} #luckysheet-icon-cell-color-menu`, function() {
            let menuButtonId = $(this).attr("id") + "-menuButton";
            let $menuButton = currentInstance.find("#" + menuButtonId);

            if ($menuButton.length == 0) {
                let subid = "cell-color-self";

                const _locale = instance.locale();
                const locale_toolbar = _locale.toolbar;
                const locale_button = _locale.button;
                const locale_alternatingColors = _locale.alternatingColors;

                let coloritem = replaceHtml(_this.coloritem, {
                    class: "luckysheet-icon-alternateformat",
                    name: locale_toolbar.alternatingColors + "...",
                   
                });
                let menu = replaceHtml(_this.color, {
                    id: menuButtonId,
                    coloritem: coloritem,
                    colorself: subid,
                    sub: "",
                    resetColor: locale_toolbar.resetColor,
                   
                });

                $(`#${containerId}`).append(menu);
                $menuButton = currentInstance.find("#" + menuButtonId);

                currentInstance.find("#" + menuButtonId)
                    .find(".luckysheet-color-selected")
                    .spectrum({
                        showPalette: true,
                        showPaletteOnly: true,
                        preferredFormat: "hex",
                        clickoutFiresChange: false,
                        showInitial: true,
                        showInput: true,
                        flat: true,
                        hideAfterPaletteSelect: true,
                        showSelectionPalette: true,
                        maxPaletteSize: 8,
                        maxSelectionSize: 8,
                        color: luckysheetConfigsetting.defaultCellColor,
                        cancelText: locale_button.cancel,
                        chooseText: locale_button.confirm,
                        togglePaletteMoreText: locale_toolbar.customColor,
                        togglePaletteLessText: locale_toolbar.collapse,
                        togglePaletteOnly: true,
                        clearText: locale_toolbar.clearText,
                        noColorSelectedText: locale_toolbar.noColorSelectedText,
                        localStorageKey: "spectrum.bgcolor" + instance.server.gridKey,
                        palette: colorPalette,
                        change: function (color) {
                            let $input = $(this);
                            if (color != null) {
                                color = color.toHexString();
                            } else {
                                color = "#fff";
                            }

                            let oldcolor = null;
                            // $("#luckysheet-icon-cell-color"+" .luckysheet-color-menu-button-indicator").css("border-bottom-color", color);
                            // 下边框换成了一个DIV
                            currentInstance.find("#luckysheet-icon-cell-color .text-color-bar").css("background-color", color);

                            currentInstance.find("#luckysheet-icon-cell-color").attr("color", color);
                            let d = instance.editor.deepCopyFlowData(Store.flowdata);
                            _this.updateFormat(containerId, d, "bg", color);

                            $menuButton.hide();
                            instance.util.luckysheetContainerFocus();
                        },
                    });

                $menuButton.find(".luckysheet-color-reset").click(function () {
                    $menuButton.hide();
                    instance.util.luckysheetContainerFocus();

                    let $input = currentInstance.find("#" + menuButtonId).find(".luckysheet-color-selected");
                    $input.val("#ffffff");
                    currentInstance.find("#luckysheet-icon-cell-color").attr("color", null);
                    $input.spectrum("set", "#ffffff");
                    currentInstance.find("#luckysheet-icon-cell-color .luckysheet-color-menu-button-indicator").css(
                        "border-bottom-color",
                        "#ffffff",
                    );

                    let d = instance.editor.deepCopyFlowData(Store.flowdata);
                    _this.updateFormat(containerId, d, "bg", null);
                });

                //交替颜色
                $menuButton.find(".luckysheet-icon-alternateformat").click(function () {
                    // *如果禁止前台编辑，则中止下一步操作
                    if (!instance.validate.checkIsAllowEdit()) {
                        instance.tooltip.info("", instance.locale().pivotTable.errorNotAllowEdit);
                        return;
                    }
                    $menuButton.hide();
                    instance.util.luckysheetContainerFocus();

                    if (Store.luckysheet_select_save.length > 1) {
                        if (instance.validate.isEditMode()) {
                            alert(locale_alternatingColors.errorInfo);
                        } else {
                            instance.tooltip.info(locale_alternatingColors.errorInfo, "");
                        }
                        return;
                    }

                    let range = $.extend(true, {}, Store.luckysheet_select_save[0]);

                    let isExists = instance.alternateformat.rangeIsExists(range)[0];
                    if (!isExists) {
                        instance.alternateformat.modelfocusIndex = 0;
                        instance.alternateformat.new(range);
                    }
                    instance.alternateformat.init(containerId);
                    instance.alternateformat.perfect(containerId);
                });

                currentInstance.find("#" + menuButtonId)
                    .find(".luckysheet-color-selected")
                    .val("#fff");
            }

            let userlen = $(this).outerWidth() * Store.scale;
            let tlen = $menuButton.outerWidth() * Store.scale;

            let menuleft = $(this).offset().left;
            if (tlen > userlen && tlen + menuleft > $("#" + Store.container).width() * Store.scale) {
                menuleft = menuleft - tlen + userlen;
            }

            let offsetTop = $(this).offset().top + 26 * Store.scale;
            setTimeout(function () {
                let $input = currentInstance.find("#" + menuButtonId).find(".luckysheet-color-selected");
                $input.spectrum("set", $input.val());
                instance.util.mouseclickposition($menuButton, menuleft - 28 * Store.scale, offsetTop, "lefttop");
            }, 1);
        });

        //字体大小
        let luckysheet_fs_setTimeout = null;
        currentInstance.find("#luckysheet-icon-font-size").mousedown(function(e) {
        // $(document).off(`mousedown.font-size-${containerId}`).on(`mousedown.font-size-${containerId}`, `#${containerId} #luckysheet-icon-font-size`, function(e) {
                // if (parseInt(currentInstance.find("#luckysheet-input-box").css("top")) > 0) {
                if (parseInt(currentInstance.find("#luckysheet-input-box").css("top")) > 0) {
                    let w = window.getSelection();
                    if (w.type != "None") {
                        let range = w.getRangeAt(0);
                        if (!range.collapsed) {
                            Store.inlineStringEditRange = range.cloneRange();
                        }
                    }
                }
                instance.cursorPos.hideMenuByCancel(e);
                e.stopPropagation();
            })
            .click(function() {
            // .off(`click.font-size-${containerId}`).on(`click.font-size-${containerId}`, `#${containerId} #luckysheet-icon-font-size`, function() {
                let menuButtonId = $(this).attr("id") + "-menuButton";
                let $menuButton = currentInstance.find("#" + menuButtonId);

                if ($menuButton.length == 0) {
                    let itemdata = [
                        { text: "9", value: "9", example: "" },
                        { text: "10", value: "10", example: "" },
                        { text: "11", value: "11", example: "" },
                        { text: "12", value: "12", example: "" },
                        { text: "14", value: "14", example: "" },
                        { text: "16", value: "16", example: "" },
                        { text: "18", value: "18", example: "" },
                        { text: "20", value: "20", example: "" },
                        { text: "22", value: "22", example: "" },
                        { text: "24", value: "24", example: "" },
                        { text: "26", value: "26", example: "" },
                        { text: "28", value: "28", example: "" },
                        { text: "36", value: "36", example: "" },
                        { text: "48", value: "48", example: "" },
                        { text: "72", value: "72", example: "" },
                    ];

                    let itemset = _this.createButtonMenu(itemdata);

                    let menu = replaceHtml(_this.menu, { id: "font-size", item: itemset, subclass: "", sub: "", });

                    $(`#${containerId}`).append(menu);
                    $menuButton = currentInstance.find("#" + menuButtonId).width(150);
                    _this.focus($menuButton, 10);

                    $menuButton.find(".luckysheet-cols-menuitem").click(function () {
                        $menuButton.hide();
                        instance.util.luckysheetContainerFocus();

                        let $t = $(this),
                            itemvalue = $t.attr("itemvalue"),
                            $input = currentInstance.find("#luckysheet-icon-font-size"+" input");
                        currentInstance.find("#luckysheet-icon-font-size").attr("itemvalue", itemvalue);
                        _this.focus($menuButton, itemvalue);
                        $input.val(itemvalue);

                        let d = instance.editor.deepCopyFlowData(Store.flowdata);
                        _this.updateFormat(containerId, d, "fs", itemvalue);

                        clearTimeout(luckysheet_fs_setTimeout);
                    });
                }

                let userlen = $(this).outerWidth() * Store.scale;
                let tlen = $menuButton.outerWidth() * Store.scale;

                let defualtvalue = currentInstance.find("#luckysheet-icon-font-size").attr("itemvalue");
                if (defualtvalue == null) {
                    defualtvalue = 10;
                }
                _this.focus($menuButton, defualtvalue);

                let menuleft = $(this).offset().left;
                if (tlen > userlen && tlen + menuleft > $("#" + Store.container).width() * Store.scale) {
                    menuleft = menuleft - tlen + userlen;
                }
                instance.util.mouseclickposition($menuButton, menuleft, $(this).offset().top + 25 * Store.scale, "lefttop");
            })
            .find(`#${containerId} #luckysheet-icon-font-size input.luckysheet-toolbar-textinput`)
            .keydown(function (e) {
                instance.cursorPos.hideMenuByCancel(e);
                e.stopPropagation();
            })
            .keyup(function (e) {
                if (e.keyCode != 13) {
                    //Enter
                    return;
                }

                let $this = $(this);

                let itemvalue = parseInt($this.val());
                let $menuButton = $(`#${containerId}  #luckysheet-icon-font-size-menuButton`);
                _this.focus($menuButton, itemvalue);

                let d = instance.editor.deepCopyFlowData(Store.flowdata);
                _this.updateFormat(containerId, d, "fs", itemvalue);

                luckysheet_fs_setTimeout = setTimeout(function () {
                    $menuButton.hide();
                    $this.blur();
                }, 200);
            });

        //边框设置
        currentInstance.find("#luckysheet-icon-border-all").click(function() {
        // $(document).off(`click.border-all-${containerId}`).on(`click.border-all-${containerId}`, `#${containerId} #luckysheet-icon-border-all`, function() {
            // *如果禁止前台编辑，则中止下一步操作
            if (!instance.validate.checkIsAllowEdit()) {
                // instance.tooltip.info("", instance.locale().pivotTable.errorNotAllowEdit);
                return;
            }
            if (!instance.protection.checkProtectionFormatCells(Store.currentSheetIndex)) {
                return;
            }

            let d = instance.editor.deepCopyFlowData(Store.flowdata);

            let type = $(this).attr("type");
            if (type == null) {
                type = "border-all";
            }

            let subcolormenuid = `luckysheet-icon-borderColor-menuButton`;
            let color = currentInstance.find("#" + subcolormenuid)
                .find(".luckysheet-color-selected")
                .val();
            let style = currentInstance.find("#luckysheetborderSizepreview").attr("itemvalue");

            if (color == null || color == "") {
                color = "#000";
            }

            if (style == null || style == "") {
                style = "1";
            }

            let cfg = $.extend(true, {}, Store.config);
            if (cfg["borderInfo"] == null) {
                cfg["borderInfo"] = [];
            }

            let borderInfo = {
                rangeType: "range",
                borderType: type,
                color: color,
                style: style,
                range: $.extend(true, [], Store.luckysheet_select_save),
            };

            cfg["borderInfo"].push(borderInfo);

            if (Store.clearjfundo) {
                Store.jfundo.length = 0;

                let redo = [];

                redo["type"] = "borderChange";

                redo["config"] = $.extend(true, {}, Store.config);
                redo["curconfig"] = $.extend(true, {}, cfg);

                redo["sheetIndex"] = Store.currentSheetIndex;

                Store.jfredo.push(redo);
            }

            instance.server.saveParam("cg", Store.currentSheetIndex, cfg["borderInfo"], { k: "borderInfo" });

            Store.config = cfg;
            Store.luckysheetfile[instance.get.getSheetIndex(Store.currentSheetIndex)].config = Store.config;

            setTimeout(function () {
                instance.refresh.luckysheetrefreshgrid();
            }, 1);
        });

        currentInstance.find("#luckysheet-icon-border-menu").click(function() {
        // $(document).off(`click.border-menu-${containerId}`).on(`click.border-menu-${containerId}`, `#${containerId} #luckysheet-icon-border-menu`, function() {
            let menuButtonId = $(this).attr("id") + "-menuButton";
            let $menuButton = currentInstance.find("#" + menuButtonId);

            if ($menuButton.length == 0) {
                let canvasH = 10,
                    canvasW = 120;
                const _locale = instance.locale();
                const locale_border = _locale.border;
                const locale_toolbar = _locale.toolbar;
                const locale_button = _locale.button;
                let itemdata = [
                    {
                        text: locale_border.borderTop,
                        value: "border-top",
                        example:
                            '<div class="luckysheet-icon luckysheet-inline-block luckysheet-material-icon luckysheet-mousedown-cancel" style="user-select: none;opacity:1;"> <div aria-hidden="true" class="luckysheet-icon-img-container luckysheet-icon-img luckysheet-icon-border-top iconfont luckysheet-iconfont-shangbiankuang" style="user-select: none;"> </div> </div>',
                    },
                    {
                        text: locale_border.borderBottom,
                        value: "border-bottom",
                        example:
                            '<div class="luckysheet-icon luckysheet-inline-block luckysheet-material-icon luckysheet-mousedown-cancel" style="user-select: none;opacity:1;"> <div aria-hidden="true" class="luckysheet-icon-img-container luckysheet-icon-img luckysheet-icon-border-bottom iconfont luckysheet-iconfont-xiabiankuang" style="user-select: none;"> </div> </div>',
                    },
                    {
                        text: locale_border.borderLeft,
                        value: "border-left",
                        example:
                            '<div class="luckysheet-icon luckysheet-inline-block luckysheet-material-icon luckysheet-mousedown-cancel" style="user-select: none;opacity:1;"> <div aria-hidden="true" class="luckysheet-icon-img-container luckysheet-icon-img luckysheet-icon-border-left iconfont luckysheet-iconfont-zuobiankuang" style="user-select: none;"> </div> </div>',
                    },
                    {
                        text: locale_border.borderRight,
                        value: "border-right",
                        example:
                            '<div class="luckysheet-icon luckysheet-inline-block luckysheet-material-icon luckysheet-mousedown-cancel" style="user-select: none;opacity:1;"> <div aria-hidden="true" class="luckysheet-icon-img-container luckysheet-icon-img luckysheet-icon-border-right iconfont luckysheet-iconfont-youbiankuang" style="user-select: none;"> </div> </div>',
                    },
                    { text: "", value: "split", example: "" },
                    {
                        text: locale_border.borderNone,
                        value: "border-none",
                        example:
                            '<div class="luckysheet-icon luckysheet-inline-block luckysheet-material-icon luckysheet-mousedown-cancel" style="user-select: none;opacity:1;"> <div aria-hidden="true" class="luckysheet-icon-img-container luckysheet-icon-img luckysheet-icon-border-none iconfont luckysheet-iconfont-wubiankuang" style="user-select: none;"> </div> </div>',
                    },
                    {
                        text: locale_border.borderAll,
                        value: "border-all",
                        example:
                            '<div class="luckysheet-icon luckysheet-inline-block luckysheet-material-icon luckysheet-mousedown-cancel" style="user-select: none;opacity:1;"> <div aria-hidden="true" class="luckysheet-icon-img-container luckysheet-icon-img luckysheet-icon-border-all iconfont luckysheet-iconfont-quanjiabiankuang" style="user-select: none;"> </div> </div>',
                    },
                    {
                        text: locale_border.borderOutside,
                        value: "border-outside",
                        example:
                            '<div class="luckysheet-icon luckysheet-inline-block luckysheet-material-icon luckysheet-mousedown-cancel" style="user-select: none;opacity:1;"> <div aria-hidden="true" class="luckysheet-icon-img-container luckysheet-icon-img luckysheet-icon-border-outside iconfont luckysheet-iconfont-sizhoujiabiankuang" style="user-select: none;"> </div> </div>',
                    },
                    { text: "", value: "split", example: "" },
                    {
                        text: locale_border.borderInside,
                        value: "border-inside",
                        example:
                            '<div class="luckysheet-icon luckysheet-inline-block luckysheet-material-icon luckysheet-mousedown-cancel" style="user-select: none;opacity:1;"> <div aria-hidden="true" class="luckysheet-icon-img-container luckysheet-icon-img luckysheet-icon-border-inside iconfont luckysheet-iconfont-neikuangxian" style="user-select: none;"> </div> </div>',
                    },
                    {
                        text: locale_border.borderHorizontal,
                        value: "border-horizontal",
                        example:
                            '<div class="luckysheet-icon luckysheet-inline-block luckysheet-material-icon luckysheet-mousedown-cancel" style="user-select: none;opacity:1;"> <div aria-hidden="true" class="luckysheet-icon-img-container luckysheet-icon-img luckysheet-icon-border-horizontal iconfont luckysheet-iconfont-neikuanghengxian" style="user-select: none;"> </div> </div>',
                    },
                    {
                        text: locale_border.borderVertical,
                        value: "border-vertical",
                        example:
                            '<div class="luckysheet-icon luckysheet-inline-block luckysheet-material-icon luckysheet-mousedown-cancel" style="user-select: none;opacity:1;"> <div aria-hidden="true" class="luckysheet-icon-img-container luckysheet-icon-img luckysheet-icon-border-vertical iconfont luckysheet-iconfont-neikuangshuxian" style="user-select: none;"> </div> </div>',
                    },
                    { text: "", value: "split", example: "" },
                    {
                        text:
                            "<span id='luckysheet-icon-borderColor-linecolor"+"' class='luckysheet-mousedown-cancel' style='border-bottom:3px solid #000;'>" +
                            locale_border.borderColor +
                            "</span>",
                        value: "borderColor",
                        example: "more",
                    },
                    {
                        text:
                            "" +
                            locale_border.borderSize +
                            "<img id='luckysheetborderSizepreview"+"' width=100 height=10 src='data:image/gif;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVQImWNgYGBgAAAABQABh6FO1AAAAABJRU5ErkJggg==' style='position:absolute;bottom:-5px;right:0px;width:100px;height:10px;'>",
                        value: "borderSize",
                        example: "more",
                    },
                ];

                // itemvalue to iconfont
                const iconfontObject = iconfontObjects.border;

                let itemset = _this.createButtonMenu(itemdata);

                let menu = replaceHtml(_this.menu, { id: "border-menu", item: itemset, subclass: "", sub: "", });

                let subitemdata = [
                    { text: locale_border.borderNone, value: "0", example: "" },
                    {
                        text:
                            "<canvas type='Thin' class='border-Thin' width=" +
                            canvasW +
                            " height=" +
                            canvasH +
                            " style='width:" +
                            canvasW +
                            "px;height:" +
                            canvasH +
                            "px;position:static;'></canvas>",
                        value: "1",
                        example: "",
                    },
                    {
                        text:
                            "<canvas type='Hair' class='border-Hair' width=" +
                            canvasW +
                            " height=" +
                            canvasH +
                            " style='width:" +
                            canvasW +
                            "px;height:" +
                            canvasH +
                            "px;position:static;'></canvas>",
                        value: "2",
                        example: "",
                    },
                    {
                        text:
                            "<canvas type='Dotted' class='border-Dotted' width=" +
                            canvasW +
                            " height=" +
                            canvasH +
                            " style='width:" +
                            canvasW +
                            "px;height:" +
                            canvasH +
                            "px;position:static;'></canvas>",
                        value: "3",
                        example: "",
                    },
                    {
                        text:
                            "<canvas type='Dashed' class='border-Dashed' width=" +
                            canvasW +
                            " height=" +
                            canvasH +
                            " style='width:" +
                            canvasW +
                            "px;height:" +
                            canvasH +
                            "px;position:static;'></canvas>",
                        value: "4",
                        example: "",
                    },
                    {
                        text:
                            "<canvas type='DashDot' class='border-DashDot' width=" +
                            canvasW +
                            " height=" +
                            canvasH +
                            " style='width:" +
                            canvasW +
                            "px;height:" +
                            canvasH +
                            "px;position:static;'></canvas>",
                        value: "5",
                        example: "",
                    },
                    {
                        text:
                            "<canvas type='DashDotDot' class='border-DashDotDot' width=" +
                            canvasW +
                            " height=" +
                            canvasH +
                            " style='width:" +
                            canvasW +
                            "px;height:" +
                            canvasH +
                            "px;position:static;'></canvas>",
                        value: "6",
                        example: "",
                    },
                    // {"text":"<canvas type='Double' class='border-Double' width="+ canvasW +" height="+ canvasH +" style='width:"+ canvasW +"px;height:"+ canvasH +"px;position:static;'></canvas>", "value":"7", "example":""},
                    {
                        text:
                            "<canvas type='Medium' class='border-Medium' width=" +
                            canvasW +
                            " height=" +
                            canvasH +
                            " style='width:" +
                            canvasW +
                            "px;height:" +
                            canvasH +
                            "px;position:static;'></canvas>",
                        value: "8",
                        example: "",
                    },
                    {
                        text:
                            "<canvas type='MediumDashed' class='border-MediumDashed' width=" +
                            canvasW +
                            " height=" +
                            canvasH +
                            " style='width:" +
                            canvasW +
                            "px;height:" +
                            canvasH +
                            "px;position:static;'></canvas>",
                        value: "9",
                        example: "",
                    },
                    {
                        text:
                            "<canvas type='MediumDashDot' class='border-MediumDashDot' width=" +
                            canvasW +
                            " height=" +
                            canvasH +
                            " style='width:" +
                            canvasW +
                            "px;height:" +
                            canvasH +
                            "px;position:static;'></canvas>",
                        value: "10",
                        example: "",
                    },
                    {
                        text:
                            "<canvas type='MediumDashDotDot' class='border-MediumDashDotDot' width=" +
                            canvasW +
                            " height=" +
                            canvasH +
                            " style='width:" +
                            canvasW +
                            "px;height:" +
                            canvasH +
                            "px;position:static;'></canvas>",
                        value: "11",
                        example: "",
                    },
                    // {"text":"<canvas type='SlantedDashDot' class='border-SlantedDashDot' width="+ canvasW +" height="+ canvasH +" style='width:"+ canvasW +"px;height:"+ canvasH +"px;position:static;'></canvas>", "value":"12", "example":""},
                    {
                        text:
                            "<canvas type='Thick' class='border-Thick' width=" +
                            canvasW +
                            " height=" +
                            canvasH +
                            " style='width:" +
                            canvasW +
                            "px;height:" +
                            canvasH +
                            "px;position:static;'></canvas>",
                        value: "13",
                        example: "",
                    },
                ];

                let subitemset = _this.createButtonMenu(subitemdata);
                let submenu = replaceHtml(_this.menu, {
                    id: "borderSize",
                    item: subitemset,
                    subclass: "luckysheet-menuButton-sub",
                   
                });
                let submenuid = `luckysheet-icon-borderSize-menuButton`;
                let subcolormenuid = `luckysheet-icon-borderColor-menuButton`;
                let colormenu = replaceHtml(_this.color, {
                    id: subcolormenuid,
                    coloritem: "",
                    colorself: "",
                    sub: "luckysheet-menuButton-sub",
                    resetColor: locale_toolbar.resetColor,
                   
                });

                $(`#${containerId}`).append(menu + colormenu + submenu);
                $menuButton = currentInstance.find("#" + menuButtonId).width(170);
                _this.focus($menuButton, "border-all");

                currentInstance.find("#" + submenuid + " canvas").each(function (i) {
                    let type = $(this).attr("type");
                    let itemvalue = $(this)
                        .closest(".luckysheet-cols-menuitem")
                        .attr("itemvalue");
                    let canvasborder = $(this)
                        .addClass("luckysheet-mousedown-cancel")
                        .get(0)
                        .getContext("2d");
                    canvasborder.translate(0.5, 0.5);

                    _this.setLineDash(canvasborder, itemvalue, "h", 0, 5, 100, 5);

                    canvasborder.strokeStyle = "#000000";
                    canvasborder.stroke();
                    canvasborder.closePath();
                });

                currentInstance.find("#" + submenuid + " .luckysheet-cols-menuitem").click(function () {
                    currentInstance.find("#" + submenuid).hide();

                    let $t = $(this),
                        itemvalue = $t.attr("itemvalue");

                    if (itemvalue == 0) {
                        currentInstance.find("#luckysheetborderSizepreview")
                            .attr(
                                "src",
                                "data:image/gif;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVQImWNgYGBgAAAABQABh6FO1AAAAABJRU5ErkJggg==",
                            )
                            .attr("itemvalue", null);
                    } else {
                        let bg = $t
                            .find("canvas")
                            .get(0)
                            .toDataURL("image/png");
                        currentInstance.find("#luckysheetborderSizepreview")
                            .attr("src", bg)
                            .attr("itemvalue", itemvalue);
                    }

                    _this.focus(currentInstance.find("#" + submenuid), itemvalue);
                });

                // border choose menu
                $menuButton.find(".luckysheet-cols-menuitem").click(function () {
                    // *如果禁止前台编辑，则中止下一步操作
                    if (!instance.validate.checkIsAllowEdit()) {
                        instance.tooltip.info("", instance.locale().pivotTable.errorNotAllowEdit);
                        return;
                    }
                    $menuButton.hide();
                    instance.util.luckysheetContainerFocus();

                    let $t = $(this),
                        itemvalue = $t.attr("itemvalue");
                    if (itemvalue == "borderColor" || itemvalue == "borderSize") {
                        return;
                    }

                    if (!instance.protection.checkProtectionFormatCells(Store.currentSheetIndex)) {
                        return;
                    }

                    let d = instance.editor.deepCopyFlowData(Store.flowdata);

                    let color = currentInstance.find("#" + subcolormenuid)
                        .find(".luckysheet-color-selected")
                        .val();
                    let style = currentInstance.find("#luckysheetborderSizepreview").attr("itemvalue");

                    if (color == null || color == "") {
                        color = "#000";
                    }

                    if (style == null || style == "") {
                        style = "1";
                    }

                    let cfg = $.extend(true, {}, Store.config);
                    if (cfg["borderInfo"] == null) {
                        cfg["borderInfo"] = [];
                    }

                    let borderInfo = {
                        rangeType: "range",
                        borderType: itemvalue,
                        color: color,
                        style: style,
                        range: $.extend(true, [], Store.luckysheet_select_save),
                    };

                    cfg["borderInfo"].push(borderInfo);

                    if (Store.clearjfundo) {
                        Store.jfundo.length = 0;

                        let redo = [];

                        redo["type"] = "borderChange";

                        redo["config"] = $.extend(true, {}, Store.config);
                        redo["curconfig"] = $.extend(true, {}, cfg);

                        redo["sheetIndex"] = Store.currentSheetIndex;

                        Store.jfredo.push(redo);
                    }

                    instance.server.saveParam("cg", Store.currentSheetIndex, cfg["borderInfo"], { k: "borderInfo" });

                    Store.config = cfg;
                    Store.luckysheetfile[instance.get.getSheetIndex(Store.currentSheetIndex)].config = Store.config;

                    setTimeout(function () {
                        instance.refresh.luckysheetrefreshgrid();
                    }, 1);

                    currentInstance.find("#luckysheet-icon-border-all").attr("type", itemvalue);

                    let $icon = currentInstance.find("#luckysheet-icon-border-all").find(".luckysheet-icon-img-container");

                    // add iconfont
                    $icon
                        .removeAttr("class")
                        .addClass(
                            "luckysheet-icon-img-container luckysheet-icon-img luckysheet-icon-" +
                            itemvalue +
                            iconfontObject[itemvalue],
                        );

                    _this.focus($menuButton, itemvalue);
                });

                currentInstance.find("#" + subcolormenuid)
                    .find(".luckysheet-color-selected")
                    .spectrum({
                        showPalette: true,
                        showPaletteOnly: true,
                        preferredFormat: "hex",
                        clickoutFiresChange: false,
                        showInitial: true,
                        showInput: true,
                        flat: true,
                        hideAfterPaletteSelect: true,
                        showSelectionPalette: true,
                        maxPaletteSize: 8,
                        maxSelectionSize: 8,
                        color: "#000",
                        cancelText: locale_button.cancel,
                        chooseText: locale_button.confirm,
                        togglePaletteMoreText: locale_toolbar.customColor,
                        togglePaletteLessText: locale_toolbar.collapse,
                        togglePaletteOnly: true,
                        clearText: locale_toolbar.clearText,
                        noColorSelectedText: locale_toolbar.noColorSelectedText,
                        localStorageKey: "spectrum.bordercolor" + instance.server.gridKey,
                        palette: colorPalette,
                        change: function (color) {
                            let $input = $(this);
                            if (color != null) {
                                color = color.toHexString();
                            } else {
                                color = "#000";
                            }

                            let oldcolor = null;
                            currentInstance.find("#luckysheet-icon-borderColor-linecolor").css("border-bottom-color", color);
                            currentInstance.find("#" + subcolormenuid)
                                .find(".luckysheet-color-selected")
                                .val(color);
                        },
                    });

                currentInstance.find("#" + subcolormenuid)
                    .find(".luckysheet-color-reset")
                    .click(function () {
                        let $input = currentInstance.find("#" + subcolormenuid).find(".luckysheet-color-selected");
                        $input.val("#000");
                        currentInstance.find("#luckysheet-icon-cell-color").attr("color", null);
                        $input.spectrum("set", "#000");
                        currentInstance.find("#luckysheet-icon-borderColor-linecolor").css("border-bottom-color", "#000");
                    });
            }

            let userlen = $(this).outerWidth() * Store.scale;
            let tlen = $menuButton.outerWidth() * Store.scale;

            let menuleft = $(this).offset().left;
            if (tlen > userlen && tlen + menuleft > $("#" + Store.container).width() * Store.scale) {
                menuleft = menuleft - tlen + userlen;
            }
            instance.util.mouseclickposition($menuButton, menuleft - 28 * Store.scale, $(this).offset().top + 25 * Store.scale, "lefttop");
        });

        //合并单元格
        currentInstance.find("#luckysheet-icon-merge-button").click(function() {
        // $(document).off(`click.cell-merge-${containerId}`).on(`click.cell-merge-${containerId}`, `#${containerId} #luckysheet-icon-merge-button`, function() {
            const _locale = instance.locale();
            const locale_merge = _locale.merge;

            if (!instance.protection.checkProtectionNotEnable(Store.currentSheetIndex)) {
                return;
            }

            if (instance.select.selectIsOverlap()) {
                if (instance.validate.isEditMode()) {
                    alert(locale_merge.overlappingError);
                } else {
                    instance.tooltip.info(locale_merge.overlappingError, "");
                }
                return;
            }

            if (Store.config["merge"] != null) {
                let has_PartMC = false;

                for (let s = 0; s < Store.luckysheet_select_save.length; s++) {
                    let r1 = Store.luckysheet_select_save[s].row[0],
                        r2 = Store.luckysheet_select_save[s].row[1];
                    let c1 = Store.luckysheet_select_save[s].column[0],
                        c2 = Store.luckysheet_select_save[s].column[1];

                    has_PartMC = instance.validate.hasPartMC(Store.config, r1, r2, c1, c2);

                    if (has_PartMC) {
                        break;
                    }
                }

                if (has_PartMC) {
                    if (instance.validate.isEditMode()) {
                        alert(locale_merge.partiallyError);
                    } else {
                        instance.tooltip.info(locale_merge.partiallyError, "");
                    }
                    return;
                }
            }

            let d = instance.editor.deepCopyFlowData(Store.flowdata);
            _this.updateFormat_mc(containerId, d, "mergeAll");
        });

        currentInstance.find("#luckysheet-icon-merge-menu").click(function() {
        // $(document).off(`click.cell-merge-menu-${containerId}`).on(`click.cell-merge-menu-${containerId}`, `#${containerId} #luckysheet-icon-merge-menu`, function() {
            let menuButtonId = $(this).attr("id") + "-menuButton";
            let $menuButton = currentInstance.find("#" + menuButtonId);

            if ($menuButton.length == 0) {
                const _locale = instance.locale();
                const locale_merge = _locale.merge;

                let itemdata = [
                    { text: locale_merge.mergeAll, value: "mergeAll", example: "" },
                    { text: locale_merge.mergeV, value: "mergeV", example: "" },
                    { text: locale_merge.mergeH, value: "mergeH", example: "" },
                    { text: locale_merge.mergeCancel, value: "mergeCancel", example: "" },
                ];

                let itemset = _this.createButtonMenu(itemdata);

                let menu = replaceHtml(_this.menu, { id: "merge-menu", item: itemset, subclass: "", sub: "", });

                $(`#${containerId}`).append(menu);
                $menuButton = currentInstance.find("#" + menuButtonId);
                _this.focus($menuButton);

                $menuButton.find(".luckysheet-cols-menuitem").click(function () {
                    $menuButton.hide();
                    instance.util.luckysheetContainerFocus();

                    if (instance.select.selectIsOverlap()) {
                        if (instance.validate.isEditMode()) {
                            alert(locale_merge.overlappingError);
                        } else {
                            instance.tooltip.info(locale_merge.overlappingError, "");
                        }
                        return;
                    }

                    if (Store.config["merge"] != null) {
                        let has_PartMC = false;

                        for (let s = 0; s < Store.luckysheet_select_save.length; s++) {
                            let r1 = Store.luckysheet_select_save[s].row[0],
                                r2 = Store.luckysheet_select_save[s].row[1];
                            let c1 = Store.luckysheet_select_save[s].column[0],
                                c2 = Store.luckysheet_select_save[s].column[1];

                            has_PartMC = instance.validate.hasPartMC(Store.config, r1, r2, c1, c2);

                            if (has_PartMC) {
                                break;
                            }
                        }

                        if (has_PartMC) {
                            if (instance.validate.isEditMode()) {
                                alert(locale_merge.partiallyError);
                            } else {
                                instance.tooltip.info(locale_merge.partiallyError, "");
                            }
                            return;
                        }
                    }

                    let $t = $(this),
                        itemvalue = $t.attr("itemvalue");
                    _this.focus($menuButton, itemvalue);

                    let d = instance.editor.deepCopyFlowData(Store.flowdata);
                    _this.updateFormat_mc(containerId, d, itemvalue);
                });
            }

            let userlen = $(this).outerWidth() * Store.scale;
            let tlen = $menuButton.outerWidth() * Store.scale;

            let menuleft = $(this).offset().left;
            if (tlen > userlen && tlen + menuleft > $("#" + Store.container).width() * Store.scale) {
                menuleft = menuleft - tlen + userlen;
            }
            instance.util.mouseclickposition($menuButton, menuleft - 28 * Store.scale, $(this).offset().top + 25 * Store.scale, "lefttop");
        });

        //水平对齐
        currentInstance.find("#luckysheet-icon-align").click(function() {
        // $(document).off(`click.align-${containerId}`).on(`click.align-${containerId}`, `#${containerId} #luckysheet-icon-align`, function() {
            let itemvalue = currentInstance.find("#luckysheet-icon-align").attr("type");
            if (itemvalue == null) {
                itemvalue = "left";
            }

            let d = instance.editor.deepCopyFlowData(Store.flowdata);
            _this.updateFormat(containerId, d, "ht", itemvalue);
        });

        currentInstance.find("#luckysheet-icon-align-menu").click(function() {
        // $(document).off(`click.align-menu-${containerId}`).on(`click.align-menu-${containerId}`, `#${containerId} #luckysheet-icon-align-menu`, function() {
            let menuButtonId = $(this).attr("id") + "-menuButton";
            let $menuButton = currentInstance.find("#" + menuButtonId);

            if ($menuButton.length == 0) {
                const _locale = instance.locale();
                const locale_align = _locale.align;
                let itemdata = [
                    {
                        text: locale_align.left,
                        value: "left",
                        example:
                            '<div class="luckysheet-icon luckysheet-inline-block" style="user-select: none;opacity:1;"> <div aria-hidden="true" class="luckysheet-icon-img-container luckysheet-icon-img luckysheet-icon-align-left iconfont luckysheet-iconfont-wenbenzuoduiqi" style="user-select: none;"> </div> </div>',
                    },
                    {
                        text: locale_align.center,
                        value: "center",
                        example:
                            '<div class="luckysheet-icon luckysheet-inline-block" style="user-select: none;opacity:1;"> <div aria-hidden="true" class="luckysheet-icon-img-container luckysheet-icon-img luckysheet-icon-align-center iconfont luckysheet-iconfont-wenbenjuzhongduiqi" style="user-select: none;"> </div> </div>',
                    },
                    {
                        text: locale_align.right,
                        value: "right",
                        example:
                            '<div class="luckysheet-icon luckysheet-inline-block" style="user-select: none;opacity:1;"> <div aria-hidden="true" class="luckysheet-icon-img-container luckysheet-icon-img luckysheet-icon-align-right iconfont luckysheet-iconfont-wenbenyouduiqi" style="user-select: none;"> </div> </div>',
                    },
                ];

                // itemvalue to iconfont
                const iconfontObject = iconfontObjects.align;

                let itemset = _this.createButtonMenu(itemdata);

                let menu = replaceHtml(_this.menu, { id: "align-menu", item: itemset, subclass: "", sub: "", });

                $(`#${containerId}`).append(menu);
                $menuButton = currentInstance.find("#" + menuButtonId).width(120);
                // _this.focus($menuButton);
                // 刚打开luckysheet，水平对齐方式菜单未创建，单元格的水平对齐方式值与菜单选中值不一致 --modify by liluyao 2023/9/4
                // 获取当前选区的值，若选区为多个单元格取第一个单元格的值
                let rangeValue = instance.api.getRangeValue()
                let itemValue = rangeValue[0][0].ht
                if (!itemValue && itemValue != '0') {
                    itemValue = 'left'
                } else if (itemValue == '0') {
                    itemValue = 'center'
                } else if (itemValue == '1') {
                    itemValue = 'left'
                } else if (itemValue == '2') {
                    itemValue = 'right'
                }
                _this.focus($menuButton, itemValue);

                $menuButton.find(".luckysheet-cols-menuitem").click(function () {
                    $menuButton.hide();
                    instance.util.luckysheetContainerFocus();

                    let $t = $(this),
                        itemvalue = $t.attr("itemvalue");
                    _this.focus($menuButton, itemvalue);

                    let $icon = currentInstance.find("#luckysheet-icon-align")
                        .attr("type", itemvalue)
                        .find(".luckysheet-icon-img-container");

                    // add iconfont
                    $icon
                        .removeAttr("class")
                        .addClass(
                            "luckysheet-icon-img-container luckysheet-icon-img luckysheet-icon-align-" +
                            itemvalue +
                            iconfontObject[itemvalue],
                        );

                    let d = instance.editor.deepCopyFlowData(Store.flowdata);
                    _this.updateFormat(containerId, d, "ht", itemvalue);
                });
            }

            let userlen = $(this).outerWidth() * Store.scale;
            let tlen = $menuButton.outerWidth() * Store.scale;

            let menuleft = $(this).offset().left;
            if (tlen > userlen && tlen + menuleft > $("#" + Store.container).width() * Store.scale) {
                menuleft = menuleft - tlen + userlen;
            }
            instance.util.mouseclickposition($menuButton, menuleft - 28 * Store.scale, $(this).offset().top + 25 * Store.scale, "lefttop");
        });

        //垂直对齐
        currentInstance.find("#luckysheet-icon-valign").click(function() {
        // $(document).off(`click.valign-${containerId}`).on(`click.valign-${containerId}`, `#${containerId} #luckysheet-icon-valign`, function() {
            let itemvalue = currentInstance.find("#luckysheet-icon-valign").attr("type");
            if (itemvalue == null) {
                itemvalue = "bottom";
            }

            let d = instance.editor.deepCopyFlowData(Store.flowdata);
            _this.updateFormat(containerId, d, "vt", itemvalue);
        });

        currentInstance.find("#luckysheet-icon-valign-menu").click(function() {
        // $(document).off(`click.valign-menu-${containerId}`).on(`click.valign-menu-${containerId}`, `#${containerId} #luckysheet-icon-valign-menu`, function() {
            let menuButtonId = $(this).attr("id") + "-menuButton";
            let $menuButton = currentInstance.find("#" + menuButtonId);
            const _locale = instance.locale();
            const locale_align = _locale.align;
            if ($menuButton.length == 0) {
                let itemdata = [
                    {
                        text: locale_align.top,
                        value: "top",
                        example:
                            '<div class="luckysheet-icon luckysheet-inline-block" style="user-select: none;opacity:1;"> <div aria-hidden="true" class="luckysheet-icon-img-container luckysheet-icon-img luckysheet-icon-valign-top iconfont luckysheet-iconfont-dingbuduiqi" style="user-select: none;"> </div> </div>',
                    },
                    {
                        text: locale_align.middle,
                        value: "middle",
                        example:
                            '<div class="luckysheet-icon luckysheet-inline-block" style="user-select: none;opacity:1;"> <div aria-hidden="true" class="luckysheet-icon-img-container luckysheet-icon-img luckysheet-icon-valign-middle iconfont luckysheet-iconfont-shuipingduiqi" style="user-select: none;"> </div> </div>',
                    },
                    {
                        text: locale_align.bottom,
                        value: "bottom",
                        example:
                            '<div class="luckysheet-icon luckysheet-inline-block" style="user-select: none;opacity:1;"> <div aria-hidden="true" class="luckysheet-icon-img-container luckysheet-icon-img luckysheet-icon-valign-bottom iconfont luckysheet-iconfont-dibuduiqi" style="user-select: none;"> </div> </div>',
                    },
                ];

                // itemvalue to iconfont
                const iconfontObject = iconfontObjects.align;

                let itemset = _this.createButtonMenu(itemdata);

                let menu = replaceHtml(_this.menu, { id: "valign-menu", item: itemset, subclass: "", sub: "", });

                $(`#${containerId}`).append(menu);
                $menuButton = currentInstance.find("#" + menuButtonId).width(120);
                // 刚打开luckysheet，垂直对齐方式菜单未创建，单元格的垂直对齐方式值与菜单选中值不一致 --modify by liluyao 2023/9/4
                // 获取当前选区的值，若选区为多个单元格取第一个单元格的值
                let rangeValue = instance.api.getRangeValue()
                let itemValue = rangeValue[0][0].vt
                if (!itemValue && itemValue != '0') {
                    itemValue = 'bottom'
                } else if (itemValue == '0') {
                    itemValue = 'middle'
                } else if (itemValue == '1') {
                    itemValue = 'top'
                } else if (itemValue == '2') {
                    itemValue = 'bottom'
                }
                _this.focus($menuButton, itemValue);

                $menuButton.find(".luckysheet-cols-menuitem").click(function () {
                    $menuButton.hide();
                    instance.util.luckysheetContainerFocus();

                    let $t = $(this),
                        itemvalue = $t.attr("itemvalue");
                    _this.focus($menuButton, itemvalue);

                    let $icon = currentInstance.find("#luckysheet-icon-valign")
                        .attr("type", itemvalue)
                        .find(".luckysheet-icon-img-container");

                    // add iconfont
                    $icon
                        .removeAttr("class")
                        .addClass(
                            "luckysheet-icon-img-container luckysheet-icon-img luckysheet-icon-valign-" +
                            itemvalue +
                            iconfontObject[itemvalue],
                        );

                    let d = instance.editor.deepCopyFlowData(Store.flowdata);
                    _this.updateFormat(containerId, d, "vt", itemvalue);
                });
            }

            let userlen = $(this).outerWidth() * Store.scale;
            let tlen = $menuButton.outerWidth() * Store.scale;

            let menuleft = $(this).offset().left;
            if (tlen > userlen && tlen + menuleft > $("#" + Store.container).width() * Store.scale) {
                menuleft = menuleft - tlen + userlen;
            }
            instance.util.mouseclickposition($menuButton, menuleft - 28 * Store.scale, $(this).offset().top + 25 * Store.scale, "lefttop");
        });

        //文本换行
        currentInstance.find("#luckysheet-icon-textwrap-menu").click(function() {
        // $(document).off(`click.textwrap-menu-${containerId}`).on(`click.textwrap-menu-${containerId}`, `#${containerId} #luckysheet-icon-textwrap-menu`, function() {
            let menuButtonId = $(this).attr("id") + "-menuButton";
            let $menuButton = currentInstance.find("#" + menuButtonId);

            if ($menuButton.length == 0) {
                const _locale = instance.locale();
                const locale_textWrap = _locale.textWrap;
                let itemdata = [
                    {
                        text: locale_textWrap.overflow,
                        value: "overflow",
                        example:
                            '<div class="luckysheet-icon luckysheet-inline-block" style="user-select: none;opacity:1;"> <div aria-hidden="true" class="luckysheet-icon-img-container luckysheet-icon-img luckysheet-icon-textwrap-overflow iconfont luckysheet-iconfont-yichu1" style="user-select: none;"> </div> </div>',
                    },
                    {
                        text: locale_textWrap.wrap,
                        value: "wrap",
                        example:
                            '<div class="luckysheet-icon luckysheet-inline-block" style="user-select: none;opacity:1;"> <div aria-hidden="true" class="luckysheet-icon-img-container luckysheet-icon-img luckysheet-icon-textwrap-wrap iconfont luckysheet-iconfont-zidonghuanhang" style="user-select: none;"> </div> </div>',
                    },
                    {
                        text: locale_textWrap.clip,
                        value: "clip",
                        example:
                            '<div class="luckysheet-icon luckysheet-inline-block" style="user-select: none;opacity:1;"> <div aria-hidden="true" class="luckysheet-icon-img-container luckysheet-icon-img luckysheet-icon-textwrap-clip iconfont luckysheet-iconfont-jieduan" style="user-select: none;"> </div> </div>',
                    },
                ];

                // itemvalue to iconfont
                const iconfontObject = iconfontObjects.textWrap;

                let itemset = _this.createButtonMenu(itemdata);

                let menu = replaceHtml(_this.menu, { id: "textwrap-menu", item: itemset, subclass: "", sub: "", });

                $(`#${containerId}`).append(menu);
                $menuButton = currentInstance.find("#" + menuButtonId).width(120);
                _this.focus($menuButton, "clip");

                $menuButton.find(".luckysheet-cols-menuitem").click(function () {
                    $menuButton.hide();
                    instance.util.luckysheetContainerFocus();

                    let $t = $(this),
                        itemvalue = $t.attr("itemvalue");
                    _this.focus($menuButton, itemvalue);

                    let $icon = currentInstance.find("#luckysheet-icon-textwrap")
                        .attr("type", itemvalue)
                        .find(".luckysheet-icon-img-container");

                    // add iconfont
                    $icon
                        .removeAttr("class")
                        .addClass(
                            "luckysheet-icon-img-container luckysheet-icon-img luckysheet-icon-textwrap-" +
                            itemvalue +
                            iconfontObject[itemvalue],
                        );

                    let d = instance.editor.deepCopyFlowData(Store.flowdata);
                    _this.updateFormat(containerId, d, "tb", itemvalue);
                });
            }

            let userlen = $(this).outerWidth() * Store.scale;
            let tlen = $menuButton.outerWidth() * Store.scale;

            let menuleft = $(this).offset().left;
            if (tlen > userlen && tlen + menuleft > $("#" + Store.container).width() * Store.scale) {
                menuleft = menuleft - tlen + userlen;
            }
            instance.util.mouseclickposition($menuButton, menuleft - 28 * Store.scale, $(this).offset().top + 25 * Store.scale, "lefttop");
        });

        //文本旋转
        currentInstance.find("#luckysheet-icon-rotation-menu").click(function() {
        // $(document).off(`click.rotation-menu-${containerId}`).on(`click.rotation-menu-${containerId}`, `#${containerId} #luckysheet-icon-rotation-menu`, function() {
            let menuButtonId = $(this).attr("id") + "-menuButton";
            let $menuButton = currentInstance.find("#" + menuButtonId);

            if ($menuButton.length == 0) {
                const _locale = instance.locale();
                const locale_rotation = _locale.rotation;
                let itemdata = [
                    {
                        text: locale_rotation.none,
                        value: "none",
                        example:
                            '<div class="luckysheet-icon luckysheet-inline-block" style="user-select: none;opacity:1;"> <div aria-hidden="true" class="luckysheet-icon-img-container luckysheet-icon-img luckysheet-icon-rotation-none iconfont luckysheet-iconfont-wuxuanzhuang" style="user-select: none;"> </div> </div>',
                    },
                    {
                        text: locale_rotation.angleup,
                        value: "angleup",
                        example:
                            '<div class="luckysheet-icon luckysheet-inline-block" style="user-select: none;opacity:1;"> <div aria-hidden="true" class="luckysheet-icon-img-container luckysheet-icon-img luckysheet-icon-rotation-angleup iconfont luckysheet-iconfont-xiangshangqingxie" style="user-select: none;"> </div> </div>',
                    },
                    {
                        text: locale_rotation.angledown,
                        value: "angledown",
                        example:
                            '<div class="luckysheet-icon luckysheet-inline-block" style="user-select: none;opacity:1;"> <div aria-hidden="true" class="luckysheet-icon-img-container luckysheet-icon-img luckysheet-icon-rotation-angledown iconfont luckysheet-iconfont-xiangxiaqingxie" style="user-select: none;"> </div> </div>',
                    },
                    {
                        text: locale_rotation.vertical,
                        value: "vertical",
                        example:
                            '<div class="luckysheet-icon luckysheet-inline-block" style="user-select: none;opacity:1;"> <div aria-hidden="true" class="luckysheet-icon-img-container luckysheet-icon-img luckysheet-icon-rotation-vertical iconfont luckysheet-iconfont-shupaiwenzi" style="user-select: none;"> </div> </div>',
                    },
                    {
                        text: locale_rotation.rotationUp,
                        value: "rotation-up",
                        example:
                            '<div class="luckysheet-icon luckysheet-inline-block" style="user-select: none;opacity:1;"> <div aria-hidden="true" class="luckysheet-icon-img-container luckysheet-icon-img luckysheet-icon-rotation-rotation-up iconfont luckysheet-iconfont-wenbenxiangshang" style="user-select: none;"> </div> </div>',
                    },
                    {
                        text: locale_rotation.rotationDown,
                        value: "rotation-down",
                        example:
                            '<div class="luckysheet-icon luckysheet-inline-block" style="user-select: none;opacity:1;"> <div aria-hidden="true" class="luckysheet-icon-img-container luckysheet-icon-img luckysheet-icon-rotation-rotation-down iconfont luckysheet-iconfont-xiangxia90" style="user-select: none;"> </div> </div>',
                    },
                ];

                // itemvalue to iconfont
                const iconfontObject = iconfontObjects.rotation;

                let itemset = _this.createButtonMenu(itemdata);

                let menu = replaceHtml(_this.menu, { id: "rotation-menu", item: itemset, subclass: "", sub: "", });

                $(`#${containerId}`).append(menu);

                // 文字旋转总 Stack Vertically 太长了，拉宽到160
                $menuButton = currentInstance.find("#" + menuButtonId).width(160);
                _this.focus($menuButton);

                $menuButton.find(".luckysheet-cols-menuitem").click(function () {
                    $menuButton.hide();
                    instance.util.luckysheetContainerFocus();

                    let $t = $(this),
                        itemvalue = $t.attr("itemvalue");
                    _this.focus($menuButton, itemvalue);

                    let $icon = currentInstance.find("#luckysheet-icon-rotation")
                        .attr("type", itemvalue)
                        .find(".luckysheet-icon-img-container");

                    // add iconfont
                    $icon
                        .removeAttr("class")
                        .addClass(
                            "luckysheet-icon-img-container luckysheet-icon-img luckysheet-icon-rotation-" +
                            itemvalue +
                            iconfontObject[itemvalue],
                        );

                    let d = instance.editor.deepCopyFlowData(Store.flowdata);
                    _this.updateFormat(containerId, d, "tr", itemvalue);
                });
            }

            let userlen = $(this).outerWidth() * Store.scale;
            let tlen = $menuButton.outerWidth() * Store.scale;

            let menuleft = $(this).offset().left;
            if (tlen > userlen && tlen + menuleft > $("#" + Store.container).width() * Store.scale) {
                menuleft = menuleft - tlen + userlen;
            }
            instance.util.mouseclickposition($menuButton, menuleft - 28 * Store.scale, $(this).offset().top + 25 * Store.scale, "lefttop");
        });

        //冻结行列
        currentInstance.find("#luckysheet-icon-freezen-menu").click(function() {
        // $(document).off(`click.freezen-menu-${containerId}`).on(`click.freezen-menu-${containerId}`, `#${containerId} #luckysheet-icon-freezen-menu`, function() {
            let menuButtonId = $(this).attr("id") + "-menuButton";
            let $menuButton = currentInstance.find("#" + menuButtonId);

            if ($menuButton.length == 0) {
                const _locale = instance.locale();
                const locale_freezen = _locale.freezen;
                let itemdata = [
                    { text: locale_freezen.freezenRow, value: "freezenRow", example: "" },
                    { text: locale_freezen.freezenColumn, value: "freezenColumn", example: "" },
                    { text: locale_freezen.freezenRC, value: "freezenRC", example: "" },
                    { text: "", value: "split", example: "" },
                    { text: locale_freezen.freezenRowRange, value: "freezenRowRange", example: "" },
                    { text: locale_freezen.freezenColumnRange, value: "freezenColumnRange", example: "" },
                    { text: locale_freezen.freezenRCRange, value: "freezenRCRange", example: "" },
                    { text: "", value: "split", example: "" },
                    { text: locale_freezen.freezenCancel, value: "freezenCancel", example: "" },
                ];

                let itemset = _this.createButtonMenu(itemdata);

                let menu = replaceHtml(_this.menu, { id: "freezen-menu", item: itemset, subclass: "", sub: "", });

                $(`#${containerId}`).append(menu);
                $menuButton = currentInstance.find("#" + menuButtonId).width(170);

                $menuButton.find(".luckysheet-cols-menuitem").click(function () {
                    $menuButton.hide();
                    instance.util.luckysheetContainerFocus();

                    let $t = $(this),
                        itemvalue = $t.attr("itemvalue");
                    _this.focus($menuButton, itemvalue);
                    if (itemvalue === "freezenCancel") {
                        $menuButton.find(".fa.fa-check").remove();
                    }

                    // store frozen
                    instance.freezen.saveFrozen(itemvalue);

                    if (itemvalue == "freezenRow") {
                        //首行冻结
                        instance.api.frozenFirstRow();
                        // let scrollTop = currentInstance.find("#luckysheet-cell-main").scrollTop();
                        // let row_st = luckysheet_searcharray(Store.visibledatarow, scrollTop);
                        // if(row_st == -1){
                        //     row_st = 0;
                        // }
                        // let top = Store.visibledatarow[row_st] - 2 - scrollTop + Store.columnHeaderHeight;
                        // let freezenhorizontaldata = [Store.visibledatarow[row_st], row_st + 1, scrollTop, instance.freezen.cutVolumn(Store.visibledatarow, row_st + 1), top];
                        // instance.freezen.saveFreezen(freezenhorizontaldata, top, null, null);

                        // if (instance.freezen.freezenverticaldata != null) {
                        //     instance.freezen.cancelFreezenVertical();
                        //     instance.freezen.createAssistCanvas();
                        //     luckysheetrefreshgrid();
                        // }

                        // instance.freezen.createFreezenHorizontal(freezenhorizontaldata, top);
                        // instance.freezen.createAssistCanvas();
                        // luckysheetrefreshgrid();
                    } else if (itemvalue == "freezenColumn") {
                        //首列冻结
                        instance.api.frozenFirstColumn();
                        // let scrollLeft = currentInstance.find("#luckysheet-cell-main").scrollLeft();
                        // let col_st = luckysheet_searcharray(Store.visibledatacolumn, scrollLeft);
                        // if(col_st == -1){
                        //     col_st = 0;
                        // }
                        // let left = Store.visibledatacolumn[col_st] - 2 - scrollLeft + Store.rowHeaderWidth;
                        // let freezenverticaldata = [Store.visibledatacolumn[col_st], col_st + 1, scrollLeft, instance.freezen.cutVolumn(Store.visibledatacolumn, col_st + 1), left];
                        // instance.freezen.saveFreezen(null, null, freezenverticaldata, left);

                        // if (instance.freezen.freezenhorizontaldata != null) {
                        //     instance.freezen.cancelFreezenHorizontal();
                        //     instance.freezen.createAssistCanvas();
                        //     luckysheetrefreshgrid();
                        // }

                        // instance.freezen.createFreezenVertical(freezenverticaldata, left);
                        // instance.freezen.createAssistCanvas();
                        // luckysheetrefreshgrid();
                    } else if (itemvalue == "freezenRC") {
                        //首行列冻结
                        if (instance.freezen.freezenRealFirstRowColumn) {
                            let row_st = 0;
                            let top = Store.visibledatarow[row_st] - 2 + Store.columnHeaderHeight;
                            let freezenhorizontaldata = [
                                Store.visibledatarow[row_st],
                                row_st + 1,
                                0,
                                instance.freezen.cutVolumn(Store.visibledatarow, row_st + 1),
                                top,
                            ];
                            instance.freezen.saveFreezen(freezenhorizontaldata, top, null, null);

                            instance.freezen.createFreezenHorizontal(freezenhorizontaldata, top);

                            let col_st = 0;
                            let left = Store.visibledatacolumn[col_st] - 2 + Store.rowHeaderWidth;
                            let freezenverticaldata = [
                                Store.visibledatacolumn[col_st],
                                col_st + 1,
                                0,
                                instance.freezen.cutVolumn(Store.visibledatacolumn, col_st + 1),
                                left,
                            ];
                            instance.freezen.saveFreezen(null, null, freezenverticaldata, left);

                            instance.freezen.createFreezenVertical(freezenverticaldata, left);
                        } else {
                            let scrollTop = currentInstance.find("#luckysheet-cell-main").scrollTop();
                            let row_st = luckysheet_searcharray(Store.visibledatarow, scrollTop);
                            if (row_st == -1) {
                                row_st = 0;
                            }
                            let top = Store.visibledatarow[row_st] - 2 - scrollTop + Store.columnHeaderHeight;
                            let freezenhorizontaldata = [
                                Store.visibledatarow[row_st],
                                row_st + 1,
                                scrollTop,
                                instance.freezen.cutVolumn(Store.visibledatarow, row_st + 1),
                                top,
                            ];
                            instance.freezen.saveFreezen(freezenhorizontaldata, top, null, null);

                            instance.freezen.createFreezenHorizontal(freezenhorizontaldata, top);

                            let scrollLeft = currentInstance.find("#luckysheet-cell-main").scrollLeft();
                            let col_st = luckysheet_searcharray(Store.visibledatacolumn, scrollLeft);
                            if (col_st == -1) {
                                col_st = 0;
                            }
                            let left = Store.visibledatacolumn[col_st] - 2 - scrollLeft + Store.rowHeaderWidth;
                            let freezenverticaldata = [
                                Store.visibledatacolumn[col_st],
                                col_st + 1,
                                scrollLeft,
                                instance.freezen.cutVolumn(Store.visibledatacolumn, col_st + 1),
                                left,
                            ];
                            instance.freezen.saveFreezen(null, null, freezenverticaldata, left);

                            instance.freezen.createFreezenVertical(freezenverticaldata, left);
                        }
                        instance.freezen.createAssistCanvas();
                        instance.refresh.luckysheetrefreshgrid();
                    } else if (itemvalue == "freezenRowRange") {
                        //选区行冻结

                        if (Store.luckysheet_select_save == null || Store.luckysheet_select_save.length == 0) {
                            if (instance.validate.isEditMode()) {
                                alert(locale_freezen.noSeletionError);
                            } else {
                                instance.tooltip.info(locale_freezen.noSeletionError, "");
                            }

                            return;
                        }
                        // 固定超出屏幕范围
                        let rangeTop = Store.luckysheet_select_save[Store.luckysheet_select_save.length - 1].top;
                        if (
                            instance.freezen.freezenRealFirstRowColumn &&
                            rangeTop > currentInstance.find("#luckysheet-cell-main").height()
                        ) {
                            return instance.tooltip.info(locale_freezen.rangeRCOverErrorTitle, locale_freezen.rangeRCOverError);
                        }
                        let scrollTop = currentInstance.find("#luckysheet-cell-main").scrollTop();
                        let row_st = luckysheet_searcharray(Store.visibledatarow, scrollTop);

                        let last = Store.luckysheet_select_save[Store.luckysheet_select_save.length - 1];
                        let row_focus = last["row_focus"] == null ? last["row"][0] : last["row_focus"];
                        row_st = Math.max(row_st - 1, row_focus - 1, 0);

                        let top, freezenhorizontaldata;
                        if (instance.freezen.freezenRealFirstRowColumn) {
                            top = Store.visibledatarow[row_st] - 2 + Store.columnHeaderHeight;
                            freezenhorizontaldata = [
                                Store.visibledatarow[row_st],
                                row_st + 1,
                                0,
                                instance.freezen.cutVolumn(Store.visibledatarow, row_st + 1),
                                top,
                            ];
                        } else {
                            top = Store.visibledatarow[row_st] - 2 - scrollTop + Store.columnHeaderHeight;
                            freezenhorizontaldata = [
                                Store.visibledatarow[row_st],
                                row_st + 1,
                                scrollTop,
                                instance.freezen.cutVolumn(Store.visibledatarow, row_st + 1),
                                top,
                            ];
                        }
                        instance.freezen.saveFreezen(freezenhorizontaldata, top, null, null);

                        if (instance.freezen.freezenverticaldata != null) {
                            instance.freezen.cancelFreezenVertical();
                            instance.freezen.createAssistCanvas();
                            instance.refresh.luckysheetrefreshgrid();
                        }

                        instance.freezen.createFreezenHorizontal(freezenhorizontaldata, top);
                        instance.freezen.createAssistCanvas();
                        instance.refresh.luckysheetrefreshgrid();
                    } else if (itemvalue == "freezenColumnRange") {
                        //选区列冻结
                        if (Store.luckysheet_select_save == null || Store.luckysheet_select_save.length == 0) {
                            if (instance.validate.isEditMode()) {
                                alert(locale_freezen.noSeletionError);
                            } else {
                                instance.tooltip.info(locale_freezen.noSeletionError, "");
                            }

                            return;
                        }
                        // 固定超出屏幕范围
                        let rangeLeft = Store.luckysheet_select_save[Store.luckysheet_select_save.length - 1].left;
                        if (
                            instance.freezen.freezenRealFirstRowColumn &&
                            rangeLeft > currentInstance.find("#luckysheet-cell-main").width()
                        ) {
                            return instance.tooltip.info(locale_freezen.rangeRCOverErrorTitle, locale_freezen.rangeRCOverError);
                        }
                        let scrollLeft = currentInstance.find("#luckysheet-cell-main").scrollLeft();
                        let col_st = luckysheet_searcharray(Store.visibledatacolumn, scrollLeft);

                        let last = Store.luckysheet_select_save[Store.luckysheet_select_save.length - 1];
                        let column_focus = last["column_focus"] == null ? last["column"][0] : last["column_focus"];
                        col_st = Math.max(col_st - 1, column_focus - 1, 0);

                        let left, freezenverticaldata;
                        if (instance.freezen.freezenRealFirstRowColumn) {
                            left = Store.visibledatacolumn[col_st] - 2 + Store.rowHeaderWidth;
                            freezenverticaldata = [
                                Store.visibledatacolumn[col_st],
                                col_st + 1,
                                0,
                                instance.freezen.cutVolumn(Store.visibledatacolumn, col_st + 1),
                                left,
                            ];
                        } else {
                            left = Store.visibledatacolumn[col_st] - 2 - scrollLeft + Store.rowHeaderWidth;
                            freezenverticaldata = [
                                Store.visibledatacolumn[col_st],
                                col_st + 1,
                                scrollLeft,
                                instance.freezen.cutVolumn(Store.visibledatacolumn, col_st + 1),
                                left,
                            ];
                        }
                        instance.freezen.saveFreezen(null, null, freezenverticaldata, left);

                        if (instance.freezen.freezenhorizontaldata != null) {
                            instance.freezen.cancelFreezenHorizontal();
                            instance.freezen.createAssistCanvas();
                            instance.refresh.luckysheetrefreshgrid();
                        }

                        instance.freezen.createFreezenVertical(freezenverticaldata, left);
                        instance.freezen.createAssistCanvas();
                        instance.refresh.luckysheetrefreshgrid();
                    } else if (itemvalue == "freezenRCRange") {
                        //选区行列冻结
                        if (Store.luckysheet_select_save == null || Store.luckysheet_select_save.length == 0) {
                            if (instance.validate.isEditMode()) {
                                alert(locale_freezen.noSeletionError);
                            } else {
                                instance.tooltip.info(locale_freezen.noSeletionError, "");
                            }

                            return;
                        }

                        // 固定超出屏幕范围
                        let rangeTop = Store.luckysheet_select_save[Store.luckysheet_select_save.length - 1].top;
                        let rangeLeft = Store.luckysheet_select_save[Store.luckysheet_select_save.length - 1].left;
                        if (
                            instance.freezen.freezenRealFirstRowColumn &&
                            (rangeTop > currentInstance.find("#luckysheet-cell-main").height() ||
                                rangeLeft > currentInstance.find("#luckysheet-cell-main").width())
                        ) {
                            return instance.tooltip.info(locale_freezen.rangeRCOverErrorTitle, locale_freezen.rangeRCOverError);
                        }

                        let scrollTop = currentInstance.find("#luckysheet-cell-main").scrollTop();
                        let row_st = luckysheet_searcharray(Store.visibledatarow, scrollTop);

                        let last = Store.luckysheet_select_save[Store.luckysheet_select_save.length - 1];
                        let row_focus = last["row_focus"] == null ? last["row"][0] : last["row_focus"];
                        row_st = Math.max(row_st - 1, row_focus - 1, 0);

                        let top, freezenhorizontaldata;
                        if (instance.freezen.freezenRealFirstRowColumn) {
                            top = Store.visibledatarow[row_st] - 2 + Store.columnHeaderHeight;
                            freezenhorizontaldata = [
                                Store.visibledatarow[row_st],
                                row_st + 1,
                                0,
                                instance.freezen.cutVolumn(Store.visibledatarow, row_st + 1),
                                top,
                            ];
                            instance.freezen.saveFreezen(freezenhorizontaldata, top, null, null);
                        } else {
                            top = Store.visibledatarow[row_st] - 2 - scrollTop + Store.columnHeaderHeight;
                            freezenhorizontaldata = [
                                Store.visibledatarow[row_st],
                                row_st + 1,
                                scrollTop,
                                instance.freezen.cutVolumn(Store.visibledatarow, row_st + 1),
                                top,
                            ];
                            instance.freezen.saveFreezen(freezenhorizontaldata, top, null, null);
                        }

                        instance.freezen.createFreezenHorizontal(freezenhorizontaldata, top);

                        let scrollLeft = currentInstance.find("#luckysheet-cell-main").scrollLeft();
                        let col_st = luckysheet_searcharray(Store.visibledatacolumn, scrollLeft);

                        let column_focus = last["column_focus"] == null ? last["column"][0] : last["column_focus"];
                        col_st = Math.max(col_st - 1, column_focus - 1, 0);

                        let left, freezenverticaldata;
                        if (instance.freezen.freezenRealFirstRowColumn) {
                            left = Store.visibledatacolumn[col_st] - 2 + Store.rowHeaderWidth;
                            freezenverticaldata = [
                                Store.visibledatacolumn[col_st],
                                col_st + 1,
                                0,
                                instance.freezen.cutVolumn(Store.visibledatacolumn, col_st + 1),
                                left,
                            ];
                        } else {
                            left = Store.visibledatacolumn[col_st] - 2 - scrollLeft + Store.rowHeaderWidth;
                            freezenverticaldata = [
                                Store.visibledatacolumn[col_st],
                                col_st + 1,
                                scrollLeft,
                                instance.freezen.cutVolumn(Store.visibledatacolumn, col_st + 1),
                                left,
                            ];
                        }
                        instance.freezen.saveFreezen(null, null, freezenverticaldata, left);

                        instance.freezen.createFreezenVertical(freezenverticaldata, left);

                        instance.freezen.createAssistCanvas();
                        instance.refresh.luckysheetrefreshgrid();
                    } else if (itemvalue == "freezenCancel") {
                        //Cancel freezen
                        if (instance.freezen.freezenverticaldata != null) {
                            instance.freezen.cancelFreezenVertical();
                            instance.freezen.createAssistCanvas();
                            instance.refresh.luckysheetrefreshgrid();
                        }

                        if (instance.freezen.freezenhorizontaldata != null) {
                            instance.freezen.cancelFreezenHorizontal();
                            instance.freezen.createAssistCanvas();
                            instance.refresh.luckysheetrefreshgrid();
                        }

                        instance.freezen.scrollAdapt();
                    }

                    setTimeout(function () {
                        instance.resize.luckysheetsizeauto(true, containerId);
                    }, 0);
                });
            }

            let userlen = $(this).outerWidth() * Store.scale;
            let tlen = $menuButton.outerWidth() * Store.scale;

            let menuleft = $(this).offset().left;
            if (tlen > userlen && tlen + menuleft > $("#" + Store.container).width() * Store.scale) {
                menuleft = menuleft - tlen + userlen;
            }
            instance.util.mouseclickposition($menuButton, menuleft - 68 * Store.scale, $(this).offset().top + 25 * Store.scale, "lefttop");
        });

        //过滤和排序
        currentInstance.find("#luckysheet-icon-autofilter").click(function() {
        // $(document).off(`click.autofilter-${containerId}`).on(`click.autofilter-${containerId}`, `#${containerId} #luckysheet-icon-autofilter`, function() {
            let menuButtonId = $(this).attr("id") + "-menuButton";
            let $menuButton = currentInstance.find("#" + menuButtonId);

            if ($menuButton.length == 0) {
                const _locale = instance.locale();
                const locale_sort = _locale.sort;
                const locale_filter = _locale.filter;
                let itemdata = [
                    {
                        text: locale_sort.asc,
                        value: "asc",
                        example: '<i class="iconfont luckysheet-iconfont-shengxu" aria-hidden="true"></i>',
                    },
                    {
                        text: locale_sort.desc,
                        value: "desc",
                        example: '<i class="iconfont luckysheet-iconfont-jiangxu" aria-hidden="true"></i>',
                    },
                    {
                        text: locale_sort.custom + "...",
                        value: "diysort",
                        example: '<i class="iconfont luckysheet-iconfont-zidingyipaixu" aria-hidden="true"></i>',
                    },
                    { text: "", value: "split", example: "" },
                    {
                        text: locale_filter.filter,
                        value: "filter",
                        example: '<i class="iconfont luckysheet-iconfont-shaixuan2" aria-hidden="true"></i>',
                    },
                    {
                        text: locale_filter.clearFilter,
                        value: "clearfilter",
                        example: '<i class="iconfont luckysheet-iconfont-qingchushaixuan" aria-hidden="true"></i>',
                    },
                ];

                let itemset = _this.createButtonMenu(itemdata);

                let menu = replaceHtml(_this.menu, { id: "autofilter", item: itemset, subclass: "", sub: "", });

                $(`#${containerId}`).append(menu);
                $menuButton = currentInstance.find("#" + menuButtonId).width(150);

                $menuButton.find(".luckysheet-cols-menuitem").click(function () {
                    $menuButton.hide();
                    instance.util.luckysheetContainerFocus();

                    let $t = $(this),
                        itemvalue = $t.attr("itemvalue");

                    if (itemvalue == "diysort") {
                        currentInstance.find("#luckysheetorderby").click();
                    } else if (itemvalue == "asc") {
                        instance.sort.sortSelection(true);
                    } else if (itemvalue == "desc") {
                        instance.sort.sortSelection(false);
                    } else if (itemvalue == "filter") {
                        if (currentInstance.find("#luckysheet-filter-options-sheet" + Store.currentSheetIndex).length > 0) {
                            currentInstance.find("#luckysheet-filter-initial").click();
                        } else {
                            instance.filter.createFilter();
                        }
                    } else if (itemvalue == "clearfilter") {
                        currentInstance.find("#luckysheet-filter-initial").click();
                    }
                });
            }

            let userlen = $(this).outerWidth() * Store.scale;
            let tlen = $menuButton.outerWidth() * Store.scale;

            let menuleft = $(this).offset().left;
            if (tlen > userlen && tlen + menuleft > $("#" + Store.container).width() * Store.scale) {
                menuleft = menuleft - tlen + userlen;
            }
            instance.util.mouseclickposition($menuButton, menuleft, $(this).offset().top + 25 * Store.scale, "lefttop");
        });

        //查找和替换
        currentInstance.find("#luckysheet-icon-seachmore").click(function() {
        // $(document).off(`click.seachmore-${containerId}`).on(`click.seachmore-${containerId}`, `#${containerId} #luckysheet-icon-seachmore`, function() {
            let menuButtonId = $(this).attr("id") + "-menuButton";
            let $menuButton = currentInstance.find("#" + menuButtonId);
            const _locale = instance.locale();
            const locale_findAndReplace = _locale.findAndReplace;
            if ($menuButton.length == 0) {
                let itemdata = [
                    {
                        text: locale_findAndReplace.find + " ...",
                        value: "search",
                        example: '<i class="iconfont luckysheet-iconfont-sousuo" aria-hidden="true"></i>',
                    },
                    {
                        text: locale_findAndReplace.replace + " ...",
                        value: "replace",
                        example: '<i class="iconfont luckysheet-iconfont-tihuan" aria-hidden="true"></i>',
                    },
                    // {"text": locale_findAndReplace.goto+" ...", "value": "goto", "example": '<i class="iconfont luckysheet-iconfont-zhuandao1" aria-hidden="true"></i>'},
                    { text: "", value: "split", example: "" },
                    {
                        text: locale_findAndReplace.location + " ...",
                        value: "location",
                        example: '<i class="iconfont luckysheet-iconfont-dingwei" aria-hidden="true"></i>',
                    },
                    {
                        text: locale_findAndReplace.formula,
                        value: "locationFormula",
                        example: locale_findAndReplace.locationExample,
                    },
                    {
                        text: locale_findAndReplace.date,
                        value: "locationConstantDate",
                        example: locale_findAndReplace.locationExample,
                    },
                    {
                        text: locale_findAndReplace.number,
                        value: "locationConstantNumber",
                        example: locale_findAndReplace.locationExample,
                    },
                    {
                        text: locale_findAndReplace.string,
                        value: "locationConstantString",
                        example: locale_findAndReplace.locationExample,
                    },
                    {
                        text: locale_findAndReplace.error,
                        value: "locationConstantError",
                        example: locale_findAndReplace.locationExample,
                    },
                    {
                        text: locale_findAndReplace.condition,
                        value: "locationCF",
                        example: locale_findAndReplace.locationExample,
                    },
                    {
                        text: locale_findAndReplace.rowSpan,
                        value: "locationStepRow",
                        example: locale_findAndReplace.locationExample,
                    },
                    {
                        text: locale_findAndReplace.columnSpan,
                        value: "locationStepColumn",
                        example: locale_findAndReplace.locationExample,
                    },
                ];

                let itemset = _this.createButtonMenu(itemdata);

                let menu = replaceHtml(_this.menu, { id: "seachmore", item: itemset, subclass: "", sub: "", });

                $(`#${containerId}`).append(menu);
                $menuButton = currentInstance.find("#" + menuButtonId).width(180);

                $menuButton.find(".luckysheet-cols-menuitem").click(function () {
                    $menuButton.hide();
                    instance.util.luckysheetContainerFocus();

                    let $t = $(this),
                        itemvalue = $t.attr("itemvalue");

                    if (itemvalue == "search" || itemvalue == "replace") {
                        //查找替换
                        if (itemvalue == "search") {
                            instance.searchReplace.createDialog(0, containerId);
                        } else if (itemvalue == "replace") {
                            instance.searchReplace.createDialog(1, containerId);
                        }

                        instance.searchReplace.init(containerId);

                        currentInstance.find(`#luckysheet-search-replace #searchInput input`).focus();
                    } else if (itemvalue == "location") {
                        //定位条件
                        instance.locationCell.createDialog();
                        instance.locationCell.init();
                    } else if (
                        itemvalue == "locationFormula" ||
                        itemvalue == "locationConstantDate" ||
                        itemvalue == "locationConstantNumber" ||
                        itemvalue == "locationConstantString" ||
                        itemvalue == "locationConstantError" ||
                        itemvalue == "locationCF"
                    ) {
                        let last = Store.luckysheet_select_save[0];

                        let range;
                        if (
                            Store.luckysheet_select_save.length == 0 ||
                            (Store.luckysheet_select_save.length == 1 &&
                                last.row[0] == last.row[1] &&
                                last.column[0] == last.column[1])
                        ) {
                            //单个单元格
                            range = [
                                { row: [0, Store.flowdata.length - 1], column: [0, Store.flowdata[0].length - 1] },
                            ];
                        } else {
                            range = $.extend(true, [], Store.luckysheet_select_save);
                        }

                        if (itemvalue == "locationFormula") {
                            //公式
                            instance.locationCell.apply(range, "locationFormula", "all");
                        } else if (itemvalue == "locationConstantDate") {
                            //日期
                            instance.locationCell.apply(range, "locationConstant", "d");
                        } else if (itemvalue == "locationConstantNumber") {
                            //数字
                            instance.locationCell.apply(range, "locationConstant", "n");
                        } else if (itemvalue == "locationConstantString") {
                            //字符
                            instance.locationCell.apply(range, "locationConstant", "s,g");
                        } else if (itemvalue == "locationConstantError") {
                            //错误
                            instance.locationCell.apply(range, "locationConstant", "e");
                        } else if (itemvalue == "locationCF") {
                            //条件格式
                            instance.locationCell.apply(range, "locationCF");
                        }
                    } else if (itemvalue == "locationStepRow") {
                        //间隔行
                        if (
                            Store.luckysheet_select_save.length == 0 ||
                            (Store.luckysheet_select_save.length == 1 &&
                                Store.luckysheet_select_save[0].row[0] == Store.luckysheet_select_save[0].row[1])
                        ) {
                            if (instance.validate.isEditMode()) {
                                alert(locale_findAndReplace.lessTwoRowTip);
                            } else {
                                instance.tooltip.info("", locale_findAndReplace.lessTwoRowTip);
                            }
                            return;
                        }

                        let range = $.extend(true, [], Store.luckysheet_select_save);

                        instance.locationCell.apply(range, "locationStepRow");
                    } else if (itemvalue == "locationStepColumn") {
                        //间隔列
                        if (
                            Store.luckysheet_select_save.length == 0 ||
                            (Store.luckysheet_select_save.length == 1 &&
                                Store.luckysheet_select_save[0].column[0] == Store.luckysheet_select_save[0].column[1])
                        ) {
                            if (instance.validate.isEditMode()) {
                                alert(locale_findAndReplace.lessTwoColumnTip);
                            } else {
                                instance.tooltip.info("", locale_findAndReplace.lessTwoColumnTip);
                            }
                            return;
                        }

                        let range = $.extend(true, [], Store.luckysheet_select_save);

                        instance.locationCell.apply(range, "locationStepColumn");
                    }
                });
            }

            let userlen = $(this).outerWidth() * Store.scale;
            let tlen = $menuButton.outerWidth() * Store.scale;

            let menuleft = $(this).offset().left;
            if (tlen > userlen && tlen + menuleft > $("#" + Store.container).width() * Store.scale) {
                menuleft = menuleft - tlen + userlen;
            }
            instance.util.mouseclickposition($menuButton, menuleft, $(this).offset().top + 25 * Store.scale, "lefttop");
        });

        //公式
        currentInstance.find("#luckysheet-icon-function").click(function() {
        // $(document).off(`click.function-${containerId}`).on(`click.function-${containerId}`, `#${containerId} #luckysheet-icon-function`, function() {
            _this.autoSelectionFormula(containerId, "SUM");
        });

        //公式菜单
        currentInstance.find("#luckysheet-icon-function-menu").click(function() {
        // $(document).off(`click.function-menu-${containerId}`).on(`click.function-menu-${containerId}`, `#${containerId} #luckysheet-icon-function-menu`, function() {
            let menuButtonId = $(this).attr("id") + "-menuButton";
            let $menuButton = currentInstance.find("#" + menuButtonId);

            const _locale = instance.locale();
            const locale_formula = _locale.formula;

            if ($menuButton.length == 0) {
                let itemdata = [
                    { text: locale_formula.sum, value: "SUM", example: "SUM" },
                    { text: locale_formula.average, value: "AVERAGE", example: "AVERAGE" },
                    { text: locale_formula.count, value: "COUNT", example: "COUNT" },
                    { text: locale_formula.max, value: "MAX", example: "MAX" },
                    { text: locale_formula.min, value: "MIN", example: "MIN" },
                    { text: "", value: "split", example: "" },
                    { text: locale_formula.ifGenerate, value: "if", example: "IF" },
                    { text: locale_formula.find + " ...", value: "formula", example: "" },
                ];

                let itemset = _this.createButtonMenu(itemdata);

                let menu = replaceHtml(_this.menu, { id: "function-menu", item: itemset, subclass: "", sub: "", });

                $(`#${containerId}`).append(menu);
                $menuButton = currentInstance.find("#" + menuButtonId).width(180);

                $menuButton.find(".luckysheet-cols-menuitem").click(function () {
                    $menuButton.hide();
                    instance.util.luckysheetContainerFocus();

                    let $t = $(this),
                        itemvalue = $t.attr("itemvalue");

                    if (itemvalue == "if") {
                        let last = Store.luckysheet_select_save[Store.luckysheet_select_save.length - 1];
                        let r = last["row_focus"] == null ? last["row"][0] : last["row_focus"];
                        let c = last["column_focus"] == null ? last["column"][0] : last["column_focus"];

                        if (!!Store.flowdata[r] && !!Store.flowdata[r][c] && !!Store.flowdata[r][c]["f"]) {
                            let fp = Store.flowdata[r][c]["f"].toString();

                            if (fp.indexOf("=if(") != -1) {
                                instance.ifFormulaGenerator.ifFormulaDialog(fp, containerId);
                            } else {
                                if (instance.validate.isEditMode()) {
                                    alert(locale_formula.tipNotBelongToIf);
                                } else {
                                    instance.tooltip.info(locale_formula.tipNotBelongToIf, "");
                                }
                                return;
                            }
                        } else {
                            instance.ifFormulaGenerator.ifFormulaDialog('', containerId);
                        }

                        instance.ifFormulaGenerator.init();
                    } else if (itemvalue == "formula") {
                        //点击函数查找弹出框
                        if (Store.luckysheet_select_save.length == 0) {
                            if (instance.validate.isEditMode()) {
                                alert(locale_formula.tipSelectCell);
                            } else {
                                instance.tooltip.info(locale_formula.tipSelectCell, "");
                            }

                            return;
                        }

                        let last = Store.luckysheet_select_save[Store.luckysheet_select_save.length - 1];

                        let row_index = last["row_focus"],
                            col_index = last["column_focus"];

                        instance.updateCell.luckysheetupdateCell(row_index, col_index, Store.flowdata);

                        let cell = Store.flowdata[row_index][col_index];
                        if (cell != null && cell.f != null) {
                            //单元格有计算
                            let functionStr = instance.formula.getfunctionParam(cell.f);
                            if (functionStr.fn != null) {
                                //有函数公式
                                instance.insertFormula.formulaParmDialog(functionStr.fn, functionStr.param, containerId);
                            } else {
                                //无函数公式
                                instance.insertFormula.formulaListDialog(containerId);
                            }
                        } else {
                            //单元格无计算
                            currentInstance.find("#luckysheet-rich-text-editor").html(
                                '<span dir="auto" class="luckysheet-formula-text-color">=</span>',
                            );
                            currentInstance.find("#luckysheet-functionbox-cell").html(currentInstance.find("#luckysheet-rich-text-editor").html());
                            instance.insertFormula.formulaListDialog(containerId);
                        }

                        instance.insertFormula.init();
                    } else {
                        _this.autoSelectionFormula(containerId, itemvalue);
                    }
                });
            }

            let userlen = $(this).outerWidth() * Store.scale;
            let tlen = $menuButton.outerWidth() * Store.scale;

            let menuleft = $(this).offset().left;
            if (tlen > userlen && tlen + menuleft > $("#" + Store.container).width() * Store.scale) {
                menuleft = menuleft - tlen + userlen;
            }
            instance.util.mouseclickposition($menuButton, menuleft - 48 * Store.scale, $(this).offset().top + 25 * Store.scale, "lefttop");
        });

        //加粗
        currentInstance.find("#luckysheet-icon-bold").mousedown(function(e) {
        // $(document).off(`mousedown.bold-${containerId}`).on(`mousedown.bold-${containerId}`, `#${containerId} #luckysheet-icon-bold`, function(e) {
            instance.cursorPos.hideMenuByCancel(e);
                e.stopPropagation();
            })
            .click(function(e) {
        // .off(`click.bold-${containerId}`).on(`click.bold-${containerId}`, `#${containerId} #luckysheet-icon-bold`, function(e) {
                let d = instance.editor.deepCopyFlowData(Store.flowdata);

                let flag = instance.api.checkTheStatusOfTheSelectedCells("bl", 1);
                let foucsStatus = flag ? 0 : 1;

                _this.updateFormat(containerId, d, "bl", foucsStatus);
            });

        //斜体
        currentInstance.find("#luckysheet-icon-italic").mousedown(function(e) {
        // $(document).off(`mousedown.italic-${containerId}`).on(`mousedown.italic-${containerId}`, `#${containerId} #luckysheet-icon-italic`, function(e) {
                instance.cursorPos.hideMenuByCancel(e);
                e.stopPropagation();
            })
            .click(function() {
            // .off(`click.italic-${containerId}`).on(`click.italic-${containerId}`, `#${containerId} #luckysheet-icon-italic`, function() {
                let d = instance.editor.deepCopyFlowData(Store.flowdata);

                let flag = instance.api.checkTheStatusOfTheSelectedCells("it", 1);
                let foucsStatus = flag ? 0 : 1;

                _this.updateFormat(containerId, d, "it", foucsStatus);
            });

        //删除线
        currentInstance.find("#luckysheet-icon-strikethrough").mousedown(function(e) {
        // $(document).off(`mousedown.strikethrough-${containerId}`).on(`mousedown.strikethrough-${containerId}`, `#${containerId} #luckysheet-icon-strikethrough`, function(e) {
                instance.cursorPos.hideMenuByCancel(e);
                e.stopPropagation();
            })
            .click(function() {
            // .off(`click.strikethrough-${containerId}`).on(`click.strikethrough-${containerId}`, `#${containerId} #luckysheet-icon-strikethrough`, function() {
                let d = instance.editor.deepCopyFlowData(Store.flowdata);
                let flag =instance.api.checkTheStatusOfTheSelectedCells("cl", 1);
                let foucsStatus = flag ? 0 : 1;

                _this.updateFormat(containerId, d, "cl", foucsStatus);
            });

        //下划线
        currentInstance.find("#luckysheet-icon-underline").mousedown(function(e) {
        // $(document).off(`mousedown.underline-${containerId}`).on(`mousedown.underline-${containerId}`, `#${containerId} #luckysheet-icon-underline`, function(e) {
                instance.cursorPos.hideMenuByCancel(e);
                e.stopPropagation();
            })
            .click(function() {
            // .off(`click.underline-${containerId}`).on(`click.underline-${containerId}`, `#${containerId} #luckysheet-icon-underline`, function() {
                let d = instance.editor.deepCopyFlowData(Store.flowdata);
                let flag =instance.api.checkTheStatusOfTheSelectedCells("un", 1);
                let foucsStatus = flag ? 0 : 1;

                _this.updateFormat(containerId, d, "un", foucsStatus);
            });

        //条件格式
        currentInstance.find("#luckysheet-icon-conditionformat").click(function() {
        // $(document).off(`click.conditionformat-${containerId}`).on(`click.conditionformat-${containerId}`, `#${containerId} #luckysheet-icon-conditionformat`, function() {
            let menuButtonId = $(this).attr("id") + "-menuButton";
            let $menuButton = currentInstance.find("#" + menuButtonId);

            const conditionformat_text = instance.locale().conditionformat;

            if ($menuButton.length == 0) {
                let itemdata = [
                    { text: conditionformat_text.highlightCellRules, value: "highlightCellRule", example: "more" },
                    { text: conditionformat_text.itemSelectionRules, value: "projectSelectRule", example: "more" },
                    { text: conditionformat_text.dataBar, value: "dataBar", example: "more" },
                    { text: conditionformat_text.colorGradation, value: "colorGradation", example: "more" },
                    { text: conditionformat_text.icons, value: "icons", example: "" },
                    { text: "", value: "split", example: "" },
                    { text: conditionformat_text.newRule, value: "newRule", example: "" },
                    { text: conditionformat_text.deleteRule, value: "deleteRule", example: "more" },
                    { text: conditionformat_text.manageRules, value: "administerRule", example: "" },
                ];
                let itemset = _this.createButtonMenu(itemdata);
                let menu = replaceHtml(_this.menu, { id: "conditionformat", item: itemset, subclass: "", sub: "", });

                //突出显示单元格规则子菜单
                let subitemdata = [
                    { text: conditionformat_text.greaterThan, value: "greaterThan", example: ">" },
                    { text: conditionformat_text.lessThan, value: "lessThan", example: "<" },
                    { text: conditionformat_text.between, value: "betweenness", example: "[]" },
                    { text: conditionformat_text.equal, value: "equal", example: "=" },
                    { text: conditionformat_text.textContains, value: "textContains", example: "()" },
                    {
                        text: conditionformat_text.occurrence,
                        value: "occurrenceDate",
                        example: conditionformat_text.yesterday,
                    },
                    { text: conditionformat_text.duplicateValue, value: "duplicateValue", example: "##" },
                ];
                let subitemset = _this.createButtonMenu(subitemdata);
                let submenu = replaceHtml(_this.menu, {
                    id: "highlightCellRule",
                    item: subitemset,
                    subclass: "luckysheet-menuButton-sub",
                });

                //项目选取规则子菜单
                let subitemdata2 = [
                    { text: conditionformat_text.top10, value: "top10", example: conditionformat_text.top10 },
                    {
                        text: conditionformat_text.top10_percent,
                        value: "top10%",
                        example: conditionformat_text.top10_percent,
                    },
                    { text: conditionformat_text.last10, value: "last10", example: conditionformat_text.last10 },
                    {
                        text: conditionformat_text.last10_percent,
                        value: "last10%",
                        example: conditionformat_text.last10_percent,
                    },
                    {
                        text: conditionformat_text.aboveAverage,
                        value: "AboveAverage",
                        example: conditionformat_text.above,
                    },
                    {
                        text: conditionformat_text.belowAverage,
                        value: "SubAverage",
                        example: conditionformat_text.below,
                    },
                ];
                let subitemset2 = _this.createButtonMenu(subitemdata2);
                let submenu2 = replaceHtml(_this.menu, {
                    id: "projectSelectRule",
                    item: subitemset2,
                    subclass: "luckysheet-menuButton-sub",
                });

                //数据条子菜单
                let submenu3 = `<div id="luckysheet-icon-dataBar-menuButton" class="luckysheet-icon-dataBar-menuButton luckysheet-cols-menu luckysheet-rightgclick-menu luckysheet-menuButton luckysheet-menuButton-sub luckysheet-mousedown-cancel" style="width: 126px;padding: 5px;top: 118.5px;left: 1321.48px;display: none;">
                                    <div itemvalue="0" class="luckysheet-cols-menuitem luckysheet-mousedown-cancel" style="width: 28px; height: 26px;padding: 5px;float: left;">
                                        <div class="luckysheet-mousedown-cancel bgImgBox" style="background-position: 0 0;" title="${conditionformat_text.gradientDataBar_1}"></div>
                                    </div>
                                    <div itemvalue="1" class="luckysheet-cols-menuitem luckysheet-mousedown-cancel" style="width: 28px; height: 26px;padding: 5px;float: left;">
                                        <div class="luckysheet-mousedown-cancel bgImgBox" style="background-position: -38px 0;" title="${conditionformat_text.gradientDataBar_2}"></div>
                                    </div>
                                    <div itemvalue="2" class="luckysheet-cols-menuitem luckysheet-mousedown-cancel" style="width: 28px; height: 26px;padding: 5px;float: left;">
                                        <div class="luckysheet-mousedown-cancel bgImgBox" style="background-position: -76px 0;" title="${conditionformat_text.gradientDataBar_3}"></div>
                                    </div>
                                    <div itemvalue="3" class="luckysheet-cols-menuitem luckysheet-mousedown-cancel" style="width: 28px; height: 26px;padding: 5px;float: left;">
                                        <div class="luckysheet-mousedown-cancel bgImgBox" style="background-position: 0 -36px;" title="${conditionformat_text.gradientDataBar_4}"></div>
                                    </div>
                                    <div itemvalue="4" class="luckysheet-cols-menuitem luckysheet-mousedown-cancel" style="width: 28px; height: 26px;padding: 5px;float: left;">
                                        <div class="luckysheet-mousedown-cancel bgImgBox" style="background-position: -38px -36px;" title="${conditionformat_text.gradientDataBar_5}"></div>
                                    </div>
                                    <div itemvalue="5" class="luckysheet-cols-menuitem luckysheet-mousedown-cancel" style="width: 28px; height: 26px;padding: 5px;float: left;">
                                        <div class="luckysheet-mousedown-cancel bgImgBox" style="background-position: -76px -36px;" title="${conditionformat_text.gradientDataBar_6}"></div>
                                    </div>
                                    <div itemvalue="6" class="luckysheet-cols-menuitem luckysheet-mousedown-cancel" style="width: 28px; height: 26px;padding: 5px;float: left;">
                                        <div class="luckysheet-mousedown-cancel bgImgBox" style="background-position: 0 -72px;" title="${conditionformat_text.solidColorDataBar_1}"></div>
                                    </div>
                                    <div itemvalue="7" class="luckysheet-cols-menuitem luckysheet-mousedown-cancel" style="width: 28px; height: 26px;padding: 5px;float: left;">
                                        <div class="luckysheet-mousedown-cancel bgImgBox" style="background-position: -38px -72px;" title="${conditionformat_text.solidColorDataBar_2}"></div>
                                    </div>
                                    <div itemvalue="8" class="luckysheet-cols-menuitem luckysheet-mousedown-cancel" style="width: 28px; height: 26px;padding: 5px;float: left;">
                                        <div class="luckysheet-mousedown-cancel bgImgBox" style="background-position: -76px -72px;" title="${conditionformat_text.solidColorDataBar_3}"></div>
                                    </div>
                                    <div itemvalue="9" class="luckysheet-cols-menuitem luckysheet-mousedown-cancel" style="width: 28px; height: 26px;padding: 5px;float: left;">
                                        <div class="luckysheet-mousedown-cancel bgImgBox" style="background-position: 0 -108px;" title="${conditionformat_text.solidColorDataBar_4}"></div>
                                    </div>
                                    <div itemvalue="10" class="luckysheet-cols-menuitem luckysheet-mousedown-cancel" style="width: 28px; height: 26px;padding: 5px;float: left;">
                                        <div class="luckysheet-mousedown-cancel bgImgBox" style="background-position: -38px -108px;" title="${conditionformat_text.solidColorDataBar_5}"></div>
                                    </div>
                                    <div itemvalue="11" class="luckysheet-cols-menuitem luckysheet-mousedown-cancel" style="width: 28px; height: 26px;padding: 5px;float: left;">
                                        <div class="luckysheet-mousedown-cancel bgImgBox" style="background-position: -76px -108px;" title="${conditionformat_text.solidColorDataBar_6}"></div>
                                    </div>
                                </div>`;

                //色阶
                let submenu4 = `<div id="luckysheet-icon-colorGradation-menuButton" class="luckysheet-icon-colorGradation-menuButton luckysheet-cols-menu luckysheet-rightgclick-menu luckysheet-menuButton luckysheet-menuButton-sub luckysheet-mousedown-cancel" style="width: 126px;padding: 5px;top: 143.5px;left: 1321.48px;display: none;">
                                    <div itemvalue="0" class="luckysheet-cols-menuitem luckysheet-mousedown-cancel" style="width: 28px; height: 26px;padding: 5px;float: left;">
                                        <div class="luckysheet-mousedown-cancel bgImgBox" style="background-position: 0 0;" title="${conditionformat_text.colorGradation_1}"></div>
                                    </div>
                                    <div itemvalue="1" class="luckysheet-cols-menuitem luckysheet-mousedown-cancel" style="width: 28px; height: 26px;padding: 5px;float: left;">
                                        <div class="luckysheet-mousedown-cancel bgImgBox" style="background-position: -38px 0;" title="${conditionformat_text.colorGradation_2}"></div>
                                    </div>
                                    <div itemvalue="2" class="luckysheet-cols-menuitem luckysheet-mousedown-cancel" style="width: 28px; height: 26px;padding: 5px;float: left;">
                                        <div class="luckysheet-mousedown-cancel bgImgBox" style="background-position: -76px 0;" title="${conditionformat_text.colorGradation_3}"></div>
                                    </div>
                                    <div itemvalue="3" class="luckysheet-cols-menuitem luckysheet-mousedown-cancel" style="width: 28px; height: 26px;padding: 5px;float: left;">
                                        <div class="luckysheet-mousedown-cancel bgImgBox" style="background-position: -114px 0;" title="${conditionformat_text.colorGradation_4}"></div>
                                    </div>
                                    <div itemvalue="4" class="luckysheet-cols-menuitem luckysheet-mousedown-cancel" style="width: 28px; height: 26px;padding: 5px;float: left;">
                                        <div class="luckysheet-mousedown-cancel bgImgBox" style="background-position: 0 -36px;" title="${conditionformat_text.colorGradation_5}"></div>
                                    </div>
                                    <div itemvalue="5" class="luckysheet-cols-menuitem luckysheet-mousedown-cancel" style="width: 28px; height: 26px;padding: 5px;float: left;">
                                        <div class="luckysheet-mousedown-cancel bgImgBox" style="background-position: -38px -36px;" title="${conditionformat_text.colorGradation_6}"></div>
                                    </div>
                                    <div itemvalue="6" class="luckysheet-cols-menuitem luckysheet-mousedown-cancel" style="width: 28px; height: 26px;padding: 5px;float: left;">
                                        <div class="luckysheet-mousedown-cancel bgImgBox" style="background-position: -76px -36px;" title="${conditionformat_text.colorGradation_7}"></div>
                                    </div>
                                    <div itemvalue="7" class="luckysheet-cols-menuitem luckysheet-mousedown-cancel" style="width: 28px; height: 26px;padding: 5px;float: left;">
                                        <div class="luckysheet-mousedown-cancel bgImgBox" style="background-position: -114px -36px;" title="${conditionformat_text.colorGradation_8}"></div>
                                    </div>
                                    <div itemvalue="8" class="luckysheet-cols-menuitem luckysheet-mousedown-cancel" style="width: 28px; height: 26px;padding: 5px;float: left;">
                                        <div class="luckysheet-mousedown-cancel bgImgBox" style="background-position: 0 -72px;" title="${conditionformat_text.colorGradation_9}"></div>
                                    </div>
                                    <div itemvalue="9" class="luckysheet-cols-menuitem luckysheet-mousedown-cancel" style="width: 28px; height: 26px;padding: 5px;float: left;">
                                        <div class="luckysheet-mousedown-cancel bgImgBox" style="background-position: -38px -72px;" title="${conditionformat_text.colorGradation_10}"></div>
                                    </div>
                                    <div itemvalue="10" class="luckysheet-cols-menuitem luckysheet-mousedown-cancel" style="width: 28px; height: 26px;padding: 5px;float: left;">
                                        <div class="luckysheet-mousedown-cancel bgImgBox" style="background-position: -76px -72px;" title="${conditionformat_text.colorGradation_11}"></div>
                                    </div>
                                    <div itemvalue="11" class="luckysheet-cols-menuitem luckysheet-mousedown-cancel" style="width: 28px; height: 26px;padding: 5px;float: left;">
                                        <div class="luckysheet-mousedown-cancel bgImgBox" style="background-position: -114px -72px;" title="${conditionformat_text.colorGradation_12}"></div>
                                    </div>
                                </div>`;

                //清除规则子菜单
                let subitemdata6 = [{ text: conditionformat_text.deleteSheetRule, value: "delSheet", example: "" }];
                let subitemset6 = _this.createButtonMenu(subitemdata6);
                let submenu6 = replaceHtml(_this.menu, {
                    id: "deleteRule",
                    item: subitemset6,
                    subclass: "luckysheet-menuButton-sub",
                });

                $(`#${containerId}`).append(menu + submenu + submenu2 + submenu3 + submenu4 + submenu6);
                $menuButton = currentInstance.find("#" + menuButtonId).width(190);
                currentInstance.find(`#luckysheet-icon-highlightCellRule-menuButton`).width(160);
                currentInstance.find(`#luckysheet-icon-projectSelectRule-menuButton`).width(180);

                $menuButton.find(".luckysheet-cols-menuitem").click(function () {
                    $menuButton.hide();
                    instance.util.luckysheetContainerFocus();

                    let $t = $(this),
                        itemvalue = $t.attr("itemvalue");

                    if (itemvalue == "icons") {
                        if (Store.luckysheet_select_save.length == 0) {
                            if (instance.validate.isEditMode()) {
                                alert(conditionformat_text.pleaseSelectRange);
                            } else {
                                instance.tooltip.info(conditionformat_text.pleaseSelectRange, "");
                            }
                            return;
                        }

                        instance.conditionformat.CFiconsDialog(containerId);
                        instance.conditionformat.init();
                    } else if (itemvalue == "newRule") {
                        if (Store.luckysheet_select_save.length == 0) {
                            if (instance.validate.isEditMode()) {
                                alert(conditionformat_text.pleaseSelectRange);
                            } else {
                                instance.tooltip.info(conditionformat_text.pleaseSelectRange, "");
                            }
                            return;
                        }

                        instance.conditionformat.newConditionRuleDialog(0, containerId);
                        instance.conditionformat.init();
                    } else if (itemvalue == "administerRule") {
                        let loadSheetUrl = instance.server.loadSheetUrl;
                        let file = instance.get.getluckysheetfile();

                        if (loadSheetUrl != "" && loadSheetUrl != null) {
                            let sheetindex = [];
                            for (let i = 0; i < file.length; i++) {
                                sheetindex.push(file[i].index);
                            }

                            $.post(loadSheetUrl, { gridKey: instance.server.gridKey, index: sheetindex.join(",") }, function (d) {
                                let dataset = new Function("return " + d)();

                                setTimeout(function () {
                                    // 去掉luckysheet渲染遮罩层 --modify by liluyao 2023/9/6
                                    // Store.loadingObj.close();
                                }, 500);

                                for (let item in dataset) {
                                    if (item == Store.currentSheetIndex) {
                                        continue;
                                    }

                                    let otherfile = file[instance.get.getSheetIndex(item)];

                                    otherfile.celldata = dataset[item.toString()];
                                    otherfile["data"] = _this.buildGridData(otherfile);
                                }

                                instance.set.setluckysheetfile(file);

                                instance.conditionformat.fileClone = $.extend(true, [], file);
                                instance.conditionformat.administerRuleDialog(containerId);
                                instance.conditionformat.init();
                            });
                        } else {
                            instance.conditionformat.fileClone = $.extend(true, [], file);
                            instance.conditionformat.administerRuleDialog(containerId);
                            instance.conditionformat.init();
                        }
                    }
                });

                //突出显示单元格规则子菜单点击事件
                currentInstance
                    .on(
                        "click.CFhighlightCellRule",
                        `#luckysheet-icon-highlightCellRule-menuButton .luckysheet-cols-menuitem`,
                        function () {
                            $menuButton.hide();
                            currentInstance.find(`#luckysheet-icon-highlightCellRule-menuButton`).hide();
                            instance.util.luckysheetContainerFocus();

                            let $t = $(this),
                                itemvalue = $t.attr("itemvalue");

                            if (Store.luckysheet_select_save.length == 0) {
                                if (instance.validate.isEditMode()) {
                                    alert(conditionformat_text.pleaseSelectRange);
                                } else {
                                    instance.tooltip.info(conditionformat_text.pleaseSelectRange, "");
                                }
                                return;
                            } else {
                                let textCellColorHtml = instance.conditionformat.textCellColorHtml();

                                let title, content;
                                switch (itemvalue) {
                                    case "greaterThan":
                                        title = conditionformat_text.conditionformat_greaterThan;
                                        content = `<div class="box" data-itemvalue="greaterThan">
                                                <div class="boxTitleOne">${conditionformat_text.conditionformat_greaterThan_title}：</div>
                                                <div class="inpbox range">
                                                    <input id="conditionVal" class="formulaInputFocus"/>
                                                    <i class="fa fa-table" aria-hidden="true" title="${conditionformat_text.selectCell}"></i>
                                                </div>
                                                <div style="margin: 5px 0;">${conditionformat_text.setAs}：</div> 
                                                ${textCellColorHtml} 
                                            </div>`;
                                        break;
                                    case "lessThan":
                                        title = conditionformat_text.conditionformat_lessThan;
                                        content = `<div class="box" data-itemvalue="lessThan">
                                                <div class="boxTitleOne">${conditionformat_text.conditionformat_lessThan_title}：</div>
                                                <div class="inpbox range">
                                                    <input id="conditionVal" class="formulaInputFocus"/>
                                                    <i class="fa fa-table" aria-hidden="true" title="${conditionformat_text.selectCell}"></i>
                                                </div>
                                                <div style="margin: 5px 0;">${conditionformat_text.setAs}：</div>
                                                ${textCellColorHtml}
                                            </div>`;
                                        break;
                                    case "betweenness":
                                        title = conditionformat_text.conditionformat_betweenness;
                                        content = `<div class="box" data-itemvalue="betweenness">
                                                <div class="boxTitleOne">${conditionformat_text.conditionformat_betweenness_title}：</div>
                                                <div style="height: 30px;line-height: 30px;">
                                                    <div class="inpbox2 range">
                                                        <input id="conditionVal" class="formulaInputFocus"/>
                                                        <i class="fa fa-table" aria-hidden="true" title="${conditionformat_text.selectCell}"></i>
                                                    </div>
                                                    <div style="float: left;height: 30px;line-height: 30px;margin: 0 5px;">${conditionformat_text.to}</div>
                                                    <div class="inpbox2 range">
                                                        <input id="conditionVal2" class="formulaInputFocus"/>
                                                        <i class="fa fa-table" aria-hidden="true" title="${conditionformat_text.selectCell}"></i>
                                                    </div>
                                                </div>
                                                <div style="margin: 5px 0;">${conditionformat_text.setAs}：</div>
                                                ${textCellColorHtml}
                                            </div>`;
                                        break;
                                    case "equal":
                                        title = conditionformat_text.conditionformat_equal;
                                        content = `<div class="box" data-itemvalue="equal">
                                                <div class="boxTitleOne">${conditionformat_text.conditionformat_equal_title}：</div>
                                                <div class="inpbox range">
                                                    <input id="conditionVal" class="formulaInputFocus"/>
                                                    <i class="fa fa-table" aria-hidden="true" title="${conditionformat_text.selectCell}"></i>
                                                </div>
                                                <div style="margin: 5px 0;">${conditionformat_text.setAs}：</div>
                                                ${textCellColorHtml}
                                            </div>`;
                                        break;
                                    case "textContains":
                                        title = conditionformat_text.conditionformat_textContains;
                                        content = `<div class="box" data-itemvalue="textContains">
                                                <div class="boxTitleOne">${conditionformat_text.conditionformat_textContains_title}：</div>
                                                <div class="inpbox range">
                                                    <input id="conditionVal" class="formulaInputFocus"/>
                                                    <i class="fa fa-table" aria-hidden="true" title="${conditionformat_text.selectCell}"></i>
                                                </div>
                                                <div style="margin: 5px 0;">${conditionformat_text.setAs}：</div>
                                                ${textCellColorHtml}
                                            </div>`;
                                        break;
                                    case "occurrenceDate":
                                        title = conditionformat_text.conditionformat_occurrenceDate;
                                        content = `<div class="box" data-itemvalue="occurrenceDate">
                                                <div class="boxTitleOne">${conditionformat_text.conditionformat_occurrenceDate_title}：</div>
                                                <div class="inpbox">
                                                    <input id="daterange-btn" class="formulaInputFocus" readonly="readonly" placeholder="${conditionformat_text.pleaseSelectADate}"/>
                                                </div>
                                                <div style="margin: 5px 0;">${conditionformat_text.setAs}：</div>
                                                ${textCellColorHtml}
                                            </div>`;
                                        break;
                                    case "duplicateValue":
                                        title = conditionformat_text.conditionformat_duplicateValue;
                                        content = `<div class="box" data-itemvalue="duplicateValue">
                                                <div class="boxTitleOne">${conditionformat_text.conditionformat_duplicateValue_title}：</div>
                                                <select id="conditionVal" class="selectbox">
                                                    <option value="0">${conditionformat_text.duplicateValue}</option>
                                                    <option value="1">${conditionformat_text.uniqueValue}</option>
                                                </select>
                                                <div style="margin:5px 0;">${conditionformat_text.setAs}：</div>
                                                ${textCellColorHtml}
                                            </div>`;
                                        break;
                                }

                                instance.conditionformat.conditionformatDialog(title, content, containerId);
                            }
                        },
                    );

                //项目选取规则子菜单点击事件
                currentInstance
                    .on(
                        "click.CFprojectSelectRule",
                        `#luckysheet-icon-projectSelectRule-menuButton .luckysheet-cols-menuitem`,
                        function () {
                            $menuButton.hide();
                            currentInstance.find(`#luckysheet-icon-projectSelectRule-menuButton`).hide();
                            instance.util.luckysheetContainerFocus();

                            let $t = $(this),
                                itemvalue = $t.attr("itemvalue");

                            if (Store.luckysheet_select_save.length == 0) {
                                if (instance.validate.isEditMode()) {
                                    alert(conditionformat_text.pleaseSelectRange);
                                } else {
                                    instance.tooltip.info(conditionformat_text.pleaseSelectRange, "");
                                }
                                return;
                            } else {
                                let textCellColorHtml = instance.conditionformat.textCellColorHtml();

                                let title, content;
                                switch (itemvalue) {
                                    case "top10":
                                        title = conditionformat_text.conditionformat_top10;
                                        content = `<div class="box" data-itemvalue="top10">
                                                <div class="boxTitleOne">${conditionformat_text.conditionformat_top10_title}：</div>
                                                <div style="height: 30px;line-height: 30px;">
                                                    <div style="float: left;height: 30px;line-height: 30px;margin: 0 5px;">${conditionformat_text.top}</div>
                                                    <div class="inpbox2">
                                                        <input id="conditionVal" class="formulaInputFocus" type="number" value="10"/>
                                                    </div>
                                                    <div style="float: left;height: 30px;line-height: 30px;margin: 0 5px;">${conditionformat_text.oneself}</div>
                                                </div>
                                                <div style="margin: 5px 0;">${conditionformat_text.setAs}：</div>
                                                ${textCellColorHtml}
                                            </div>`;
                                        break;
                                    case "top10%":
                                        title = conditionformat_text.conditionformat_top10_percent;
                                        content = `<div class="box" data-itemvalue="top10%">
                                                <div class="boxTitleOne">${conditionformat_text.conditionformat_top10_title}：</div>
                                                <div style="height: 30px;line-height: 30px;">
                                                    <div style="float: left;height: 30px;line-height: 30px;margin: 0 5px;">${conditionformat_text.top}</div>
                                                    <div class="inpbox2">
                                                        <input id="conditionVal" class="formulaInputFocus" type="number" value="10"/>
                                                    </div>
                                                    <div style="float: left;height: 30px;line-height: 30px;margin: 0 5px;">%</div>
                                                </div>
                                                <div style="margin: 5px 0;">${conditionformat_text.setAs}：</div>
                                                ${textCellColorHtml}
                                            </div>`;
                                        break;
                                    case "last10":
                                        title = conditionformat_text.conditionformat_last10;
                                        content = `<div class="box" data-itemvalue="last10">
                                                <div class="boxTitleOne">${conditionformat_text.conditionformat_last10_title}：</div>
                                                <div style="height: 30px;line-height: 30px;">
                                                    <div style="float: left;height: 30px;line-height: 30px;margin: 0 5px;">${conditionformat_text.last}</div>
                                                    <div class="inpbox2">
                                                        <input id="conditionVal" class="formulaInputFocus" type="number" value="10"/>
                                                    </div>
                                                    <div style="float: left;height: 30px;line-height: 30px;margin: 0 5px;">${conditionformat_text.oneself}</div>
                                                </div>
                                                <div style="margin: 5px 0;">${conditionformat_text.setAs}：</div>
                                                ${textCellColorHtml}
                                            </div>`;
                                        break;
                                    case "last10%":
                                        title = conditionformat_text.conditionformat_last10_percent;
                                        content = `<div class="box" data-itemvalue="last10%">
                                                <div class="boxTitleOne">${conditionformat_text.conditionformat_last10_title}：</div>
                                                <div style="height: 30px;line-height: 30px;">
                                                    <div style="float: left;height: 30px;line-height: 30px;margin: 0 5px;">${conditionformat_text.last}</div>
                                                    <div class="inpbox2">
                                                        <input id="conditionVal" class="formulaInputFocus" type="number" value="10"/>
                                                    </div>
                                                    <div style="float: left;height: 30px;line-height: 30px;margin: 0 5px;">%</div>
                                                </div>
                                                <div style="margin:5px 0;">设置为：</div>
                                                ${textCellColorHtml}
                                            </div>`;
                                        break;
                                    case "AboveAverage":
                                        title = conditionformat_text.conditionformat_AboveAverage;
                                        content = `<div class="box" data-itemvalue="AboveAverage">
                                                <div class="boxTitleOne">${conditionformat_text.conditionformat_AboveAverage_title}：</div>
                                                <div style="margin: 5px 0;">${conditionformat_text.setAsByArea}：</div>
                                                ${textCellColorHtml}
                                            </div>`;
                                        break;
                                    case "SubAverage":
                                        title = conditionformat_text.conditionformat_SubAverage;
                                        content = `<div class="box" data-itemvalue="SubAverage">
                                                <div class="boxTitleOne">${conditionformat_text.conditionformat_SubAverage_title}：</div>
                                                <div style="margin: 5px 0;">${conditionformat_text.setAsByArea}：</div>
                                                ${textCellColorHtml}
                                            </div>`;
                                        break;
                                }

                                instance.conditionformat.conditionformatDialog(title, content, containerId);
                            }
                        },
                    );

                //数据条子菜单点击事件
                currentInstance
                    .on("click.CFdataBar", `#luckysheet-icon-dataBar-menuButton .luckysheet-cols-menuitem`, function () {
                        $menuButton.hide();
                        currentInstance.find(`#luckysheet-icon-dataBar-menuButton`).hide();
                        instance.util.luckysheetContainerFocus();

                        let $t = $(this),
                            itemvalue = $t.attr("itemvalue");

                        if (Store.luckysheet_select_save.length > 0) {
                            let cellrange = $.extend(true, [], Store.luckysheet_select_save);
                            let format = instance.conditionformat.dataBarList[itemvalue]["format"];

                            instance.conditionformat.updateItem("dataBar", cellrange, format);
                        }
                    });

                //色阶子菜单点击事件
                currentInstance
                    .on(
                        "click.CFcolorGradation",
                        `#luckysheet-icon-colorGradation-menuButton .luckysheet-cols-menuitem`,
                        function () {
                            $menuButton.hide();
                            currentInstance.find(`#luckysheet-icon-colorGradation-menuButton`).hide();
                            instance.util.luckysheetContainerFocus();

                            let $t = $(this),
                                itemvalue = $t.attr("itemvalue");

                            if (Store.luckysheet_select_save.length > 0) {
                                let cellrange = $.extend(true, [], Store.luckysheet_select_save);
                                let format = instance.conditionformat.colorGradationList[itemvalue]["format"];

                                instance.conditionformat.updateItem("colorGradation", cellrange, format);
                            }
                        },
                    );

                //清除规则子菜单点击事件
                currentInstance
                    .on(
                        "click.CFdeleteRule",
                        `#luckysheet-icon-deleteRule-menuButton .luckysheet-cols-menuitem`,
                        function () {
                            $menuButton.hide();
                            currentInstance.find(`#luckysheet-icon-deleteRule-menuButton`).hide();
                            instance.util.luckysheetContainerFocus();

                            let $t = $(this),
                                itemvalue = $t.attr("itemvalue");

                            if (itemvalue == "delSheet") {
                                instance.conditionformat.updateItem("delSheet");
                            }
                        },
                    );
            }

            let userlen = $(this).outerWidth() * Store.scale;
            let tlen = $menuButton.outerWidth() * Store.scale;

            let menuleft = $(this).offset().left;
            if (tlen > userlen && tlen + menuleft > $("#" + Store.container).width() * Store.scale) {
                menuleft = menuleft - tlen + userlen;
            }
            instance.util.mouseclickposition($menuButton, menuleft, $(this).offset().top + 25 * Store.scale, "lefttop");
        });

        //批注
        currentInstance.find("#luckysheet-icon-postil").click(function() {
        // $(document).off(`click.postil-${containerId}`).on(`click.postil-${containerId}`, `#${containerId} #luckysheet-icon-postil`, function() {
            let menuButtonId = $(this).attr("id") + "-menuButton";
            let $menuButton = currentInstance.find("#" + menuButtonId);

            const locale_comment = instance.locale().comment;

            $menuButton.remove();

            // if($menuButton.length == 0){
            instance.postil.removeActivePs();

            let last = Store.luckysheet_select_save[Store.luckysheet_select_save.length - 1];

            let row_index = last["row_focus"];
            if (row_index == null) {
                row_index = last["row"][0];
            }

            let col_index = last["column_focus"];
            if (col_index == null) {
                col_index = last["column"][0];
            }

            let itemdata;
            if (Store.flowdata[row_index][col_index] != null && Store.flowdata[row_index][col_index].ps != null) {
                itemdata = [
                    { text: locale_comment.edit, value: "editPs", example: "" },
                    { text: locale_comment.delete, value: "delPs", example: "" },
                    { text: "", value: "split", example: "" },
                    { text: locale_comment.showOne, value: "showHidePs", example: "" },
                    { text: locale_comment.showAll, value: "showHideAllPs", example: "" },
                ];
            } else {
                itemdata = [
                    { text: locale_comment.insert, value: "newPs", example: "" },
                    { text: "", value: "split", example: "" },
                    { text: locale_comment.showAll, value: "showHideAllPs", example: "" },
                ];
            }

            let itemset = _this.createButtonMenu(itemdata);
            let menu = replaceHtml(_this.menu, { id: "postil", item: itemset, subclass: "", sub: "", });

            $(`#${containerId}`).append(menu);
            $menuButton = currentInstance.find("#" + menuButtonId).width(150);

            $menuButton.find(".luckysheet-cols-menuitem").click(function () {
                $menuButton.hide();
                instance.util.luckysheetContainerFocus();

                let $t = $(this),
                    itemvalue = $t.attr("itemvalue");

                if (itemvalue == "newPs") {
                    instance.postil.newPs(row_index, col_index);
                } else if (itemvalue == "editPs") {
                    instance.postil.editPs(row_index, col_index);
                } else if (itemvalue == "delPs") {
                    instance.postil.delPs(row_index, col_index);
                } else if (itemvalue == "showHidePs") {
                    instance.postil.showHidePs(row_index, col_index);
                } else if (itemvalue == "showHideAllPs") {
                    instance.postil.showHideAllPs();
                }
            });
            // }

            let userlen = $(this).outerWidth() * Store.scale;
            let tlen = $menuButton.outerWidth() * Store.scale;

            let menuleft = $(this).offset().left;
            if (tlen > userlen && tlen + menuleft > $("#" + Store.container).width() * Store.scale) {
                menuleft = menuleft - tlen + userlen;
            }
            instance.util.mouseclickposition($menuButton, menuleft, $(this).offset().top + 25 * Store.scale, "lefttop");
        });

        //sheet protection
        currentInstance.find("#luckysheet-icon-protection").click(function() {
        // $(document).off(`click.protection-${containerId}`).on(`click.protection-${containerId}`, `#${containerId} #luckysheet-icon-protection`, function() {
            // 非编辑模式下不允许该操作
            if(instance.validate.isEditMode()){
                return;
            }
            let sheetFile = instance.sheetmanage.getSheetByIndex();
            instance.protection.openProtectionModal(sheetFile);
        });

        //print
        currentInstance.find("#luckysheet-icon-print").click(function() {
        // $(document).off(`click.print-${containerId}`).on(`click.print-${containerId}`, `#${containerId} #luckysheet-icon-print`, function() {
            let menuButtonId = $(this).attr("id") + "-menuButton";
            let $menuButton = currentInstance.find("#" + menuButtonId);
            const _locale = instance.locale();
            const locale_print = _locale.print;
            if ($menuButton.length == 0) {
                let itemdata = [
                    {
                        text: locale_print.menuItemPrint,
                        value: "print",
                        example: '<i class="iconfont luckysheet-iconfont-dayin" aria-hidden="true"></i>',
                    },
                    { text: "", value: "split", example: "" },
                    {
                        text: locale_print.menuItemAreas,
                        value: "areas",
                        example: '<i class="iconfont luckysheet-iconfont-tihuan" aria-hidden="true"></i>',
                    },
                    {
                        text: locale_print.menuItemRows,
                        value: "rows",
                        example: '<i class="iconfont luckysheet-iconfont-zhuandao1" aria-hidden="true"></i>',
                    },
                    {
                        text: locale_print.menuItemColumns,
                        value: "columns",
                        example: '<i class="iconfont luckysheet-iconfont-dingwei" aria-hidden="true"></i>',
                    },
                ];

                let itemset = _this.createButtonMenu(itemdata);

                let menu = replaceHtml(_this.menu, { id: "print", item: itemset, subclass: "", sub: "", });

                $(`#${containerId}`).append(menu);
                $menuButton = currentInstance.find("#" + menuButtonId).width(180);

                $menuButton.find(".luckysheet-cols-menuitem").click(function () {
                    $menuButton.hide();
                    instance.util.luckysheetContainerFocus();

                    let $t = $(this),
                        itemvalue = $t.attr("itemvalue");

                    if (itemvalue == "print") {
                        //Print config
                        if (Store.luckysheetPrint) {
                            luckysheetPrint = Store.luckysheetPrint;
                            const plugin = Store.plugins.find((item) => item.name === "print");
                            if (plugin && plugin.config) {
                                luckysheetPrint.createDialog();
                                luckysheetPrint.init(plugin.config.license);
                            }
                        }
                    } else if (itemvalue == "areas" || itemvalue == "rows" || itemvalue == "columns") {
                        //range
                        alert("areas");
                    }
                });
            }

            let userlen = $(this).outerWidth() * Store.scale;
            let tlen = $menuButton.outerWidth() * Store.scale;

            let menuleft = $(this).offset().left;
            if (tlen > userlen && tlen + menuleft > $("#" + Store.container).width() * Store.scale) {
                menuleft = menuleft - tlen + userlen;
            }
            instance.util.mouseclickposition($menuButton, menuleft, $(this).offset().top + 25 * Store.scale, "lefttop");
        });

        // IC50/EC50
        currentInstance.find("#luckysheet-icon-ic50-ec50").click(function() {
        // $(document).off(`click.ic50ec50-${containerId}`).on(`click.ic50ec50-${containerId}`, `#${containerId} #luckysheet-icon-ic50-ec50`, function() {
            let menuButtonId = $(this).attr("id") + "-menuButton";
            let $menuButton = currentInstance.find("#" + menuButtonId);
            const _locale = instance.locale();
            const IC50EC50Text = _locale.ic50ec50;
            if ($menuButton.length == 0) {
                let itemdata = [
                    { text: IC50EC50Text.ic50, value: "ic50", example: "more" },
                    { text: IC50EC50Text.ec50, value: "ec50", example: "more" },
                    { text: IC50EC50Text.redrawAll, value: "redrawAll", example: "" },
                ];
                let itemset = _this.createButtonMenu(itemdata);
                let menu = replaceHtml(_this.menu, { id: "ic50-ec50", item: itemset, subclass: "", sub: "", });

                //ic50子菜单
                let submenuIc50 = `<div id="luckysheet-icon-ic50-menuButton" class="luckysheet-icon-ic50-menuButton luckysheet-cols-menu luckysheet-rightgclick-menu luckysheet-menuButton luckysheet-menuButton-sub luckysheet-mousedown-cancel" style="width: 58px;padding: 4px;top: 143.5px;left: 1321.48px;display: none;">
                    <div itemvalue="ic50-logx-4" class="luckysheet-cols-menuitem luckysheet-mousedown-cancel" style="width: 38px; height: 38px;padding: 5px;float: left;">
                        <div class="luckysheet-mousedown-cancel bgImgBox bg-ic50-logx-4" title="${IC50EC50Text.ic50Logx4}"></div>
                    </div>
                    <div itemvalue="ic50-logx-3" class="luckysheet-cols-menuitem luckysheet-mousedown-cancel" style="width: 38px; height: 38px;padding: 5px;float: left;">
                        <div class="luckysheet-mousedown-cancel bgImgBox bg-ic50-logx-3" title="${IC50EC50Text.ic50Logx3}"></div>
                    </div>
                    <div itemvalue="ic50-logx-2" class="luckysheet-cols-menuitem luckysheet-mousedown-cancel" style="width: 38px; height: 38px;padding: 5px;float: left;">
                        <div class="luckysheet-mousedown-cancel bgImgBox bg-ic50-logx-2" title="${IC50EC50Text.ic50Logx2}"></div>
                    </div>
                    <div itemvalue="ic50-x-4" class="luckysheet-cols-menuitem luckysheet-mousedown-cancel" style="width: 38px; height: 38px;padding: 5px;float: left;">
                        <div class="luckysheet-mousedown-cancel bgImgBox bg-ic50-x-4" title="${IC50EC50Text.ic50X4}"></div>
                    </div>
                    <div itemvalue="ic50-x-3" class="luckysheet-cols-menuitem luckysheet-mousedown-cancel" style="width: 38px; height: 38px;padding: 5px;float: left;">
                        <div class="luckysheet-mousedown-cancel bgImgBox bg-ic50-x-3" title="${IC50EC50Text.ic50X3}"></div>
                    </div>
                    <div itemvalue="ic50-x-2" class="luckysheet-cols-menuitem luckysheet-mousedown-cancel" style="width: 38px; height: 38px;padding: 5px;float: left;">
                        <div class="luckysheet-mousedown-cancel bgImgBox bg-ic50-x-2" title="${IC50EC50Text.ic50X2}"></div>
                    </div>
                </div>`
                // ec50子菜单
                let submenuEc50 = `<div id="luckysheet-icon-ec50-menuButton" class="luckysheet-icon-ec50-menuButton luckysheet-cols-menu luckysheet-rightgclick-menu luckysheet-menuButton luckysheet-menuButton-sub luckysheet-mousedown-cancel" style="width: 58px;padding: 4px;top: 143.5px;left: 1321.48px;display: none;">
                    <div itemvalue="ec50-logx-4" class="luckysheet-cols-menuitem luckysheet-mousedown-cancel" style="width: 38px; height: 38px;padding: 5px;float: left;">
                        <div class="luckysheet-mousedown-cancel bgImgBox bg-ec50-logx-4" title="${IC50EC50Text.ec50Logx4}"></div>
                    </div>
                    <div itemvalue="ec50-logx-3" class="luckysheet-cols-menuitem luckysheet-mousedown-cancel" style="width: 38px; height: 38px;padding: 5px;float: left;">
                        <div class="luckysheet-mousedown-cancel bgImgBox bg-ec50-logx-3" title="${IC50EC50Text.ec50Logx3}"></div>
                    </div>
                    <div itemvalue="ec50-logx-2" class="luckysheet-cols-menuitem luckysheet-mousedown-cancel" style="width: 38px; height: 38px;padding: 5px;float: left;">
                        <div class="luckysheet-mousedown-cancel bgImgBox bg-ec50-logx-2" title="${IC50EC50Text.ec50Logx2}"></div>
                    </div>
                    <div itemvalue="ec50-x-4" class="luckysheet-cols-menuitem luckysheet-mousedown-cancel" style="width: 38px; height: 38px;padding: 5px;float: left;">
                        <div class="luckysheet-mousedown-cancel bgImgBox bg-ec50-x-4" title="${IC50EC50Text.ec50X4}"></div>
                    </div>
                    <div itemvalue="ec50-x-3" class="luckysheet-cols-menuitem luckysheet-mousedown-cancel" style="width: 38px; height: 38px;padding: 5px;float: left;">
                        <div class="luckysheet-mousedown-cancel bgImgBox bg-ec50-x-3" title="${IC50EC50Text.ec50X3}"></div>
                    </div>
                    <div itemvalue="ec50-x-2" class="luckysheet-cols-menuitem luckysheet-mousedown-cancel" style="width: 38px; height: 38px;padding: 5px;float: left;">
                        <div class="luckysheet-mousedown-cancel bgImgBox bg-ec50-x-2" title="${IC50EC50Text.ec50X2}"></div>
                    </div>
                </div>`

                $(`#${containerId}`).append(menu + submenuIc50 + submenuEc50);
                $menuButton = currentInstance.find("#" + menuButtonId).width(180);

                $menuButton.find(".luckysheet-cols-menuitem").click(function () {
                    $menuButton.hide();
                    instance.util.luckysheetContainerFocus();

                    let $t = $(this),
                        itemvalue = $t.attr("itemvalue");

                    if (itemvalue == "redrawAll") { // 全部重新绘制
                        let currentSheetCharts = instance.api.getSheet().chart
                        instance.chartPlugin.redrawAllIC50EC50Chart(currentSheetCharts)
                    }
                });
                // ic50 子菜单点击事件
                currentInstance
                    .on(
                        "click.ic50",
                        `#luckysheet-icon-ic50-menuButton .luckysheet-cols-menuitem`,
                        function () {
                            $menuButton.hide();
                            currentInstance.find(`#luckysheet-icon-ic50-menuButton`).hide();
                            instance.util.luckysheetContainerFocus();

                            let $t = $(this),
                                itemvalue = $t.attr("itemvalue");
                            instance.chartPlugin.createLuckyChart('', '', '', '', 'ic50ec50', itemvalue, '')
                        },
                    );
                // ec50 子菜单点击事件
                currentInstance
                    .off("click.ec50")
                    .on(
                        "click.ec50",
                        `#luckysheet-icon-ec50-menuButton .luckysheet-cols-menuitem`,
                        function () {
                            $menuButton.hide();
                            currentInstance.find(`#luckysheet-icon-ec50-menuButton`).hide();
                            instance.util.luckysheetContainerFocus();

                            let $t = $(this),
                                itemvalue = $t.attr("itemvalue");
                            instance.chartPlugin.createLuckyChart('', '', '', '', 'ic50ec50', itemvalue, '')
                        },
                    );
            }
            // 菜单位置
            let userlen = $(this).outerWidth() * Store.scale;
            let tlen = $menuButton.outerWidth() * Store.scale;

            let menuleft = $(this).offset().left;
            if (tlen > userlen && tlen + menuleft > $("#" + Store.container).width() * Store.scale) {
                menuleft = menuleft - tlen + userlen;
            }
            instance.util.mouseclickposition($menuButton, menuleft, $(this).offset().top + 25 * Store.scale, "lefttop");
        })

        // 序列操作 --modify by wangxiaofei 2023.8.18
        currentInstance.find("#luckysheet-icon-sequence-operation").click(function() {
        // $(document).off(`click.sequence-operation-${containerId}`).on(`click.sequence-operation-${containerId}`, `#${containerId} #luckysheet-icon-sequence-operation`, function() {
            let menuButtonId = $(this).attr("id") + "-menuButton";
            let $menuButton = currentInstance.find("#" + menuButtonId);
            const _locale = instance.locale();
            const sequenceOperationText = _locale.sequenceOperation;
            if ($menuButton.length == 0) {
                let itemdata = [
                    { text: sequenceOperationText.sequenceImport, value: "sequenceImport", example: "" },
                    { text: sequenceOperationText.generateCoordinates, value: "generateCoordinates", example: "" },
                    { text: sequenceOperationText.sequenceMerge, value: "sequenceMerge", example: "" },
                    { text: sequenceOperationText.switchCase, value: "switchCase", example: "" },
                    { text: sequenceOperationText.createComments, value: "createComments", example: "" },
                    { text: sequenceOperationText.DNASequenceFlipping, value: "DNASequenceFlipping", example: "" },
                ];
                let itemset = _this.createButtonMenu(itemdata);
                let menu = replaceHtml(_this.menu, { id: "sequence-operation", item: itemset, subclass: "", sub: "", });

                $(`#${containerId}`).append(menu);
                $menuButton = currentInstance.find("#" + menuButtonId).width(150);

                $menuButton.find(".luckysheet-cols-menuitem").click(function () {
                    $menuButton.hide();
                    instance.util.luckysheetContainerFocus();

                    let $t = $(this),
                        itemvalue = $t.attr("itemvalue");

                    if (itemvalue == "sequenceImport") { // 序列导入
                        _this.sequenceImportDialog.createSequenceImportDialog();
                    } else if (itemvalue === "generateCoordinates") { // 生成坐标
                        _this.sequenceImportDialog.createProteinAxis();
                    } else if (itemvalue === "sequenceMerge") { // 序列合并
                        _this.sequenceImportDialog.sequenceMerge();
                    } else if (itemvalue === "switchCase") { // 切换大小写
                        _this.sequenceImportDialog.switchCase();
                    } else if (itemvalue === "createComments") { // 创建注释
                        _this.sequenceImportDialog.createComments();
                    } else if (itemvalue === "DNASequenceFlipping") { // DNA序列翻转
                        _this.sequenceImportDialog.sequenceFlipping();
                    }
                });
            }
            // 菜单位置
            let userlen = $(this).outerWidth() * Store.scale;
            let tlen = $menuButton.outerWidth() * Store.scale;

            let menuleft = $(this).offset().left;
            if (tlen > userlen && tlen + menuleft > $("#" + Store.container).width() * Store.scale) {
                menuleft = menuleft - tlen + userlen;
            }
            instance.util.mouseclickposition($menuButton, menuleft, $(this).offset().top + 25 * Store.scale, "lefttop");
        })

        // 引物设计
        currentInstance.find("#luckysheet-icon-primer-design").click(function() {
        // $(document).off(`click.primer-design-${containerId}`).on(`click.primer-design-${containerId}`, `#${containerId} #luckysheet-icon-primer-design`, function() {
            let menuButtonId = $(this).attr("id") + "-menuButton";
            let $menuButton = currentInstance.find("#" + menuButtonId);
            const _locale = instance.locale();
            const primerDesignText = _locale.primerDesign;
            if ($menuButton.length == 0) {
                let itemdata = [
                    { text: primerDesignText.createPrimer, value: "createPrimer", example: "more" },
                    { text: primerDesignText.primerPropertyAnalysis, value: "primerPropertyAnalysis", example: "" },
                    { text: primerDesignText.primer3, value: "primer3", example: "" },
                ];
                let itemset = _this.createButtonMenu(itemdata);
                let menu = replaceHtml(_this.menu, { id: "primer-design", item: itemset, subclass: "", sub: "", });

                //创建引物子菜单
                let submenu = `<div id="luckysheet-icon-createPrimer-menuButton" class="luckysheet-cols-menu luckysheet-rightgclick-menu luckysheet-menuButton luckysheet-menuButton-sub luckysheet-mousedown-cancel" style="width: 100px;padding: 4px;top: 143.5px;left: 1321.48px;display: none;">
                    <div itemvalue="positiveChain" class="luckysheet-cols-menuitem luckysheet-mousedown-cancel" style="width: 80px;padding: 5px;float: left;">
                        ${primerDesignText.positiveChain}
                    </div>
                    <div itemvalue="negativeChain" class="luckysheet-cols-menuitem luckysheet-mousedown-cancel" style="width: 80px;padding: 5px;float: left;">
                        ${primerDesignText.negativeChain}
                    </div>
                </div>`

                $(`#${containerId}`).append(menu + submenu);
                $menuButton = currentInstance.find("#" + menuButtonId).width(150);

                $menuButton.find(".luckysheet-cols-menuitem").click(function () {
                    $menuButton.hide();
                    instance.util.luckysheetContainerFocus();

                    let $t = $(this),
                        itemvalue = $t.attr("itemvalue");

                    if (itemvalue == "primer3") { // Primer3
                        _this.primerDesign.openPrimer();
                    } else if (itemvalue === "primerPropertyAnalysis") { // 引物性质分析
                        _this.primerDesign.primerPropertyAnalysis();
                    }
                });
                // 创建引物子菜单点击事件
                currentInstance
                    .on(
                        "click.createPrimer",
                        `#luckysheet-icon-createPrimer-menuButton .luckysheet-cols-menuitem`,
                        function () {
                            $menuButton.hide();
                            currentInstance.find(`#luckysheet-icon-createPrimer-menuButton`).hide();
                            instance.util.luckysheetContainerFocus();

                            let $t = $(this),
                                itemvalue = $t.attr("itemvalue");
                                if (itemvalue === 'positiveChain') { // 正链
                                    _this.primerDesign.primerChain('forward');
                                } else if (itemvalue === 'negativeChain') { // 负链
                                    _this.primerDesign.primerChain('reverse');
                                }
                        },
                    );
            }
            // 菜单位置
            let userlen = $(this).outerWidth() * Store.scale;
            let tlen = $menuButton.outerWidth() * Store.scale;

            let menuleft = $(this).offset().left;
            if (tlen > userlen && tlen + menuleft > $("#" + Store.container).width() * Store.scale) {
                menuleft = menuleft - tlen + userlen;
            }
            instance.util.mouseclickposition($menuButton, menuleft, $(this).offset().top + 25 * Store.scale, "lefttop");
        })

        // DNA分析
        currentInstance.find("#luckysheet-icon-dna-analysis").click(function() {
        // $(document).off(`click.dna-analysis-${containerId}`).on(`click.dna-analysis-${containerId}`, `#${containerId} #luckysheet-icon-dna-analysis`, function() {
            let menuButtonId = $(this).attr("id") + "-menuButton";
            let $menuButton = currentInstance.find("#" + menuButtonId);
            const _locale = instance.locale();
            const dnaAnalysisText = _locale.dnaAnalysis;
            if ($menuButton.length == 0) {
                let itemdata = [
                    // { text: primerDesignText.createPrimer, value: "createPrimer", example: "more" },
                    { text: dnaAnalysisText.DNAproperties, value: "DNAproperties", example: "" },
                    { text: dnaAnalysisText.complementaryChainComputing, value: "complementaryChainComputing", example: "" },
                    { text: dnaAnalysisText.calculateORF, value: "calculateORF", example: "" },
                    { text: dnaAnalysisText.translateProtein, value: "translateProtein", example: "more" },
                    { text: dnaAnalysisText.DNASequenceComparison, value: "DNASequenceComparison", example: "more" },
                    { text: dnaAnalysisText.DNASequenceCopy, value: "DNASequenceCopy", example: "" },
                    { text: dnaAnalysisText.searchForEnzymeCleavageSites, value: "searchForEnzymeCleavageSites", example: "" },
                ];
                let itemset = _this.createButtonMenu(itemdata);
                let menu = replaceHtml(_this.menu, { id: "dna-analysis", item: itemset, subclass: "", sub: "", });

                 //创建翻译为蛋白质子菜单
                 let submenu = `<div id="luckysheet-icon-translateProtein-menuButton" class="luckysheet-cols-menu luckysheet-rightgclick-menu luckysheet-menuButton luckysheet-menuButton-sub luckysheet-mousedown-cancel" style="width: 120px;padding: 4px;top: 143.5px;left: 1321.48px;display: none;">
                    <div itemvalue="positiveStrand" class="luckysheet-cols-menuitem luckysheet-mousedown-cancel" style="width: 100px;padding: 5px;float: left;">
                        ${dnaAnalysisText.positiveStrand}
                    </div>
                    <div itemvalue="minusStrand" class="luckysheet-cols-menuitem luckysheet-mousedown-cancel" style="width: 100px;padding: 5px;float: left;">
                        ${dnaAnalysisText.minusStrand}
                    </div>
                </div>
                <div id="luckysheet-icon-DNASequenceComparison-menuButton" class="luckysheet-cols-menu luckysheet-rightgclick-menu luckysheet-menuButton luckysheet-menuButton-sub luckysheet-mousedown-cancel" style="width: 120px;padding: 4px;top: 143.5px;left: 1321.48px;display: none;">
                    <div itemvalue="doubleSequenceComparison" class="luckysheet-cols-menuitem luckysheet-mousedown-cancel" style="width: 100px;padding: 5px;float: left;">
                        ${dnaAnalysisText.doubleSequenceComparison}
                    </div>
                    <div itemvalue="BLASTSequenceComparison" class="luckysheet-cols-menuitem luckysheet-mousedown-cancel" style="width: 100px;padding: 5px;float: left;">
                        ${dnaAnalysisText.BLASTSequenceComparison}
                    </div>
                </div>`

                $(`#${containerId}`).append(menu + submenu);
                $menuButton = currentInstance.find("#" + menuButtonId).width(150);

                $menuButton.find(".luckysheet-cols-menuitem").click(function () {
                    $menuButton.hide();
                    instance.util.luckysheetContainerFocus();

                    let $t = $(this),
                        itemvalue = $t.attr("itemvalue");

                    if (itemvalue === "DNAproperties") { // DNA性质分析
                        _this.dnaAnalysisUtils.DNApropertiesFunction()
                    } else if (itemvalue === "complementaryChainComputing"){ // 互补链计算
                        _this.dnaAnalysisUtils.complementaryChainComputing();
                    } else if (itemvalue === "calculateORF"){ // 如果是开放阅读框计算
                        let selectedRangeArr = instance.api.getRangeArray('twoDimensional')
                        if (selectedRangeArr.length >= 1) { // 有选中行，则打开开放阅读框计算的弹窗
                            _this.calculateORFDialog.createCalculateORFDialog();
                        }
                    } else if (itemvalue === "DNASequenceCopy") { // DNA序列复制
                        _this.dnaAnalysisUtils.DNASequenceCopy();
                    } else if (itemvalue === "searchForEnzymeCleavageSites") { // 查找酶切位点
                         _this.dnaAnalysisUtils.searchForEnzymeCleavageSites();
                    }
                });
                // 创建翻译为蛋白质子菜单点击事件
                currentInstance
                .off("click.translateProtein")
                .on(
                    "click.translateProtein",
                    `#luckysheet-icon-translateProtein-menuButton .luckysheet-cols-menuitem`,
                    function () {
                        $menuButton.hide();
                        currentInstance.find(`#luckysheet-icon-translateProtein-menuButton`).hide();
                        instance.util.luckysheetContainerFocus();

                        let $t = $(this),
                            itemvalue = $t.attr("itemvalue");
                        if(itemvalue === 'positiveStrand'){ // 如果是翻译为正链，使用翻译为正链的方法
                            _this.dnaAnalysisUtils.translateProteinForwardStrand();
                        }else if(itemvalue === 'minusStrand'){ // 如果是翻译为负链，使用翻译为负链的方法
                            _this.dnaAnalysisUtils.translateProteinReverseStrand();
                        }
                        
                })

                // 创建DNA序列对比子菜单点击事件
                currentInstance
                .off("click.DNASequenceComparison")
                .on(
                    "click.DNASequenceComparison",
                    `#luckysheet-icon-DNASequenceComparison-menuButton .luckysheet-cols-menuitem`,
                    function () {
                        $menuButton.hide();
                        currentInstance.find(`#luckysheet-icon-DNASequenceComparison-menuButton`).hide();
                        instance.util.luckysheetContainerFocus();
                        let $t = $(this),
                            itemvalue = $t.attr("itemvalue");
                        if(itemvalue === 'doubleSequenceComparison'){ // 如果是DNA双序列对比
                            _this.dnaAnalysisUtils.doubleSequenceComparison();
                        }else if(itemvalue === 'BLASTSequenceComparison'){ // 如果是BLAST序列对比
                            _this.dnaAnalysisUtils.BLASTSequenceComparison();
                        }
                        
                })
            }
            // 菜单位置
            let userlen = $(this).outerWidth() * Store.scale;
            let tlen = $menuButton.outerWidth() * Store.scale;

            let menuleft = $(this).offset().left;
            if (tlen > userlen && tlen + menuleft > $("#" + Store.container).width() * Store.scale) {
                menuleft = menuleft - tlen + userlen;
            }
            instance.util.mouseclickposition($menuButton, menuleft, $(this).offset().top + 25 * Store.scale, "lefttop");
        })

        // 序列查找 --modify by wangxiaofei 2023.8.28
        currentInstance.find("#luckysheet-icon-sequence-lookup").click(function() {
        // $(document).off(`click.sequence-lookup-${containerId}`).on(`click.sequence-lookup-${containerId}`, `#${containerId} #luckysheet-icon-sequence-lookup`, function() {
            let menuButtonId = $(this).attr("id") + "-menuButton";
            let $menuButton = currentInstance.find("#" + menuButtonId);
            const _locale = instance.locale();
            const sequenceLookupText = _locale.sequenceLookup;
            if ($menuButton.length == 0) {
                let itemdata = [
                    { text: sequenceLookupText.repeatSequenceSearch, value: "repeatSequenceSearch", example: "" },
                    { text: sequenceLookupText.moduleSearchTitle, value: "moduleSearchTitle", example: "" },
                    { text: sequenceLookupText.indexSearch, value: "indexSearch", example: "" },
                ];
                let itemset = _this.createButtonMenu(itemdata);
                let menu = replaceHtml(_this.menu, { id: "sequence-lookup", item: itemset, subclass: "", sub: "" });

                $(`#${containerId}`).append(menu);
                $menuButton = currentInstance.find("#" + menuButtonId).width(150);

                $menuButton.find(".luckysheet-cols-menuitem").click(function () {
                    $menuButton.hide();
                    instance.util.luckysheetContainerFocus();

                    let $t = $(this),
                        itemvalue = $t.attr("itemvalue");

                    if (itemvalue == "repeatSequenceSearch") { // 重复序列查找
                        _this.sequenceLookup.repeatSequenceSearch();
                    } else if (itemvalue === "moduleSearchTitle") { // 模式查找
                        _this.sequenceLookup.fragmentSearch();
                    } else if (itemvalue === "indexSearch") { // 定位查找
                        _this.sequenceLookup.indexSearch();
                    }
                });
            }
            // 菜单位置
            let userlen = $(this).outerWidth() * Store.scale;
            let tlen = $menuButton.outerWidth() * Store.scale;

            let menuleft = $(this).offset().left;
            if (tlen > userlen && tlen + menuleft > $("#" + Store.container).width() * Store.scale) {
                menuleft = menuleft - tlen + userlen;
            }
            instance.util.mouseclickposition($menuButton, menuleft, $(this).offset().top + 25 * Store.scale, "lefttop");
        });

        // CRISPR设计 --modify by wangxiaofei 2023.8.30
        currentInstance.find("#luckysheet-icon-crispr-design").click(function() {
        // $(document).off(`click.crispr-design-${containerId}`).on(`click.crispr-design-${containerId}`, `#${containerId} #luckysheet-icon-crispr-design`, function() {
            let menuButtonId = $(this).attr("id") + "-menuButton";
            let $menuButton = currentInstance.find("#" + menuButtonId);
            const _locale = instance.locale();
            const crisprDesignText = _locale.crisprDesign;
            if ($menuButton.length == 0) {
                let itemdata = [
                    { text: crisprDesignText.crispr, value: "crispr", example: "" },
                    { text: crisprDesignText.atum, value: "atum", example: "" },
                ];
                let itemset = _this.createButtonMenu(itemdata);
                let menu = replaceHtml(_this.menu, { id: "crispr-design", item: itemset, subclass: "", sub: "" });

                $(`#${containerId}`).append(menu);
                $menuButton = currentInstance.find("#" + menuButtonId).width(185);

                $menuButton.find(".luckysheet-cols-menuitem").click(function () {
                    $menuButton.hide();
                    instance.util.luckysheetContainerFocus();

                    let $t = $(this),
                        itemvalue = $t.attr("itemvalue");

                    if (itemvalue == "crispr") { // crispr查找
                        _this.crisprDesign.createCrisprDesignDialog();
                    } else if (itemvalue === "atum") { // ATUM CRISPR Design
                        _this.crisprDesign.openCrispr();
                    }
                });
            }
            // 菜单位置
            let userlen = $(this).outerWidth() * Store.scale;
            let tlen = $menuButton.outerWidth() * Store.scale;

            let menuleft = $(this).offset().left;
            if (tlen > userlen && tlen + menuleft > $("#" + Store.container).width() * Store.scale) {
                menuleft = menuleft - tlen + userlen;
            }
            instance.util.mouseclickposition($menuButton, menuleft, $(this).offset().top + 25 * Store.scale, "lefttop");
        });
        
        // 蛋白质分析 --modify by wangxiaofei 2023.9.5
        currentInstance.find("#luckysheet-icon-protein-analysis").click(function() {
        // $(document).off(`click.protein-analysis-${containerId}`).on(`click.protein-analysis-${containerId}`, `#${containerId} #luckysheet-icon-protein-analysis`, function() {
            let menuButtonId = $(this).attr("id") + "-menuButton";
            let $menuButton = currentInstance.find("#" + menuButtonId);
            const _locale = instance.locale();
            const proteinanalysismenuText = _locale.proteinanalysismenu;
            if ($menuButton.length == 0) {
                let itemdata = [
                    { text: proteinanalysismenuText.proteinfeatureanalysis, value: "proteinfeatureanalysis", example: "more" },
                    // { text: proteinanalysismenuText.antibodyNumbering, value: "antibodyNumbering", example: "" },
                    // { text: proteinanalysismenuText.cdr, value: "cdr", example: "" },
                    { text: proteinanalysismenuText.proteinblastp, value: "proteinblastp", example: "more" },
                    { text: proteinanalysismenuText.proteinaa, value: "proteinaa", example: "" },
                    { text: proteinanalysismenuText.proteinexpresschange, value: "proteinexpresschange", example: "more" },
                    { text: proteinanalysismenuText.proteinCopy, value: "proteinCopy", example: "" },

                ];
                let itemset = _this.createButtonMenu(itemdata);
                let menu = replaceHtml(_this.menu, { id: "protein-analysis", item: itemset, subclass: "", sub: "" });

                //蛋白质生化特性计算+蛋白质序列对比子菜单
                let submenu = `<div id="luckysheet-icon-proteinfeatureanalysis-menuButton" class="luckysheet-cols-menu luckysheet-rightgclick-menu luckysheet-menuButton luckysheet-menuButton-sub luckysheet-mousedown-cancel" style="width: 140px;padding: 4px;top: 143.5px;left: 1321.48px;display: none;">
                    <div itemvalue="isoelectricPoint" class="luckysheet-cols-menuitem luckysheet-mousedown-cancel" style="width: 120px;padding: 5px;float: left;">
                        ${proteinanalysismenuText.isoelectricPoint}
                    </div>
                    <div itemvalue="proteinMw" class="luckysheet-cols-menuitem luckysheet-mousedown-cancel" style="width: 120px;padding: 5px;float: left;">
                        ${proteinanalysismenuText.proteinMw}
                    </div>
                    <div itemvalue="Hydrophobicity" class="luckysheet-cols-menuitem luckysheet-mousedown-cancel" style="width: 120px;padding: 5px;float: left;">
                        ${proteinanalysismenuText.Hydrophobicity}
                    </div>
                    <div itemvalue="instabilityIndex" class="luckysheet-cols-menuitem luckysheet-mousedown-cancel" style="width: 120px;padding: 5px;float: left;">
                        ${proteinanalysismenuText.instabilityIndex}
                    </div>
                    <div itemvalue="proteinextinctioncoefficient" class="luckysheet-cols-menuitem luckysheet-mousedown-cancel" style="width: 120px;padding: 5px;float: left;">
                        ${proteinanalysismenuText.proteinextinctioncoefficient}
                    </div>
                </div>
                <div id="luckysheet-icon-proteinblastp-menuButton" class="luckysheet-cols-menu luckysheet-rightgclick-menu luckysheet-menuButton luckysheet-menuButton-sub luckysheet-mousedown-cancel" style="width: 140px;padding: 4px;top: 143.5px;left: 1321.48px;display: none;">
                    <div itemvalue="blastp" class="luckysheet-cols-menuitem luckysheet-mousedown-cancel" style="width: 120px;padding: 5px;float: left;">
                        ${proteinanalysismenuText.blastp}
                    </div>
                    <div itemvalue="proteinBLASTCompare" class="luckysheet-cols-menuitem luckysheet-mousedown-cancel" style="width: 120px;padding: 5px;float: left;">
                        ${proteinanalysismenuText.proteinBLASTCompare}
                    </div>
                </div>
                <div id="luckysheet-icon-proteinexpresschange-menuButton" class="luckysheet-cols-menu luckysheet-rightgclick-menu luckysheet-menuButton luckysheet-menuButton-sub luckysheet-mousedown-cancel" style="width: 140px;padding: 4px;top: 143.5px;left: 1321.48px;display: none;">
                    <div itemvalue="singleAA" class="luckysheet-cols-menuitem luckysheet-mousedown-cancel" style="width: 120px;padding: 5px;float: left;">
                        ${proteinanalysismenuText.singleAA}
                    </div>
                    <div itemvalue="tripleAA" class="luckysheet-cols-menuitem luckysheet-mousedown-cancel" style="width: 120px;padding: 5px;float: left;">
                        ${proteinanalysismenuText.tripleAA}
                    </div>
                </div>`

                $(`#${containerId}`).append(menu + submenu);
                $menuButton = currentInstance.find("#" + menuButtonId).width(180);

                $menuButton.find(".luckysheet-cols-menuitem").click(function () {
                    $menuButton.hide();
                    instance.util.luckysheetContainerFocus();

                    let $t = $(this),
                        itemvalue = $t.attr("itemvalue");
                        // 抗体编号需要调用后端计算，涉及到的互补决定区注释需要用到抗体编号，暂时先将两项功能都注释
                        // if (itemvalue === "antibodyNumbering") { // 抗体编号
                        //     // _this.proteinAnalysis.AntibodyNumber();
                        // }  else if (itemvalue === "cdr") { // 互补决定区注释
                        //     // _this.proteinAnalysis.cdrMark();
                        // } else
                        if (itemvalue === "proteinaa") { // 氨基酸组成分析
                            _this.proteinAnalysis.proteinAaFunction();
                        } else if (itemvalue === "proteinexpresschange") { // 氨基酸表示方法切换
                            _this.proteinAnalysis.proteinexpresschangeFunction();
                        }  else if (itemvalue === "proteinCopy") { // 蛋白质序列复制
                            _this.proteinAnalysis.proteinCopyFunction();
                        }    
                });
                // 蛋白质生化特性计算子菜单点击事件
                currentInstance
                    .off(`click.proteinfeatureanalysis-${containerId}`)
                    .on(
                        `click.proteinfeatureanalysis-${containerId}`,
                        `#luckysheet-icon-proteinfeatureanalysis-menuButton .luckysheet-cols-menuitem`,
                        function () {
                            $menuButton.hide();
                            currentInstance.find("#luckysheet-icon-proteinfeatureanalysis-menuButton").hide();
                            instance.util.luckysheetContainerFocus();

                            let $t = $(this),
                                itemvalue = $t.attr("itemvalue");
                                if (itemvalue === 'isoelectricPoint') { // 等电量
                                    _this.proteinAnalysis.isoelectricPointFunction();
                                } else if (itemvalue === 'proteinMw') { // 蛋白质分子量
                                    _this.proteinAnalysis.proteinMwFunction();
                                } else if (itemvalue === 'Hydrophobicity') { // 氨基酸疏水性
                                    _this.proteinAnalysis.Hydrophobicity();
                                } else if (itemvalue === 'instabilityIndex') { // 蛋白质不稳定系数
                                    _this.proteinAnalysis.instabilityIndexFunction();
                                } else if (itemvalue === 'proteinextinctioncoefficient') { // 蛋白质消光系数
                                    _this.proteinAnalysis.extinctionCoefficient();
                                }
                        },
                    );
                // 蛋白质序列比对子菜单点击事件
                currentInstance
                    .off(`click.proteinblastp-${containerId}`)
                    .on(
                        `click.proteinblastp-${containerId}`,
                        `#luckysheet-icon-proteinblastp-menuButton .luckysheet-cols-menuitem`,
                        function () {
                            $menuButton.hide();
                            currentInstance.find("#luckysheet-icon-proteinblastp-menuButton").hide();
                            instance.util.luckysheetContainerFocus();

                            let $t = $(this),
                                itemvalue = $t.attr("itemvalue");
                                if (itemvalue === 'blastp') { // 蛋白质双序列比对
                                    _this.proteinAnalysis.doubleAlignment();
                                } else if (itemvalue === 'proteinBLASTCompare') { // BLAST序列比对
                                    _this.proteinAnalysis.BLASTAlignment();
                                }
                        },
                    );
                    // 氨基酸表示方法切换子菜单点击事件
                    currentInstance
                    .off(`click.proteinexpresschange-${containerId}`)
                    .on(
                        `click.proteinexpresschange-${containerId}`,
                        `#luckysheet-icon-proteinexpresschange-menuButton .luckysheet-cols-menuitem`,
                        function () {
                            $menuButton.hide();
                            currentInstance.find("#luckysheet-icon-proteinexpresschange-menuButton").hide();
                            instance.util.luckysheetContainerFocus();

                            let $t = $(this),
                                itemvalue = $t.attr("itemvalue");
                                if (itemvalue === 'singleAA') { // 单字母表示
                                    _this.proteinAnalysis.singleAAFunction();
                                } else if (itemvalue === 'tripleAA') { // 三字母表示
                                    _this.proteinAnalysis.tripleAAFunction();
                                }
                        },
                    );
            }
            // 菜单位置
            let userlen = $(this).outerWidth() * Store.scale;
            let tlen = $menuButton.outerWidth() * Store.scale;

            let menuleft = $(this).offset().left;
            if (tlen > userlen && tlen + menuleft > $("#" + Store.container).width() * Store.scale) {
                menuleft = menuleft - tlen + userlen;
            }
            instance.util.mouseclickposition($menuButton, menuleft, $(this).offset().top + 25 * Store.scale, "lefttop");
        })
        
        currentInstance
            .on("mouseover mouseleave", ".luckysheet-menuButton .luckysheet-cols-submenu", function (e) {
                let $t = $(this),
                    attrid = $t.attr("itemvalue")+'',
                    $attr = currentInstance.find("#luckysheet-icon-" + attrid + "-menuButton");

                if (e.type === "mouseover") {
                    let $con = $t.parent();
                    let instanceWidth = currentInstance.width(),
                        instanceHeight = currentInstance.height();
                    let menuW = $con.width(),
                        attrH = $attr.height() + 25,
                        attrW = $attr.width() + 5;
                    let offset = $t.offset();
                    let top = (offset.top - currentInstance.offset().top) / Store.scale,
                        left = (offset.left - currentInstance.offset().left) / Store.scale + menuW;

                    if (left + attrW > instanceWidth) {
                        left = (offset.left - currentInstance.offset().left) / Store.scale - attrW;
                    }

                    if (top + attrH > instanceHeight) {
                        top = instanceHeight - attrH;
                    }

                    $attr.css({ top: top, left: left }).show();
                    _this.rightclickmenu = $t;
                } else {
                    clearTimeout(_this.submenuhide[$attr.attr("id")]);
                    _this.submenuhide[$attr.attr("id")] = setTimeout(function () {
                        $attr.hide();
                    }, 200);
                }
            })
            .on("mouseover mouseleave", ".luckysheet-menuButton-sub", function (e) {
                if (e.type === "mouseover") {
                    _this.rightclickmenu.addClass("luckysheet-cols-menuitem-hover");
                    clearTimeout(_this.submenuhide[$(this).attr("id")]);
                } else {
                    _this.rightclickmenu.removeClass("luckysheet-cols-menuitem-hover");
                    $(this).hide();
                }
            });
    },
    getQKBorder: function (width, type, color) {
        let bordertype = "";

        if (width.indexOf("pt") > -1) {
            width = parseFloat(width);

            if (width < 1) {
            } else if (width < 1.5) {
                bordertype = "Medium";
            } else {
                bordertype = "Thick";
            }
        } else {
            width = parseFloat(width);

            if (width < 2) {
            } else if (width < 3) {
                bordertype = "Medium";
            } else {
                bordertype = "Thick";
            }
        }

        let style = 0;
        type = type.toLowerCase();

        if (type == "double") {
            style = 2;
        } else if (type == "dotted") {
            if (bordertype == "Medium" || bordertype == "Thick") {
                style = 3;
            } else {
                style = 10;
            }
        } else if (type == "dashed") {
            if (bordertype == "Medium" || bordertype == "Thick") {
                style = 4;
            } else {
                style = 9;
            }
        } else if (type == "solid") {
            if (bordertype == "Medium") {
                style = 8;
            } else if (bordertype == "Thick") {
                style = 13;
            } else {
                style = 1;
            }
        }

        return [style, color];
    },
    updateFormatCell: function (d, attr, foucsStatus, row_st, row_ed, col_st, col_ed) {
        const instance = this.instance;
        const containerId = instance.getInstanceId();
        let Store = instance.getStore();
        if (d == null || attr == null) {
            return;
        }
        if (attr == "ct") {
            for (let r = row_st; r <= row_ed; r++) {
                if (Store.config["rowhidden"] != null && Store.config["rowhidden"][r] != null) {
                    continue;
                }

                for (let c = col_st; c <= col_ed; c++) {
                    let cell = d[r][c],
                        value = null;

                    if (getObjType(cell) == "object") {
                        value = d[r][c]["v"];
                    } else {
                        value = d[r][c];
                    }

                    if (foucsStatus != "@" && isRealNum(value)) {
                        value = parseFloat(value);
                    }

                    let mask = update(foucsStatus, value);
                    let type = "n";

                    if (
                        is_date(foucsStatus) ||
                        foucsStatus === 14 ||
                        foucsStatus === 15 ||
                        foucsStatus === 16 ||
                        foucsStatus === 17 ||
                        foucsStatus === 18 ||
                        foucsStatus === 19 ||
                        foucsStatus === 20 ||
                        foucsStatus === 21 ||
                        foucsStatus === 22 ||
                        foucsStatus === 45 ||
                        foucsStatus === 46 ||
                        foucsStatus === 47
                    ) {
                        type = "d";
                    } else if (foucsStatus == "@" || foucsStatus === 49) {
                        type = "s";
                    } else if (foucsStatus == "General" || foucsStatus === 0) {
                        // type = "g";
                        type = isRealNum(value) ? "n" : "g";
                    }

                    if (getObjType(cell) == "object") {
                        d[r][c]["m"] = mask;
                        if (d[r][c]["ct"] == null) {
                            d[r][c]["ct"] = {};
                        }
                        d[r][c]["ct"]["fa"] = foucsStatus;
                        d[r][c]["ct"]["t"] = type;
                    } else {
                        d[r][c] = { ct: { fa: foucsStatus, t: type }, v: value, m: mask };
                    }
                }
            }
        } else {
            if (attr == "ht") {
                if (foucsStatus == "left") {
                    foucsStatus = "1";
                } else if (foucsStatus == "center") {
                    foucsStatus = "0";
                } else if (foucsStatus == "right") {
                    foucsStatus = "2";
                }
            } else if (attr == "vt") {
                if (foucsStatus == "top") {
                    foucsStatus = "1";
                } else if (foucsStatus == "middle") {
                    foucsStatus = "0";
                } else if (foucsStatus == "bottom") {
                    foucsStatus = "2";
                }
            } else if (attr == "tb") {
                if (foucsStatus == "overflow") {
                    foucsStatus = "1";
                } else if (foucsStatus == "clip") {
                    foucsStatus = "0";
                } else if (foucsStatus == "wrap") {
                    foucsStatus = "2";
                }
            } else if (attr == "tr") {
                if (foucsStatus == "none") {
                    foucsStatus = "0";
                } else if (foucsStatus == "angleup") {
                    foucsStatus = "1";
                } else if (foucsStatus == "angledown") {
                    foucsStatus = "2";
                } else if (foucsStatus == "vertical") {
                    foucsStatus = "3";
                } else if (foucsStatus == "rotation-up") {
                    foucsStatus = "4";
                } else if (foucsStatus == "rotation-down") {
                    foucsStatus = "5";
                }
            }

            for (let r = row_st; r <= row_ed; r++) {
                if (Store.config["rowhidden"] != null && Store.config["rowhidden"][r] != null) {
                    continue;
                }

                for (let c = col_st; c <= col_ed; c++) {
                    let value = d[r][c];

                    if (getObjType(value) == "object") {
                        // if(attr in inlineStyleAffectAttribute && isInlineStringCell(value)){
                        updateInlineStringFormatOutside(value, attr, foucsStatus);
                        // }
                        // else{
                        d[r][c][attr] = foucsStatus;
                        // }
                    } else {
                        d[r][c] = { v: value };
                        d[r][c][attr] = foucsStatus;
                    }

                    // if(attr == "tr" && d[r][c].tb != null){
                    //     d[r][c].tb = "0";
                    // }
                }
            }
        }
    },
    updateFormat: function (containerId, d, attr, foucsStatus) {
        let _this = this;
        const instance = _this.instance;
        containerId = containerId || instance.getInstanceId();
	    let Store = instance.getStore();
        let currentInstance = $(`#${containerId}`);

        if (!instance.protection.checkProtectionFormatCells(Store.currentSheetIndex)) {
            return;
        }

        // *如果禁止前台编辑，则中止下一步操作
        if (!instance.validate.checkIsAllowEdit()) {
            // instance.tooltip.info("", instance.locale().pivotTable.errorNotAllowEdit);
            return;
        }

        let canvasElement = document.createElement("canvas");
        let canvas = canvasElement.getContext("2d");

        if (attr in inlineStyleAffectAttribute) {
            if (parseInt(currentInstance.find("#luckysheet-input-box").css("top")) > 0) {
                let value = currentInstance.find("#luckysheet-input-box").text();
                if (value.substr(0, 1) != "=") {
                    let cell = d[Store.luckysheetCellUpdate[0]][Store.luckysheetCellUpdate[1]];
                    instance.inlineString.updateInlineStringFormat(cell, attr, foucsStatus, instance.formula.rangeResizeTo);
                    // return;
                }
            }
        }

        let cfg = $.extend(true, {}, Store.config);
        if (cfg["rowlen"] == null) {
            cfg["rowlen"] = {};
        }

        for (let s = 0; s < Store.luckysheet_select_save.length; s++) {
            let row_st = Store.luckysheet_select_save[s]["row"][0],
                row_ed = Store.luckysheet_select_save[s]["row"][1];
            let col_st = Store.luckysheet_select_save[s]["column"][0],
                col_ed = Store.luckysheet_select_save[s]["column"][1];

            this.updateFormatCell(d, attr, foucsStatus, row_st, row_ed, col_st, col_ed);

            if (attr == "tb" || attr == "tr" || attr == "fs") {
                cfg = instance.getRowlen.rowlenByRange(d, row_st, row_ed, cfg, containerId);
            }
        }

        let allParam = {};
        if (attr == "tb" || attr == "tr" || attr == "fs") {
            allParam = {
                cfg: cfg,
                RowlChange: true,
            };
        }

        instance.refresh.jfrefreshgrid(d, Store.luckysheet_select_save, allParam, false);
    },
    updateFormat_mc: function (containerId, d, foucsStatus) {
        const instance = this.instance;
	    let Store = instance.getStore();
        // *如果禁止前台编辑，则中止下一步操作
        if (!instance.validate.checkIsAllowEdit()) {
            // instance.tooltip.info("", instance.locale().pivotTable.errorNotAllowEdit);
            return;
        }
        let cfg = $.extend(true, {}, Store.config);
        if (cfg["merge"] == null) {
            cfg["merge"] = {};
        }

        if (!instance.protection.checkProtectionNotEnable(Store.currentSheetIndex)) {
            return;
        }

        if (foucsStatus == "mergeCancel") {
            for (let i = 0; i < Store.luckysheet_select_save.length; i++) {
                let range = Store.luckysheet_select_save[i];
                let r1 = range["row"][0],
                    r2 = range["row"][1];
                let c1 = range["column"][0],
                    c2 = range["column"][1];

                if (r1 == r2 && c1 == c2) {
                    continue;
                }

                let fv = {};

                for (let r = r1; r <= r2; r++) {
                    for (let c = c1; c <= c2; c++) {
                        let cell = d[r][c];

                        if (cell != null && cell.mc != null) {
                            let mc_r = cell.mc.r,
                                mc_c = cell.mc.c;

                            if ("rs" in cell.mc) {
                                delete cell.mc;
                                delete cfg["merge"][mc_r + "_" + mc_c];

                                fv[mc_r + "_" + mc_c] = $.extend(true, {}, cell);
                            } else {
                                // let cell_clone = fv[mc_r + "_" + mc_c];
                                let cell_clone = JSON.parse(JSON.stringify(fv[mc_r + "_" + mc_c]));

                                delete cell_clone.v;
                                delete cell_clone.m;
                                delete cell_clone.ct;
                                delete cell_clone.f;
                                delete cell_clone.spl;

                                d[r][c] = cell_clone;
                            }
                        }
                    }
                }
            }
        } else {
            let isHasMc = false; //选区是否含有 合并的单元格

            for (let i = 0; i < Store.luckysheet_select_save.length; i++) {
                let range = Store.luckysheet_select_save[i];
                let r1 = range["row"][0],
                    r2 = range["row"][1];
                let c1 = range["column"][0],
                    c2 = range["column"][1];

                for (let r = r1; r <= r2; r++) {
                    for (let c = c1; c <= c2; c++) {
                        let cell = d[r][c];

                        if (getObjType(cell) == "object" && "mc" in cell) {
                            isHasMc = true;
                            break;
                        }
                    }
                }
            }

            if (isHasMc) {
                //选区有合并单元格（选区都执行 取消合并）
                for (let i = 0; i < Store.luckysheet_select_save.length; i++) {
                    let range = Store.luckysheet_select_save[i];
                    let r1 = range["row"][0],
                        r2 = range["row"][1];
                    let c1 = range["column"][0],
                        c2 = range["column"][1];

                    if (r1 == r2 && c1 == c2) {
                        continue;
                    }

                    let fv = {};

                    for (let r = r1; r <= r2; r++) {
                        for (let c = c1; c <= c2; c++) {
                            let cell = d[r][c];

                            if (cell != null && cell.mc != null) {
                                let mc_r = cell.mc.r,
                                    mc_c = cell.mc.c;

                                if ("rs" in cell.mc) {
                                    delete cell.mc;
                                    delete cfg["merge"][mc_r + "_" + mc_c];

                                    fv[mc_r + "_" + mc_c] = $.extend(true, {}, cell);
                                } else {
                                    // let cell_clone = fv[mc_r + "_" + mc_c];
                                    let cell_clone = JSON.parse(JSON.stringify(fv[mc_r + "_" + mc_c]));

                                    delete cell_clone.v;
                                    delete cell_clone.m;
                                    delete cell_clone.ct;
                                    delete cell_clone.f;
                                    delete cell_clone.spl;

                                    d[r][c] = cell_clone;
                                }
                            }
                        }
                    }
                }
            } else {
                for (let i = 0; i < Store.luckysheet_select_save.length; i++) {
                    let range = Store.luckysheet_select_save[i];
                    let r1 = range["row"][0],
                        r2 = range["row"][1];
                    let c1 = range["column"][0],
                        c2 = range["column"][1];

                    if (r1 == r2 && c1 == c2) {
                        continue;
                    }

                    if (foucsStatus == "mergeAll") {
                        let fv = {},
                            isfirst = false;

                        for (let r = r1; r <= r2; r++) {
                            for (let c = c1; c <= c2; c++) {
                                let cell = d[r][c];

                                if (
                                    cell != null &&
                                    (isInlineStringCT(cell.ct) || !isRealNull(cell.v) || cell.f != null) &&
                                    !isfirst
                                ) {
                                    fv = $.extend(true, {}, cell);
                                    isfirst = true;
                                }

                                d[r][c] = { mc: { r: r1, c: c1 } };
                            }
                        }

                        d[r1][c1] = fv;
                        d[r1][c1].mc = { r: r1, c: c1, rs: r2 - r1 + 1, cs: c2 - c1 + 1 };

                        cfg["merge"][r1 + "_" + c1] = { r: r1, c: c1, rs: r2 - r1 + 1, cs: c2 - c1 + 1 };
                    } else if (foucsStatus == "mergeV") {
                        for (let c = c1; c <= c2; c++) {
                            let fv = {},
                                isfirst = false;

                            for (let r = r1; r <= r2; r++) {
                                let cell = d[r][c];

                                if (cell != null && (!isRealNull(cell.v) || cell.f != null) && !isfirst) {
                                    fv = $.extend(true, {}, cell);
                                    isfirst = true;
                                }

                                d[r][c] = { mc: { r: r1, c: c } };
                            }

                            d[r1][c] = fv;
                            d[r1][c].mc = { r: r1, c: c, rs: r2 - r1 + 1, cs: 1 };

                            cfg["merge"][r1 + "_" + c] = { r: r1, c: c, rs: r2 - r1 + 1, cs: 1 };
                        }
                    } else if (foucsStatus == "mergeH") {
                        for (let r = r1; r <= r2; r++) {
                            let fv = {},
                                isfirst = false;

                            for (let c = c1; c <= c2; c++) {
                                let cell = d[r][c];

                                if (cell != null && (!isRealNull(cell.v) || cell.f != null) && !isfirst) {
                                    fv = $.extend(true, {}, cell);
                                    isfirst = true;
                                }

                                d[r][c] = { mc: { r: r, c: c1 } };
                            }

                            d[r][c1] = fv;
                            d[r][c1].mc = { r: r, c: c1, rs: 1, cs: c2 - c1 + 1 };

                            cfg["merge"][r + "_" + c1] = { r: r, c: c1, rs: 1, cs: c2 - c1 + 1 };
                        }
                    }
                }
            }
        }

        const file = Store.luckysheetfile[instance.get.getSheetIndex(Store.currentSheetIndex)];
        const calc = file.calcChain?.filter(({ r, c }) => d[r][c]?.f);
        const hyperlink =
            file.hyperlink &&
            Object.fromEntries(
                Object.entries(file.hyperlink).filter(([r_c]) => {
                    const [r, c] = r_c.split("_");
                    return d[r][c]?.v;
                }),
            );

        if (Store.clearjfundo) {
            Store.jfundo.length = 0;
            Store.jfredo.push({
                type: "mergeChange",
                sheetIndex: Store.currentSheetIndex,
                data: Store.flowdata,
                curData: d,
                range: $.extend(true, [], Store.luckysheet_select_save),
                config: $.extend(true, {}, Store.config),
                curConfig: cfg,
                calc: file.calcChain,
                curCalc: calc,
                hyperlink: file.hyperlink,
                curHyperlink: hyperlink,
            });
        }

        Store.clearjfundo = false;
        instance.refresh.jfrefreshgrid(d, Store.luckysheet_select_save, { cfg, calc, hyperlink });
        Store.clearjfundo = true;
    },
    borderfix: function (d, r, c) {
        // return [-1, -1, 2, 2];

        let cell = d[r][c];
        let bg = null;

        if (cell == null) {
            return [-1, 0, 0, -1];
        } else if (d[r][c].bg == null || d[r][c].bg == "") {
            return [-1, 0, 0, -1];
        } else {
            return [-2, -1, 1, 0];
            //return [-2, -2, 1, 0];
        }
    },
    changeMenuButtonDom: function (attr, foucsStatus, _locale, container) {
        let _this = this;
        const instance = this.instance;
        if (_locale == null) {
            _locale = instance.locale();
        }
        const locale_fontarray = _locale.fontarray;
        const locale_fontjson = _locale.fontjson;
        const containerId = container || instance.getInstanceId();
        let currentInstance = $(`#${containerId}`);

        if (attr == "bl") {
            let $boldButton = $(`#${containerId} #luckysheet-icon-bold`);
            if (foucsStatus != "0") {
                $boldButton.addClass("luckysheet-toolbar-button-hover");
            } else {
                $boldButton.removeClass("luckysheet-toolbar-button-hover");
            }
        } else if (attr == "it") {
            let $italicButton = $(`#${containerId} #luckysheet-icon-italic`);
            if (foucsStatus != "0") {
                $italicButton.addClass("luckysheet-toolbar-button-hover");
            } else {
                $italicButton.removeClass("luckysheet-toolbar-button-hover");
            }
        } else if (attr == "cl") {
            let $strikethroughButton = $(`#${containerId} #luckysheet-icon-strikethrough`);
            if (foucsStatus != "0") {
                $strikethroughButton.addClass("luckysheet-toolbar-button-hover");
            } else {
                $strikethroughButton.removeClass("luckysheet-toolbar-button-hover");
            }
        } else if (attr == "un") {
            let $underlineButton = $(`#${containerId} #luckysheet-icon-underline`);
            if (foucsStatus != "0") {
                $underlineButton.addClass("luckysheet-toolbar-button-hover");
            } else {
                $underlineButton.removeClass("luckysheet-toolbar-button-hover");
            }
        } else if (attr == "ff") {
            let menuButtonId = `luckysheet-icon-font-family-menuButton`;
            let $menuButton = currentInstance.find("#" + menuButtonId);
            // const locale_fontarray = instance.locale().fontarray;
            let itemname = locale_fontarray[0],
                itemvalue = 0;
            if (foucsStatus != null) {
                if (isdatatypemulti(foucsStatus)["num"]) {
                    itemvalue = parseInt(foucsStatus);
                    itemname = locale_fontarray[itemvalue];

                    if (itemname == null) {
                        itemvalue = _this.defualtFont[itemvalue];
                        itemname = itemvalue;
                        if (itemvalue != null) {
                            _this.addFontTolist(itemvalue);
                        }
                    }
                } else {
                    foucsStatus = foucsStatus.replace(/"/g, "").replace(/'/g, "");
                    itemvalue = foucsStatus;
                    itemname = foucsStatus;

                    _this.addFontTolist(itemvalue);
                }
            }

            _this.focus($menuButton, itemvalue);
            currentInstance.find("#luckysheet-icon-font-family")
                .find(".luckysheet-toolbar-menu-button-caption")
                .html(" " + itemname + " ");
        } else if (attr == "fs") {
            let $menuButton = currentInstance.find(`#luckysheet-icon-font-size-menuButton`);
            let itemvalue = foucsStatus,
                $input = currentInstance.find("#luckysheet-icon-font-size input");
            _this.focus($menuButton, itemvalue);
            currentInstance.find("#luckysheet-icon-font-size").attr("itemvalue", itemvalue);
            $input.val(itemvalue);
        } else if (attr == "ht") {
            let $menuButton = currentInstance.find(`#luckysheet-icon-align-menu-menuButton`);
            let $t = currentInstance.find("luckysheet-icon-align"),
                itemvalue = "left";

            if (foucsStatus == "0") {
                itemvalue = "center";
            } else if (foucsStatus == "2") {
                itemvalue = "right";
            }

            _this.focus($menuButton, itemvalue);

            // add iconfont
            const iconfontObject = iconfontObjects.align;

            let $icon = currentInstance.find("#luckysheet-icon-align")
                .attr("type", itemvalue)
                .find(".luckysheet-icon-img-container");
            $icon
                .removeAttr("class")
                .addClass(
                    "luckysheet-icon-img-container luckysheet-icon-img luckysheet-icon-align-" +
                    itemvalue +
                    iconfontObject[itemvalue],
                );
            $menuButton.hide();
        } else if (attr == "vt") {
            let $menuButton = currentInstance.find(`#luckysheet-icon-valign-menu-menuButton`);
            let $t = currentInstance.find("luckysheet-icon-valign"),
                itemvalue = "bottom";

            if (foucsStatus == "1") {
                itemvalue = "top";
            } else if (foucsStatus == "0") {
                itemvalue = "middle";
            }

            _this.focus($menuButton, itemvalue);

            // add iconfont
            const iconfontObject = iconfontObjects.align;

            let $icon = currentInstance.find("#luckysheet-icon-valign")
                .attr("type", itemvalue)
                .find(".luckysheet-icon-img-container");
            $icon
                .removeAttr("class")
                .addClass(
                    "luckysheet-icon-img-container luckysheet-icon-img luckysheet-icon-valign-" +
                    itemvalue +
                    iconfontObject[itemvalue],
                );
            $menuButton.hide();
        } else if (attr == "tb") {
            let $menuButton = currentInstance.find(`#luckysheet-icon-textwrap-menu-menuButton`);
            let $t = currentInstance.find("luckysheet-icon-textwrap"),
                itemvalue = "clip";

            if (foucsStatus == "1") {
                itemvalue = "overflow";
            } else if (foucsStatus == "2") {
                itemvalue = "wrap";
            }

            _this.focus($menuButton, itemvalue);

            // add iconfont
            const iconfontObject = iconfontObjects.textWrap;

            let $icon = currentInstance.find("#luckysheet-icon-textwrap")
                .attr("type", itemvalue)
                .find(".luckysheet-icon-img-container");
            $icon
                .removeAttr("class")
                .addClass(
                    "luckysheet-icon-img-container luckysheet-icon-img luckysheet-icon-textwrap-" +
                    itemvalue +
                    iconfontObject[itemvalue],
                );
            $menuButton.hide();
        } else if (attr == "tr") {
            let $menuButton = currentInstance.find(`#luckysheet-icon-rotation-menu-menuButton`);
            let $t = currentInstance.find("luckysheet-icon-rotation"),
                itemvalue = "none";

            if (foucsStatus == "1") {
                itemvalue = "angleup";
            } else if (foucsStatus == "2") {
                itemvalue = "angledown";
            } else if (foucsStatus == "3") {
                itemvalue = "vertical";
            } else if (foucsStatus == "4") {
                itemvalue = "rotation-up";
            } else if (foucsStatus == "5") {
                itemvalue = "rotation-down";
            }

            _this.focus($menuButton, itemvalue);

            // add iconfont
            const iconfontObject = iconfontObjects.rotation;

            let $icon = currentInstance.find("#luckysheet-icon-rotation")
                .attr("type", itemvalue)
                .find(".luckysheet-icon-img-container");
            $icon
                .removeAttr("class")
                .addClass(
                    "luckysheet-icon-img-container luckysheet-icon-img luckysheet-icon-rotation-" +
                    itemvalue +
                    iconfontObject[itemvalue],
                );
            $menuButton.hide();
        } else if (attr == "ct") {
            let $menuButton = currentInstance.find("#luckysheet-icon-fmt-other");
            const _locale = instance.locale();
            const locale_defaultFmt = _locale.defaultFmt;
            if (!foucsStatus) {
                $menuButton.find(".luckysheet-toolbar-menu-button-caption").html(" " + locale_defaultFmt[0].text + " ");
                return;
            }
            const { fa } = foucsStatus;
            const format = locale_defaultFmt.find((f) => f.value === fa);
            if (format) {
                $menuButton.find(".luckysheet-toolbar-menu-button-caption").html(" " + format.text + " ");
            } else {
                const otherFormat = locale_defaultFmt.find((f) => f.value === "fmtOtherSelf");
                $menuButton.find(".luckysheet-toolbar-menu-button-caption").html(" " + otherFormat.text + " ");
            }
        }
    },
    inputMenuButtonFocus: function (focusTarget) {
        const instance = this.instance;
        const containerId = instance.getInstanceId();
        let Store = instance.getStore();
        var w = window.getSelection();
        var range = w.getRangeAt(0);
        let startContainer = range.startContainer;
        Store.inlineStringEditRange = null;
        const _locale = instance.locale();
        if (startContainer.parentNode.tagName == "SPAN") {
            let cssText = startContainer.parentNode.style.cssText;
            let stylelist = instance.inlineString.convertCssToStyleList(cssText);
            for (let key in stylelist) {
                this.changeMenuButtonDom(key, stylelist[key], _locale);
            }
        }
    },
    menuButtonFocus: function (d, r, c, container) {
        let _this = this;
        const instance = _this.instance;
        let foucsList = ["bl", "it", "cl", "ff", "ht", "vt", "fs", "tb", "tr", "ct", "un"];
        const _locale = instance.locale();
        for (let i = 0; i < foucsList.length; i++) {
            let attr = foucsList[i];
            let foucsStatus = _this.checkstatus(d, r, c, attr);

            this.changeMenuButtonDom(attr, foucsStatus, _locale, container);
        }
    },
    checkstatus: function (d, r, c, a, container) {
        const instance = this.instance;
        if (d == null || d[r] == null) {
            console.warn("It's incorrect data", r, c);
            return null;
        }
        let foucsStatus = d[r][c];
        return instance.getdata.checkstatusByCell(foucsStatus, a, container);
    },
    setLineDash: function (canvasborder, type, hv, m_st, m_ed, line_st, line_ed) {
        let borderType = {
            "0": "none",
            "1": "Thin",
            "2": "Hair",
            "3": "Dotted",
            "4": "Dashed",
            "5": "DashDot",
            "6": "DashDotDot",
            "7": "Double",
            "8": "Medium",
            "9": "MediumDashed",
            "10": "MediumDashDot",
            "11": "MediumDashDotDot",
            "12": "SlantedDashDot",
            "13": "Thick",
        };

        type = borderType[type.toString()];

        try {
            if (type == "Hair") {
                canvasborder.setLineDash([1, 2]);
            } else if (type.indexOf("DashDotDot") > -1) {
                canvasborder.setLineDash([2, 2, 5, 2, 2]);
            } else if (type.indexOf("DashDot") > -1) {
                canvasborder.setLineDash([2, 5, 2]);
            } else if (type.indexOf("Dotted") > -1) {
                canvasborder.setLineDash([2]);
            } else if (type.indexOf("Dashed") > -1) {
                canvasborder.setLineDash([3]);
            } else {
                canvasborder.setLineDash([0]);
            }
        } catch (e) {
            console.log(e);
        }

        canvasborder.beginPath();

        if (type.indexOf("Medium") > -1) {
            if (hv == "h") {
                canvasborder.moveTo(m_st, m_ed - 0.5);
                canvasborder.lineTo(line_st, line_ed - 0.5);
            } else {
                canvasborder.moveTo(m_st - 0.5, m_ed);
                canvasborder.lineTo(line_st - 0.5, line_ed);
            }

            canvasborder.lineWidth = 2;
        } else if (type == "Thick") {
            canvasborder.moveTo(m_st, m_ed);
            canvasborder.lineTo(line_st, line_ed);
            canvasborder.lineWidth = 3;
        } else {
            canvasborder.moveTo(m_st, m_ed);
            canvasborder.lineTo(line_st, line_ed);
            canvasborder.lineWidth = 1;
        }
    },
    moveMergeData: function (d, offset_r, offset_c) {
        if (isRealNull(d)) {
            return d;
        }

        let deleMC = [],
            insertMC = [],
            hasMC = false;

        for (let r = 0; r < d.length; r++) {
            for (let c = 0; c < d[0].length; c++) {
                let cell = d[r][c];

                if (getObjType(cell) == "object" && "mc" in cell) {
                    if (cell.mc.rs != null) {
                        deleMC.push({
                            rs: cell.mc.rs,
                            cs: cell.mc.cs,
                            r: cell.mc.r,
                            c: cell.mc.c,
                        });
                        insertMC.push({
                            rs: cell.mc.rs,
                            cs: cell.mc.cs,
                            r: cell.mc.r + offset_r,
                            c: cell.mc.c + offset_c,
                        });

                        hasMC = true;
                    }

                    d[r][c].mc.r += offset_r;
                    d[r][c].mc.c += offset_c;
                }
            }
        }

        return { deleMC: deleMC, insertMC: insertMC, hasMC: hasMC };
    },
    getRangeInMerge: function (st_r, rlen, st_c, clen, sheetIndex) {
        const instance = this.instance;
        const containerId = instance.getInstanceId();
        let Store = instance.getStore();
        let _this = this;

        let mergelist = [];
        let cfg = null;
        if (sheetIndex != null) {
            cfg = $.extend(true, {}, _this.getSheetConfig());
        } else {
            cfg = $.extend(true, {}, Store.config);
        }

        if (cfg != null && cfg["merge"] != null) {
            for (let key in cfg["merge"]) {
                let mc = cfg["merge"][key];
                if (
                    !(st_r + rlen - 1 < mc.r || st_r > mc.r + mc.rs - 1) &&
                    !(st_c + clen - 1 < mc.c || st_c > mc.c + mc.cs - 1)
                ) {
                    mergelist.push(mc);
                }
            }
        }

        return mergelist;
    },
    mergeborer: function (d, row_index, col_index, container) {
        const instance = this.instance;
        const containerId = container || instance.getInstanceId();
	    let Store = instance.getStore();
        if (d == null || d[row_index] == null) {
            console.warn("Merge info is null", row_index, col_index);
            return null;
        }
        let value = d[row_index][col_index];

        if (getObjType(value) == "object" && "mc" in value) {
            let margeMaindata = value["mc"];
            if (margeMaindata == null) {
                console.warn("Merge info is null", row_index, col_index);
                return null;
            }
            col_index = margeMaindata.c;
            row_index = margeMaindata.r;

            if (d[row_index][col_index] == null) {
                console.warn("Main merge Cell info is null", row_index, col_index);
                return null;
            }
            let col_rs = d[row_index][col_index].mc.cs;
            let row_rs = d[row_index][col_index].mc.rs;

            let margeMain = d[row_index][col_index].mc;

            let start_r, end_r, row, row_pre;
            for (let r = row_index; r < margeMain.rs + row_index; r++) {
                if (r == 0) {
                    start_r = -1;
                } else {
                    start_r = Store.visibledatarow[r - 1] - 1;
                }

                end_r = Store.visibledatarow[r];

                if (row_pre == null) {
                    row_pre = start_r;
                    row = end_r;
                } else {
                    row += end_r - start_r - 1;
                }
            }

            let start_c, end_c, col, col_pre;
            for (let c = col_index; c < margeMain.cs + col_index; c++) {
                if (c == 0) {
                    start_c = 0;
                } else {
                    start_c = Store.visibledatacolumn[c - 1];
                }

                end_c = Store.visibledatacolumn[c];

                if (col_pre == null) {
                    col_pre = start_c;
                    col = end_c;
                } else {
                    col += end_c - start_c;
                }
            }

            return {
                row: [row_pre, row, row_index, row_index + row_rs - 1],
                column: [col_pre, col, col_index, col_index + col_rs - 1],
            };
        } else {
            return null;
        }
    },
    mergeMoveData: {},
    mergeMoveMain: function (columnseleted, rowseleted, s, top, height, left, width) {
        let _this = this;
        const instance = this.instance;
        let mergesetting = instance.sheetmanage.getSheetMerge();

        if (mergesetting == null) {
            return;
        }

        let mcset = [];
        for (let key in mergesetting) {
            mcset.push(key);
        }

        if (rowseleted[0] > rowseleted[1]) {
            rowseleted[1] = rowseleted[0];
        }

        if (columnseleted[0] > columnseleted[1]) {
            columnseleted[1] = columnseleted[0];
        }

        let offloop = true;
        _this.mergeMoveData = {};

        while (offloop) {
            offloop = false;

            for (let i = 0; i < mcset.length; i++) {
                let key = mcset[i];
                let mc = mergesetting[key];

                if (key in _this.mergeMoveData) {
                    continue;
                }

                let changeparam = _this.mergeMove(mc, columnseleted, rowseleted, s, top, height, left, width);

                if (changeparam != null) {
                    _this.mergeMoveData[key] = mc;

                    columnseleted = changeparam[0];
                    rowseleted = changeparam[1];
                    top = changeparam[2];
                    height = changeparam[3];
                    left = changeparam[4];
                    width = changeparam[5];

                    offloop = true;
                } else {
                    delete _this.mergeMoveData[key];
                }
            }
        }

        return [columnseleted, rowseleted, top, height, left, width];
    },
    mergeMove: function (mc, columnseleted, rowseleted, s, top, height, left, width, container) {
        let _this = this;

        let row_st = mc.r,
            row_ed = mc.r + mc.rs - 1;
        let col_st = mc.c,
            col_ed = mc.c + mc.cs - 1;
        let ismatch = false;
        const instance = this.instance;
        const containerId = instance.getInstanceId();
        let Store = instance.getStore();

        if (columnseleted[1] < columnseleted[0]) {
            columnseleted[0] = columnseleted[1];
        }

        if (rowseleted[1] < rowseleted[0]) {
            rowseleted[0] = rowseleted[1];
        }

        if (
            (columnseleted[0] <= col_st &&
                columnseleted[1] >= col_ed &&
                rowseleted[0] <= row_st &&
                rowseleted[1] >= row_ed) ||
            (!(columnseleted[1] < col_st || columnseleted[0] > col_ed) &&
                !(rowseleted[1] < row_st || rowseleted[0] > row_ed))
        ) {
            let margeset = _this.mergeborer(Store.flowdata, mc.r, mc.c);
            if (!!margeset) {
                let row = margeset.row[1],
                    row_pre = margeset.row[0],
                    row_index = margeset.row[2],
                    col = margeset.column[1],
                    col_pre = margeset.column[0],
                    col_index = margeset.column[2];

                if (!(columnseleted[1] < col_st || columnseleted[0] > col_ed)) {
                    //向上滑动
                    if (rowseleted[0] <= row_ed && rowseleted[0] >= row_st) {
                        height += top - row_pre;
                        top = row_pre;
                        rowseleted[0] = row_st;
                    }

                    //向下滑动或者居中时往上滑动的向下补齐
                    if (rowseleted[1] >= row_st && rowseleted[1] <= row_ed) {
                        if (s.row_focus >= row_st && s.row_focus <= row_ed) {
                            height = row - top;
                        } else {
                            height = row - top;
                        }

                        rowseleted[1] = row_ed;
                    }
                }

                if (!(rowseleted[1] < row_st || rowseleted[0] > row_ed)) {
                    if (columnseleted[0] <= col_ed && columnseleted[0] >= col_st) {
                        width += left - col_pre;
                        left = col_pre;
                        columnseleted[0] = col_st;
                    }

                    //向右滑动或者居中时往左滑动的向下补齐
                    if (columnseleted[1] >= col_st && columnseleted[1] <= col_ed) {
                        if (s.column_focus >= col_st && s.column_focus <= col_ed) {
                            width = col - left;
                        } else {
                            width = col - left;
                        }

                        columnseleted[1] = col_ed;
                    }
                }

                ismatch = true;
            }
        }

        if (ismatch) {
            return [columnseleted, rowseleted, top, height, left, width];
        } else {
            return null;
        }
    },
    getCellRealSize: function (d, cell_r, cell_c, container) {
        let _this = this;
        const instance = this.instance;
        const containerId = instance.getInstanceId();
        let Store = instance.getStore();
        let width = Store.defaultcollen;
        let height = Store.defaultrowlen;
        let celldata = d[cell_r][cell_c];

        if (!!celldata && celldata["mc"] != null) {
            let mc = celldata["mc"];
            let margeset = _this.mergeborer(d, mc.r, mc.c);

            if (!!margeset) {
                let row = margeset.row[1];
                let row_pre = margeset.row[0];
                let row_index = margeset.row[2];
                let row_index_ed = margeset.row[3];

                let col = margeset.column[1];
                let col_pre = margeset.column[0];
                let col_index = margeset.column[2];
                let col_index_ed = margeset.column[3];

                width = col - col_pre - 1;
                height = row - row_pre - 1;
            }
        } else {
            let config = instance.get.getluckysheetfile()[instance.get.getSheetIndex(Store.currentSheetIndex)]["config"];

            if (config["columnlen"] != null && config["columnlen"][cell_c] != null) {
                width = config["columnlen"][cell_c];
            }

            if (config["rowlen"] != null && config["rowlen"][cell_r] != null) {
                height = config["rowlen"][cell_r];
            }
        }

        return [width, height];
    },
    getTextHeightCache: {},
    getTextSize: function (text, font, containerId) {
        const instance = this.instance;
        let fontarray = instance.locale().fontarray;
        let f = font || "10pt " + fontarray[0];
        if (!containerId) {
            containerId = instance.getInstanceId();
        }
        let currentInstance = $(`#${containerId}`);

        let _this = this;

        if (f in _this.getTextHeightCache) {
            return _this.getTextHeightCache[f];
        }

        if (currentInstance.find(`#luckysheetTextSizeTest`).length == 0) {
            $(
                '<span id="luckysheetTextSizeTest" style="float:left;white-space:nowrap;visibility:hidden;margin:0;padding:0;">' +
                text +
                "</span>",
            ).appendTo($(`#${containerId}`));
        }

        let o = currentInstance.find(`#luckysheetTextSizeTest`)
            .text(text)
            .css({ font: f }),
            w = o.innerWidth(),
            h = o.innerHeight();

        _this.getTextHeightCache[f] = [w, h];

        return [w, h];
    },
    activeFormulaInput: function (row_index, col_index, rowh, columnh, formula, isnull) {
        const instance = this.instance;
        const containerId = instance.getInstanceId();
        let Store = instance.getStore();
        let _this = this;
        let currentInstance = $(`#${containerId}`);

        if (isnull == null) {
            isnull = false;
        }

        instance.updateCell.luckysheetupdateCell(row_index, col_index, Store.flowdata, true);

        if (isnull) {
            let formulaTxt =
                '<span dir="auto" class="luckysheet-formula-text-color">=</span><span dir="auto" class="luckysheet-formula-text-color">' +
                formula.toUpperCase() +
                '</span><span dir="auto" class="luckysheet-formula-text-color">(</span><span dir="auto" class="luckysheet-formula-text-color">)</span>';

            currentInstance.find("#luckysheet-rich-text-editor").html(formulaTxt);

            let currSelection = window.getSelection();
            let $span = currentInstance.find("#luckysheet-rich-text-editor").find("span");
            instance.formula.setCaretPosition($span.get($span.length - 2), 0, 1);

            return;
        }

        let row_pre = instance.location.rowLocationByIndex(rowh[0])[0],
            row = instance.location.rowLocationByIndex(rowh[1])[1],
            col_pre = instance.location.colLocationByIndex(columnh[0])[0],
            col = instance.location.colLocationByIndex(columnh[1])[1];

        let formulaTxt =
            '<span dir="auto" class="luckysheet-formula-text-color">=</span><span dir="auto" class="luckysheet-formula-text-color">' +
            formula.toUpperCase() +
            '</span><span dir="auto" class="luckysheet-formula-text-color">(</span><span class="luckysheet-formula-functionrange-cell" rangeindex="0" dir="auto" style="color:' +
            luckyColor[0] +
            ';">' +
            instance.get.getRangetxt(Store.currentSheetIndex, { row: rowh, column: columnh }, Store.currentSheetIndex) +
            '</span><span dir="auto" class="luckysheet-formula-text-color">)</span>';
        currentInstance.find("#luckysheet-rich-text-editor").html(formulaTxt);

        instance.formula.israngeseleciton();
        instance.formula.rangestart = true;
        instance.formula.rangedrag_column_start = false;
        instance.formula.rangedrag_row_start = false;
        instance.formula.rangechangeindex = 0;
        instance.formula.rangeSetValue({ row: rowh, column: columnh });
        instance.formula.func_selectedrange = {
            left: col_pre,
            width: col - col_pre - 1,
            top: row_pre,
            height: row - row_pre - 1,
            left_move: col_pre,
            width_move: col - col_pre - 1,
            top_move: row_pre,
            height_move: row - row_pre - 1,
            row: [row_index, row_index],
            column: [col_index, col_index],
        };

        currentInstance.find("#luckysheet-formula-functionrange-select")
            .css({ left: col_pre, width: col - col_pre - 1, top: row_pre, height: row - row_pre - 1 })
            .show();

        currentInstance.find("#luckysheet-formula-help-c").hide();
    },
    backFormulaInput: function (d, r, c, rowh, columnh, formula, container) {
        let _this = this;
        const instance = this.instance;
        const containerId = instance.getInstanceId();
        let Store = instance.getStore();

        let f =
            "=" +
            formula.toUpperCase() +
            "(" +
            instance.get.getRangetxt(Store.currentSheetIndex, { row: rowh, column: columnh }, Store.currentSheetIndex) +
            ")";
        let v = instance.formula.execfunction(f, r, c);
        let value = { v: v[1], f: v[2] };
        instance.setdata.setcellvalue(r, c, d, value);
        instance.formula.execFunctionExist.push({ r: r, c: c, i: Store.currentSheetIndex });

        instance.server.historyParam(d, Store.currentSheetIndex, { row: [r, r], column: [c, c] });
    },
    checkNoNullValue: function (cell) {
        let v = cell;
        if (getObjType(v) == "object") {
            v = v.v;
        }

        if (
            !isRealNull(v) &&
            isdatatypemulti(v).num &&
            (cell.ct == null || cell.ct.t == null || cell.ct.t == "n" || cell.ct.t == "g")
        ) {
            return true;
        } else {
            return false;
        }
    },
    checkNoNullValueAll: function (cell) {
        let v = cell;
        if (getObjType(v) == "object") {
            v = v.v;
        }

        if (!isRealNull(v)) {
            return true;
        } else {
            return false;
        }
    },
    getNoNullValue: function (d, st_x, ed, type) {
        let _this = this;
        let hasValueSum = 0,
            hasValueStart = null;
        let nullNum = 0,
            nullTime = 0;

        for (let r = ed - 1; r >= 0; r--) {
            let cell;
            if (type == "c") {
                cell = d[st_x][r];
            } else {
                cell = d[r][st_x];
            }

            if (_this.checkNoNullValue(cell)) {
                hasValueSum++;
                hasValueStart = r;
            } else if (cell == null || cell.v == null || cell.v == "") {
                nullNum++;

                if (nullNum >= 40) {
                    if (nullTime <= 0) {
                        nullTime = 1;
                    } else {
                        break;
                    }
                }
            } else {
                break;
            }
        }

        return hasValueStart;
    },
    singleFormulaInput: function (d, _index, fix, st_m, ed_m, formula, type, noNum, noNull) {
        let _this = this;

        if (type == null) {
            type = "r";
        }

        if (noNum == null) {
            noNum = true;
        }

        if (noNull == null) {
            noNull = true;
        }

        let isNull = true,
            isNum = false;

        for (let c = st_m; c <= ed_m; c++) {
            let cell = null;

            if (type == "c") {
                cell = d[c][fix];
            } else {
                cell = d[fix][c];
            }

            if (_this.checkNoNullValue(cell)) {
                isNull = false;
                isNum = true;
            } else if (_this.checkNoNullValueAll(cell)) {
                isNull = false;
            }
        }

        if (isNull && noNull) {
            let st_r_r = _this.getNoNullValue(d, _index, fix, type);

            if (st_r_r == null) {
                if (type == "c") {
                    _this.activeFormulaInput(_index, fix, null, null, formula, true);
                } else {
                    _this.activeFormulaInput(fix, _index, null, null, formula, true);
                }
            } else {
                if (_index == st_m) {
                    for (let c = st_m; c <= ed_m; c++) {
                        let st_r_r = _this.getNoNullValue(d, c, fix, type);

                        if (st_r_r == null) {
                            break;
                        }

                        if (type == "c") {
                            _this.backFormulaInput(d, c, fix, [c, c], [st_r_r, fix - 1], formula);
                        } else {
                            _this.backFormulaInput(d, fix, c, [st_r_r, fix - 1], [c, c], formula);
                        }
                    }
                } else {
                    for (let c = ed_m; c >= st_m; c--) {
                        let st_r_r = _this.getNoNullValue(d, c, fix, type);

                        if (st_r_r == null) {
                            break;
                        }

                        if (type == "c") {
                            _this.backFormulaInput(d, c, fix, [c, c], [st_r_r, fix - 1], formula);
                        } else {
                            _this.backFormulaInput(d, fix, c, [st_r_r, fix - 1], [c, c], formula);
                        }
                    }
                }
            }
        } else if (isNum && noNum) {
            let cell = null;

            if (type == "c") {
                cell = d[ed_m + 1][fix];
            } else {
                cell = d[fix][ed_m + 1];
            }

            /* 备注：在搜寻的时候排除自己以解决单元格函数引用自己的问题 */
            if (cell != null && cell.v != null && cell.v.toString().length > 0) {
                let c = ed_m + 1;

                if (type == "c") {
                    cell = d[ed_m + 1][fix];
                } else {
                    cell = d[fix][ed_m + 1];
                }

                while (cell != null && cell.v != null && cell.v.toString().length > 0) {
                    c++;
                    let len = null;

                    if (type == "c") {
                        len = d.length;
                    } else {
                        len = d[0].length;
                    }

                    if (c >= len) {
                        return;
                    }

                    if (type == "c") {
                        cell = d[c][fix];
                    } else {
                        cell = d[fix][c];
                    }
                }

                if (type == "c") {
                    _this.backFormulaInput(d, c, fix, [st_m, ed_m], [fix, fix], formula);
                } else {
                    _this.backFormulaInput(d, fix, c, [fix, fix], [st_m, ed_m], formula);
                }
            } else {
                if (type == "c") {
                    _this.backFormulaInput(d, ed_m + 1, fix, [st_m, ed_m], [fix, fix], formula);
                } else {
                    _this.backFormulaInput(d, fix, ed_m + 1, [fix, fix], [st_m, ed_m], formula);
                }
            }
        } else {
            return true;
        }
    },
    autoSelectionFormula: function (containerId, formula) {
        const instance = this.instance;
	    let Store = instance.getStore();
        let _this = this;
        let d = instance.editor.deepCopyFlowData(Store.flowdata);
        let nullfindnum = 40;
        let isfalse = true;
        instance.formula.execFunctionExist = [];

        let execFormulaInput_c = function (d, st_r, ed_r, st_c, ed_c, formula) {
            let st_c_c = _this.getNoNullValue(d, st_r, ed_c, "c");

            if (st_c_c == null) {
                _this.activeFormulaInput(st_r, st_c, null, null, formula, true);
            } else {
                _this.activeFormulaInput(st_r, st_c, [st_r, ed_r], [st_c_c, ed_c - 1], formula);
            }
        };

        let execFormulaInput = function (d, st_r, ed_r, st_c, ed_c, formula) {
            let st_r_c = _this.getNoNullValue(d, st_c, ed_r, "r");

            if (st_r_c == null) {
                execFormulaInput_c(d, st_r, ed_r, st_c, ed_c, formula);
            } else {
                _this.activeFormulaInput(st_r, st_c, [st_r_c, ed_r - 1], [st_c, ed_c], formula);
            }
        };

        for (let s = 0; s < Store.luckysheet_select_save.length; s++) {
            let st_r = Store.luckysheet_select_save[s].row[0],
                ed_r = Store.luckysheet_select_save[s].row[1];
            let st_c = Store.luckysheet_select_save[s].column[0],
                ed_c = Store.luckysheet_select_save[s].column[1];
            let row_index = Store.luckysheet_select_save[s].row_focus,
                col_index = Store.luckysheet_select_save[s].column_focus;

            if (st_r == ed_r && st_c == ed_c) {
                if (ed_r - 1 < 0 && ed_c - 1 < 0) {
                    _this.activeFormulaInput(st_r, st_c, null, null, formula, true);
                    return;
                }

                if (ed_r - 1 >= 0 && _this.checkNoNullValue(d[ed_r - 1][st_c])) {
                    execFormulaInput(d, st_r, ed_r, st_c, ed_c, formula);
                } else if (ed_c - 1 >= 0 && _this.checkNoNullValue(d[st_r][ed_c - 1])) {
                    execFormulaInput_c(d, st_r, ed_r, st_c, ed_c, formula);
                } else {
                    execFormulaInput(d, st_r, ed_r, st_c, ed_c, formula);
                }
            } else if (st_r == ed_r) {
                isfalse = _this.singleFormulaInput(d, col_index, st_r, st_c, ed_c, formula, "r");
            } else if (st_c == ed_c) {
                isfalse = _this.singleFormulaInput(d, row_index, st_c, st_r, ed_r, formula, "c");
            } else {
                let r_false = true;
                for (let r = st_r; r <= ed_r; r++) {
                    r_false =
                        _this.singleFormulaInput(d, col_index, r, st_c, ed_c, formula, "r", true, false) && r_false;
                }

                let c_false = true;
                for (let c = st_c; c <= ed_c; c++) {
                    c_false =
                        _this.singleFormulaInput(d, row_index, c, st_r, ed_r, formula, "c", true, false) && c_false;
                }

                isfalse = !!r_false && !!c_false;
            }

            isfalse = isfalse && isfalse;
        }

        if (!isfalse) {
            instance.formula.execFunctionExist.reverse();
            instance.formula.execFunctionGroup(null, null, null, null, d);
            instance.refresh.jfrefreshgrid(d, Store.luckysheet_select_save);

            clearTimeout(Store.jfcountfuncTimeout);
            Store.jfcountfuncTimeout = setTimeout(function () {
                instance.count.countfunc();
            }, 500);
        }
    },
    getStyleByCell: function (d, r, c) {
        let _this = this;
        const instance = this.instance;
        let style = "";

        //交替颜色
        let af_compute = instance.alternateformat.getComputeMap();
        let checksAF = instance.alternateformat.checksAF(r, c, af_compute);

        //条件格式
        let cf_compute = instance.conditionformat.getComputeMap();
        let checksCF = instance.conditionformat.checksCF(r, c, cf_compute);

        const locale_fontarray = instance.locale().fontarray;

        let cell = d[r][c];
        let ct = cell.ct,
            isInline = false;
        if (isInlineStringCell(cell)) {
            isInline = true;
        }
        for (let key in cell) {
            let value = _this.checkstatus(d, r, c, key);

            if (checksAF != null || (checksCF != null && checksCF["cellColor"] != null)) {
                if (checksCF != null && checksCF["cellColor"] != null) {
                    style += "background: " + checksCF["cellColor"] + ";";
                } else if (checksAF != null) {
                    style += "background: " + checksAF[1] + ";";
                }
            }

            if (getObjType(value) == "object") {
                continue;
            }

            if (key == "bg" || checksAF != null || (checksCF != null && checksCF["cellColor"] != null)) {
                if (checksCF != null && checksCF["cellColor"] != null) {
                    style += "background: " + checksCF["cellColor"] + ";";
                } else if (checksAF != null) {
                    style += "background: " + checksAF[1] + ";";
                } else {
                    style += "background: " + value + ";";
                }
            }

            // if(!isInline){
            //     if(key == "bl" && value != "0"){
            //         style += "font-weight: bold;";
            //     }

            //     if(key == "it" && value != "0"){
            //         style += "font-style:italic;";
            //     }

            //     if(key == "ff" && value != "0"){
            //         let f = value;
            //         if(!isNaN(parseInt(value))){
            //             f = locale_fontarray[parseInt(value)];
            //         }
            //         style += "font-family: " + f + ";";
            //     }

            //     if(key == "fs" && value != "10"){
            //         style += "font-size: "+ value + "pt;";
            //     }

            //     if((key == "fc" && value != "#000000") || checksAF != null || (checksCF != null && checksCF["textColor"] != null)){
            //         if(checksCF != null && checksCF["textColor"] != null){
            //             style += "color: " + checksCF["textColor"] + ";";
            //         }
            //         else if(checksAF != null){
            //             style += "color: " + checksAF[0] + ";";
            //         }
            //         else{
            //             style += "color: " + value + ";";
            //         }
            //     }
            // }

            if (key == "ht" && value != "1") {
                if (value == "0") {
                    style += "text-align: center;";
                } else if (value == "2") {
                    style += "text-align: right;";
                }
            }

            if (key == "vt") {
                if (value == "0") {
                    style += "vertical-align: middle;";
                } else if (value == "1") {
                    style += "vertical-align: top;";
                } else if (value == "2") {
                    style += "vertical-align: bottom;";
                }
            }

            if (key == "un" && value) {
                style += "text-decoration:underline;";
            }
        }

        if (!isInline) {
            style += instance.getdata.getFontStyleByCell(cell, checksAF, checksCF);
        }

        return style;
    },
    fontSelectList: [],
    defualtFont: [
        "Times New Roman",
        "Arial",
        "Tahoma",
        "Verdana",
        "微软雅黑",
        "宋体",
        "黑体",
        "楷体",
        "仿宋",
        "新宋体",
        "华文新魏",
        "华文行楷",
        "华文隶书",
    ],
    addFontTolist: function (fontName, container) {
        const instance = this.instance;
        fontName = fontName.replace(/"/g, "").replace(/'/g, "");
        let isNone = true;
        let containerId = container || instance.getInstanceId();
        let currentInstance = $(`#${containerId}`);
        let Store = instance.getStore();
        for (let a = 0; a < this.fontSelectList.length; a++) {
            let fItem = this.fontSelectList[a];
            if (fItem.value == fontName) {
                isNone = false;
                break;
            }
        }

        let _locale = instance.locale();
        const locale_fontjson = _locale.fontjson;
        if (fontName in locale_fontjson) {
            isNone = false;
        }

        if (isNone) {
            let ret = {};
            ret.value = fontName;
            ret.index = this.fontSelectList.length;
            ret.type = "userDefined";
            ret.text =
                "<span class='luckysheet-mousedown-cancel' style='font-size:11px;font-family:" +
                fontName +
                "'>" +
                fontName +
                "</span>";
            ret.example = "";
            this.fontSelectList.push(ret);

            let $menuButton = currentInstance.find(`#luckysheet-icon-font-family-menuButton`);
            let itemset = this.createButtonMenu(this.fontSelectList);
            $menuButton.html(itemset);
        }
    },
    fontInitial: function (fontList) {
        const instance = this.instance;
        let itemdata = [];
        const locale_fontarray = instance.locale().fontarray;
        for (let a = 0; a < locale_fontarray.length; a++) {
            let fItem = locale_fontarray[a];
            let ret = {};
            ret.value = fItem;
            ret.index = a;
            ret.type = "inner";
            ret.text =
                "<span class='luckysheet-mousedown-cancel' style='font-size:11px;font-family:" +
                fItem +
                "'>" +
                fItem +
                "</span>";
            ret.example = "";
            itemdata.push(ret);
        }

        if (fontList != null) {
            for (let a = 0; a < fontList.length; a++) {
                let fItem = fontList[a];
                let ret = {};
                ret.value = fItem.fontName;
                ret.index = a;
                ret.type = "userDefined";
                ret.text =
                    "<span class='luckysheet-mousedown-cancel' style='font-size:11px;font-family:" +
                    fItem.fontName +
                    "'>" +
                    fItem.fontName +
                    "</span>";
                ret.example = "";
                itemdata.push(ret);

                if (document.fonts && !document.fonts.check("12px " + fItem.fontName)) {
                    if (fItem.url) {
                        const fontface = new FontFace(fItem.fontName, `url(${fItem.url})`);
                        document.fonts.add(fontface);
                        fontface.load();
                    }
                }
            }

            document.fonts &&
                document.fonts.ready.then(function () {
                    // Any operation that needs to be done only after all the fonts
                    // have finished loading can go here.
                    // console.log("font ready");
                });
        }

        this.fontSelectList = itemdata;
    },

    // 实例内初始化IC50Ec50等生物计算方法
    initFormulaButton(){
        let _this = this;
        const instance = _this.instance;
        _this.sequenceImportDialog = {
            ...sequenceImportDialog,
            instance,
        }; // 序列操作相关处理
        _this.calculateORFDialog = {
            ...calculateORFDialog,
            instance,
        };
        _this.dnaAnalysisUtils = {
            ...dnaAnalysisUtils,
            instance,
        }; 
        _this.sequenceLookup = {
            ...sequenceLookup,
            instance,
        }; // 序列查找操作相关处理
        _this.crisprDesign = {
            ...crisprDesign,
            instance,
        }; // CRISPR设计操作相关处理
        _this.primerDesign = {
            ...primerDesign,
            instance,
        }; // 引物设计操作相关处理
        _this.proteinAnalysis = {
            ...proteinAnalysis,
            instance,
        }; // 蛋白质分析操作相关处理
    }
};

export default menuButton;
